webpackJsonp([83281933695004],{

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 *  howler.js v2.0.10
	 *  howlerjs.com
	 *
	 *  (c) 2013-2018, James Simpson of GoldFire Studios
	 *  goldfirestudios.com
	 *
	 *  MIT License
	 */
	
	(function() {
	
	  'use strict';
	
	  /** Global Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create the global controller. All contained methods and properties apply
	   * to all sounds that are currently playing or will be in the future.
	   */
	  var HowlerGlobal = function() {
	    this.init();
	  };
	  HowlerGlobal.prototype = {
	    /**
	     * Initialize the global Howler object.
	     * @return {Howler}
	     */
	    init: function() {
	      var self = this || Howler;
	
	      // Create a global ID counter.
	      self._counter = 1000;
	
	      // Internal properties.
	      self._codecs = {};
	      self._howls = [];
	      self._muted = false;
	      self._volume = 1;
	      self._canPlayEvent = 'canplaythrough';
	      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;
	
	      // Public properties.
	      self.masterGain = null;
	      self.noAudio = false;
	      self.usingWebAudio = true;
	      self.autoSuspend = true;
	      self.ctx = null;
	
	      // Set to false to disable the auto iOS enabler.
	      self.mobileAutoEnable = true;
	
	      // Setup the various state values for global tracking.
	      self._setup();
	
	      return self;
	    },
	
	    /**
	     * Get/set the global volume for all sounds.
	     * @param  {Float} vol Volume from 0.0 to 1.0.
	     * @return {Howler/Float}     Returns self or current volume.
	     */
	    volume: function(vol) {
	      var self = this || Howler;
	      vol = parseFloat(vol);
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!self.ctx) {
	        setupAudioContext();
	      }
	
	      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
	        self._volume = vol;
	
	        // Don't update any of the nodes if we are muted.
	        if (self._muted) {
	          return self;
	        }
	
	        // When using Web Audio, we just need to adjust the master gain.
	        if (self.usingWebAudio) {
	          self.masterGain.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	        }
	
	        // Loop through and change volume for all HTML5 audio nodes.
	        for (var i=0; i<self._howls.length; i++) {
	          if (!self._howls[i]._webAudio) {
	            // Get all of the sounds in this Howl group.
	            var ids = self._howls[i]._getSoundIds();
	
	            // Loop through all sounds and change the volumes.
	            for (var j=0; j<ids.length; j++) {
	              var sound = self._howls[i]._soundById(ids[j]);
	
	              if (sound && sound._node) {
	                sound._node.volume = sound._volume * vol;
	              }
	            }
	          }
	        }
	
	        return self;
	      }
	
	      return self._volume;
	    },
	
	    /**
	     * Handle muting and unmuting globally.
	     * @param  {Boolean} muted Is muted or not.
	     */
	    mute: function(muted) {
	      var self = this || Howler;
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!self.ctx) {
	        setupAudioContext();
	      }
	
	      self._muted = muted;
	
	      // With Web Audio, we just need to mute the master gain.
	      if (self.usingWebAudio) {
	        self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler.ctx.currentTime);
	      }
	
	      // Loop through and mute all HTML5 Audio nodes.
	      for (var i=0; i<self._howls.length; i++) {
	        if (!self._howls[i]._webAudio) {
	          // Get all of the sounds in this Howl group.
	          var ids = self._howls[i]._getSoundIds();
	
	          // Loop through all sounds and mark the audio node as muted.
	          for (var j=0; j<ids.length; j++) {
	            var sound = self._howls[i]._soundById(ids[j]);
	
	            if (sound && sound._node) {
	              sound._node.muted = (muted) ? true : sound._muted;
	            }
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Unload and destroy all currently loaded Howl objects.
	     * @return {Howler}
	     */
	    unload: function() {
	      var self = this || Howler;
	
	      for (var i=self._howls.length-1; i>=0; i--) {
	        self._howls[i].unload();
	      }
	
	      // Create a new AudioContext to make sure it is fully reset.
	      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
	        self.ctx.close();
	        self.ctx = null;
	        setupAudioContext();
	      }
	
	      return self;
	    },
	
	    /**
	     * Check for codec support of specific extension.
	     * @param  {String} ext Audio file extention.
	     * @return {Boolean}
	     */
	    codecs: function(ext) {
	      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
	    },
	
	    /**
	     * Setup various state values for global tracking.
	     * @return {Howler}
	     */
	    _setup: function() {
	      var self = this || Howler;
	
	      // Keeps track of the suspend/resume state of the AudioContext.
	      self.state = self.ctx ? self.ctx.state || 'running' : 'running';
	
	      // Automatically begin the 30-second suspend process
	      self._autoSuspend();
	
	      // Check if audio is available.
	      if (!self.usingWebAudio) {
	        // No audio is available on this system if noAudio is set to true.
	        if (typeof Audio !== 'undefined') {
	          try {
	            var test = new Audio();
	
	            // Check if the canplaythrough event is available.
	            if (typeof test.oncanplaythrough === 'undefined') {
	              self._canPlayEvent = 'canplay';
	            }
	          } catch(e) {
	            self.noAudio = true;
	          }
	        } else {
	          self.noAudio = true;
	        }
	      }
	
	      // Test to make sure audio isn't disabled in Internet Explorer.
	      try {
	        var test = new Audio();
	        if (test.muted) {
	          self.noAudio = true;
	        }
	      } catch (e) {}
	
	      // Check for supported codecs.
	      if (!self.noAudio) {
	        self._setupCodecs();
	      }
	
	      return self;
	    },
	
	    /**
	     * Check for browser support for various codecs and cache the results.
	     * @return {Howler}
	     */
	    _setupCodecs: function() {
	      var self = this || Howler;
	      var audioTest = null;
	
	      // Must wrap in a try/catch because IE11 in server mode throws an error.
	      try {
	        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
	      } catch (err) {
	        return self;
	      }
	
	      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
	        return self;
	      }
	
	      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
	
	      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
	      var checkOpera = self._navigator && self._navigator.userAgent.match(/OPR\/([0-6].)/g);
	      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);
	
	      self._codecs = {
	        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
	        mpeg: !!mpegTest,
	        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
	        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
	        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
	        wav: !!audioTest.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''),
	        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
	        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
	        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
	        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
	        weba: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
	        webm: !!audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''),
	        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
	        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
	      };
	
	      return self;
	    },
	
	    /**
	     * Mobile browsers will only allow audio to be played after a user interaction.
	     * Attempt to automatically unlock audio on the first user interaction.
	     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
	     * @return {Howler}
	     */
	    _enableMobileAudio: function() {
	      var self = this || Howler;
	
	      // Only run this on mobile devices if audio isn't already eanbled.
	      var isMobile = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk|Mobi/i.test(self._navigator && self._navigator.userAgent);
	      var isTouch = !!(('ontouchend' in window) || (self._navigator && self._navigator.maxTouchPoints > 0) || (self._navigator && self._navigator.msMaxTouchPoints > 0));
	      if (self._mobileEnabled || !self.ctx || (!isMobile && !isTouch)) {
	        return;
	      }
	
	      self._mobileEnabled = false;
	
	      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
	      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
	      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
	      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
	        self._mobileUnloaded = true;
	        self.unload();
	      }
	
	      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
	      // http://stackoverflow.com/questions/24119684
	      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
	
	      // Call this method on touch start to create and play a buffer,
	      // then check if the audio actually played to determine if
	      // audio has now been unlocked on iOS, Android, etc.
	      var unlock = function() {
	        // Fix Android can not play in suspend state.
	        Howler._autoResume();
	
	        // Create an empty buffer.
	        var source = self.ctx.createBufferSource();
	        source.buffer = self._scratchBuffer;
	        source.connect(self.ctx.destination);
	
	        // Play the empty buffer.
	        if (typeof source.start === 'undefined') {
	          source.noteOn(0);
	        } else {
	          source.start(0);
	        }
	
	        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
	        if (typeof self.ctx.resume === 'function') {
	          self.ctx.resume();
	        }
	
	        // Setup a timeout to check that we are unlocked on the next event loop.
	        source.onended = function() {
	          source.disconnect(0);
	
	          // Update the unlocked state and prevent this check from happening again.
	          self._mobileEnabled = true;
	          self.mobileAutoEnable = false;
	
	          // Remove the touch start listener.
	          document.removeEventListener('touchstart', unlock, true);
	          document.removeEventListener('touchend', unlock, true);
	        };
	      };
	
	      // Setup a touch start listener to attempt an unlock in.
	      document.addEventListener('touchstart', unlock, true);
	      document.addEventListener('touchend', unlock, true);
	
	      return self;
	    },
	
	    /**
	     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
	     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
	     * @return {Howler}
	     */
	    _autoSuspend: function() {
	      var self = this;
	
	      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
	        return;
	      }
	
	      // Check if any sounds are playing.
	      for (var i=0; i<self._howls.length; i++) {
	        if (self._howls[i]._webAudio) {
	          for (var j=0; j<self._howls[i]._sounds.length; j++) {
	            if (!self._howls[i]._sounds[j]._paused) {
	              return self;
	            }
	          }
	        }
	      }
	
	      if (self._suspendTimer) {
	        clearTimeout(self._suspendTimer);
	      }
	
	      // If no sound has played after 30 seconds, suspend the context.
	      self._suspendTimer = setTimeout(function() {
	        if (!self.autoSuspend) {
	          return;
	        }
	
	        self._suspendTimer = null;
	        self.state = 'suspending';
	        self.ctx.suspend().then(function() {
	          self.state = 'suspended';
	
	          if (self._resumeAfterSuspend) {
	            delete self._resumeAfterSuspend;
	            self._autoResume();
	          }
	        });
	      }, 30000);
	
	      return self;
	    },
	
	    /**
	     * Automatically resume the Web Audio AudioContext when a new sound is played.
	     * @return {Howler}
	     */
	    _autoResume: function() {
	      var self = this;
	
	      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
	        return;
	      }
	
	      if (self.state === 'running' && self._suspendTimer) {
	        clearTimeout(self._suspendTimer);
	        self._suspendTimer = null;
	      } else if (self.state === 'suspended') {
	        self.ctx.resume().then(function() {
	          self.state = 'running';
	
	          // Emit to all Howls that the audio has resumed.
	          for (var i=0; i<self._howls.length; i++) {
	            self._howls[i]._emit('resume');
	          }
	        });
	
	        if (self._suspendTimer) {
	          clearTimeout(self._suspendTimer);
	          self._suspendTimer = null;
	        }
	      } else if (self.state === 'suspending') {
	        self._resumeAfterSuspend = true;
	      }
	
	      return self;
	    }
	  };
	
	  // Setup the global audio controller.
	  var Howler = new HowlerGlobal();
	
	  /** Group Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create an audio group controller.
	   * @param {Object} o Passed in properties for this group.
	   */
	  var Howl = function(o) {
	    var self = this;
	
	    // Throw an error if no source is provided.
	    if (!o.src || o.src.length === 0) {
	      console.error('An array of source files must be passed with any new Howl.');
	      return;
	    }
	
	    self.init(o);
	  };
	  Howl.prototype = {
	    /**
	     * Initialize a new Howl group object.
	     * @param  {Object} o Passed in properties for this group.
	     * @return {Howl}
	     */
	    init: function(o) {
	      var self = this;
	
	      // If we don't have an AudioContext created yet, run the setup.
	      if (!Howler.ctx) {
	        setupAudioContext();
	      }
	
	      // Setup user-defined default properties.
	      self._autoplay = o.autoplay || false;
	      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
	      self._html5 = o.html5 || false;
	      self._muted = o.mute || false;
	      self._loop = o.loop || false;
	      self._pool = o.pool || 5;
	      self._preload = (typeof o.preload === 'boolean') ? o.preload : true;
	      self._rate = o.rate || 1;
	      self._sprite = o.sprite || {};
	      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
	      self._volume = o.volume !== undefined ? o.volume : 1;
	      self._xhrWithCredentials = o.xhrWithCredentials || false;
	
	      // Setup all other default properties.
	      self._duration = 0;
	      self._state = 'unloaded';
	      self._sounds = [];
	      self._endTimers = {};
	      self._queue = [];
	      self._playLock = false;
	
	      // Setup event listeners.
	      self._onend = o.onend ? [{fn: o.onend}] : [];
	      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
	      self._onload = o.onload ? [{fn: o.onload}] : [];
	      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
	      self._onplayerror = o.onplayerror ? [{fn: o.onplayerror}] : [];
	      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
	      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
	      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
	      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
	      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
	      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
	      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
	      self._onresume = [];
	
	      // Web Audio or HTML5 Audio?
	      self._webAudio = Howler.usingWebAudio && !self._html5;
	
	      // Automatically try to enable audio on iOS.
	      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.mobileAutoEnable) {
	        Howler._enableMobileAudio();
	      }
	
	      // Keep track of this Howl group in the global controller.
	      Howler._howls.push(self);
	
	      // If they selected autoplay, add a play event to the load queue.
	      if (self._autoplay) {
	        self._queue.push({
	          event: 'play',
	          action: function() {
	            self.play();
	          }
	        });
	      }
	
	      // Load the source file unless otherwise specified.
	      if (self._preload) {
	        self.load();
	      }
	
	      return self;
	    },
	
	    /**
	     * Load the audio file.
	     * @return {Howler}
	     */
	    load: function() {
	      var self = this;
	      var url = null;
	
	      // If no audio is available, quit immediately.
	      if (Howler.noAudio) {
	        self._emit('loaderror', null, 'No audio support.');
	        return;
	      }
	
	      // Make sure our source is in an array.
	      if (typeof self._src === 'string') {
	        self._src = [self._src];
	      }
	
	      // Loop through the sources and pick the first one that is compatible.
	      for (var i=0; i<self._src.length; i++) {
	        var ext, str;
	
	        if (self._format && self._format[i]) {
	          // If an extension was specified, use that instead.
	          ext = self._format[i];
	        } else {
	          // Make sure the source is a string.
	          str = self._src[i];
	          if (typeof str !== 'string') {
	            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
	            continue;
	          }
	
	          // Extract the file extension from the URL or base64 data URI.
	          ext = /^data:audio\/([^;,]+);/i.exec(str);
	          if (!ext) {
	            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
	          }
	
	          if (ext) {
	            ext = ext[1].toLowerCase();
	          }
	        }
	
	        // Log a warning if no extension was found.
	        if (!ext) {
	          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
	        }
	
	        // Check if this extension is available.
	        if (ext && Howler.codecs(ext)) {
	          url = self._src[i];
	          break;
	        }
	      }
	
	      if (!url) {
	        self._emit('loaderror', null, 'No codec support for selected audio sources.');
	        return;
	      }
	
	      self._src = url;
	      self._state = 'loading';
	
	      // If the hosting page is HTTPS and the source isn't,
	      // drop down to HTML5 Audio to avoid Mixed Content errors.
	      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
	        self._html5 = true;
	        self._webAudio = false;
	      }
	
	      // Create a new sound object and add it to the pool.
	      new Sound(self);
	
	      // Load and decode the audio data for playback.
	      if (self._webAudio) {
	        loadBuffer(self);
	      }
	
	      return self;
	    },
	
	    /**
	     * Play a sound or resume previous playback.
	     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
	     * @param  {Boolean} internal Internal Use: true prevents event firing.
	     * @return {Number}          Sound ID.
	     */
	    play: function(sprite, internal) {
	      var self = this;
	      var id = null;
	
	      // Determine if a sprite, sound id or nothing was passed
	      if (typeof sprite === 'number') {
	        id = sprite;
	        sprite = null;
	      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
	        // If the passed sprite doesn't exist, do nothing.
	        return null;
	      } else if (typeof sprite === 'undefined') {
	        // Use the default sound sprite (plays the full audio length).
	        sprite = '__default';
	
	        // Check if there is a single paused sound that isn't ended.
	        // If there is, play that sound. If not, continue as usual.
	        var num = 0;
	        for (var i=0; i<self._sounds.length; i++) {
	          if (self._sounds[i]._paused && !self._sounds[i]._ended) {
	            num++;
	            id = self._sounds[i]._id;
	          }
	        }
	
	        if (num === 1) {
	          sprite = null;
	        } else {
	          id = null;
	        }
	      }
	
	      // Get the selected node, or get one from the pool.
	      var sound = id ? self._soundById(id) : self._inactiveSound();
	
	      // If the sound doesn't exist, do nothing.
	      if (!sound) {
	        return null;
	      }
	
	      // Select the sprite definition.
	      if (id && !sprite) {
	        sprite = sound._sprite || '__default';
	      }
	
	      // If the sound hasn't loaded, we must wait to get the audio's duration.
	      // We also need to wait to make sure we don't run into race conditions with
	      // the order of function calls.
	      if (self._state !== 'loaded') {
	        // Set the sprite value on this sound.
	        sound._sprite = sprite;
	
	        // Makr this sounded as not ended in case another sound is played before this one loads.
	        sound._ended = false;
	
	        // Add the sound to the queue to be played on load.
	        var soundId = sound._id;
	        self._queue.push({
	          event: 'play',
	          action: function() {
	            self.play(soundId);
	          }
	        });
	
	        return soundId;
	      }
	
	      // Don't play the sound if an id was passed and it is already playing.
	      if (id && !sound._paused) {
	        // Trigger the play event, in order to keep iterating through queue.
	        if (!internal) {
	          self._loadQueue('play');
	        }
	
	        return sound._id;
	      }
	
	      // Make sure the AudioContext isn't suspended, and resume it if it is.
	      if (self._webAudio) {
	        Howler._autoResume();
	      }
	
	      // Determine how long to play for and where to start playing.
	      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
	      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
	      var timeout = (duration * 1000) / Math.abs(sound._rate);
	
	      // Update the parameters of the sound
	      sound._paused = false;
	      sound._ended = false;
	      sound._sprite = sprite;
	      sound._seek = seek;
	      sound._start = self._sprite[sprite][0] / 1000;
	      sound._stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
	      sound._loop = !!(sound._loop || self._sprite[sprite][2]);
	
	      // Begin the actual playback.
	      var node = sound._node;
	      if (self._webAudio) {
	        // Fire this when the sound is ready to play to begin Web Audio playback.
	        var playWebAudio = function() {
	          self._refreshBuffer(sound);
	
	          // Setup the playback params.
	          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
	          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	          sound._playStart = Howler.ctx.currentTime;
	
	          // Play the sound using the supported method.
	          if (typeof node.bufferSource.start === 'undefined') {
	            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
	          } else {
	            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
	          }
	
	          // Start a new timer if none is present.
	          if (timeout !== Infinity) {
	            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	          }
	
	          if (!internal) {
	            setTimeout(function() {
	              self._emit('play', sound._id);
	            }, 0);
	          }
	        };
	
	        if (Howler.state === 'running') {
	          playWebAudio();
	        } else {
	          self.once('resume', playWebAudio);
	
	          // Cancel the end timer.
	          self._clearTimer(sound._id);
	        }
	      } else {
	        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
	        var playHtml5 = function() {
	          node.currentTime = seek;
	          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
	          node.volume = sound._volume * Howler.volume();
	          node.playbackRate = sound._rate;
	
	          // Mobile browsers will throw an error if this is called without user interaction.
	          try {
	            var play = node.play();
	
	            // Support older browsers that don't support promises, and thus don't have this issue.
	            if (typeof Promise !== 'undefined' && play instanceof Promise) {
	              // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
	              self._playLock = true;
	
	              // Releases the lock and executes queued actions.
	              var runLoadQueue = function() {
	                self._playLock = false;
	                if (!internal) {
	                  self._emit('play', sound._id);
	                }
	              };
	              play.then(runLoadQueue, runLoadQueue);
	            } else if (!internal) {
	              self._emit('play', sound._id);
	            }
	
	            // Setting rate before playing won't work in IE, so we set it again here.
	            node.playbackRate = sound._rate;
	
	            // If the node is still paused, then we can assume there was a playback issue.
	            if (node.paused) {
	              self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
	                'on mobile devices where playback was not within a user interaction.');
	              return;
	            }
	
	            // Setup the end timer on sprites or listen for the ended event.
	            if (sprite !== '__default' || sound._loop) {
	              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	            } else {
	              self._endTimers[sound._id] = function() {
	                // Fire ended on this audio node.
	                self._ended(sound);
	
	                // Clear this listener.
	                node.removeEventListener('ended', self._endTimers[sound._id], false);
	              };
	              node.addEventListener('ended', self._endTimers[sound._id], false);
	            }
	          } catch (err) {
	            self._emit('playerror', sound._id, err);
	          }
	        };
	
	        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
	        var loadedNoReadyState = (window && window.ejecta) || (!node.readyState && Howler._navigator.isCocoonJS);
	        if (node.readyState >= 3 || loadedNoReadyState) {
	          playHtml5();
	        } else {
	          var listener = function() {
	            // Begin playback.
	            playHtml5();
	
	            // Clear this listener.
	            node.removeEventListener(Howler._canPlayEvent, listener, false);
	          };
	          node.addEventListener(Howler._canPlayEvent, listener, false);
	
	          // Cancel the end timer.
	          self._clearTimer(sound._id);
	        }
	      }
	
	      return sound._id;
	    },
	
	    /**
	     * Pause playback and save current position.
	     * @param  {Number} id The sound ID (empty to pause all in group).
	     * @return {Howl}
	     */
	    pause: function(id) {
	      var self = this;
	
	      // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
	      if (self._state !== 'loaded' || self._playLock) {
	        self._queue.push({
	          event: 'pause',
	          action: function() {
	            self.pause(id);
	          }
	        });
	
	        return self;
	      }
	
	      // If no id is passed, get all ID's to be paused.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Clear the end timer.
	        self._clearTimer(ids[i]);
	
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound && !sound._paused) {
	          // Reset the seek position.
	          sound._seek = self.seek(ids[i]);
	          sound._rateSeek = 0;
	          sound._paused = true;
	
	          // Stop currently running fades.
	          self._stopFade(ids[i]);
	
	          if (sound._node) {
	            if (self._webAudio) {
	              // Make sure the sound has been created.
	              if (!sound._node.bufferSource) {
	                continue;
	              }
	
	              if (typeof sound._node.bufferSource.stop === 'undefined') {
	                sound._node.bufferSource.noteOff(0);
	              } else {
	                sound._node.bufferSource.stop(0);
	              }
	
	              // Clean up the buffer source.
	              self._cleanBuffer(sound._node);
	            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
	              sound._node.pause();
	            }
	          }
	        }
	
	        // Fire the pause event, unless `true` is passed as the 2nd argument.
	        if (!arguments[1]) {
	          self._emit('pause', sound ? sound._id : null);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Stop playback and reset to start.
	     * @param  {Number} id The sound ID (empty to stop all in group).
	     * @param  {Boolean} internal Internal Use: true prevents event firing.
	     * @return {Howl}
	     */
	    stop: function(id, internal) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to stop when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'stop',
	          action: function() {
	            self.stop(id);
	          }
	        });
	
	        return self;
	      }
	
	      // If no id is passed, get all ID's to be stopped.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Clear the end timer.
	        self._clearTimer(ids[i]);
	
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound) {
	          // Reset the seek position.
	          sound._seek = sound._start || 0;
	          sound._rateSeek = 0;
	          sound._paused = true;
	          sound._ended = true;
	
	          // Stop currently running fades.
	          self._stopFade(ids[i]);
	
	          if (sound._node) {
	            if (self._webAudio) {
	              // Make sure the sound's AudioBufferSourceNode has been created.
	              if (sound._node.bufferSource) {
	                if (typeof sound._node.bufferSource.stop === 'undefined') {
	                  sound._node.bufferSource.noteOff(0);
	                } else {
	                  sound._node.bufferSource.stop(0);
	                }
	
	                // Clean up the buffer source.
	                self._cleanBuffer(sound._node);
	              }
	            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
	              sound._node.currentTime = sound._start || 0;
	              sound._node.pause();
	            }
	          }
	
	          if (!internal) {
	            self._emit('stop', sound._id);
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Mute/unmute a single sound or all sounds in this Howl group.
	     * @param  {Boolean} muted Set to true to mute and false to unmute.
	     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
	     * @return {Howl}
	     */
	    mute: function(muted, id) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to mute when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'mute',
	          action: function() {
	            self.mute(muted, id);
	          }
	        });
	
	        return self;
	      }
	
	      // If applying mute/unmute to all sounds, update the group's value.
	      if (typeof id === 'undefined') {
	        if (typeof muted === 'boolean') {
	          self._muted = muted;
	        } else {
	          return self._muted;
	        }
	      }
	
	      // If no id is passed, get all ID's to be muted.
	      var ids = self._getSoundIds(id);
	
	      for (var i=0; i<ids.length; i++) {
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        if (sound) {
	          sound._muted = muted;
	
	          // Cancel active fade and set the volume to the end value.
	          if (sound._interval) {
	            self._stopFade(sound._id);
	          }
	
	          if (self._webAudio && sound._node) {
	            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
	          } else if (sound._node) {
	            sound._node.muted = Howler._muted ? true : muted;
	          }
	
	          self._emit('mute', sound._id);
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
	     *   volume() -> Returns the group's volume value.
	     *   volume(id) -> Returns the sound id's current volume.
	     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
	     *   volume(vol, id) -> Sets the volume of passed sound id.
	     * @return {Howl/Number} Returns self or current volume.
	     */
	    volume: function() {
	      var self = this;
	      var args = arguments;
	      var vol, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // Return the value of the groups' volume.
	        return self._volume;
	      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
	        // First check if this is an ID, and if not, assume it is a new volume.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          vol = parseFloat(args[0]);
	        }
	      } else if (args.length >= 2) {
	        vol = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // Update the volume or return the current volume.
	      var sound;
	      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
	        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
	        if (self._state !== 'loaded') {
	          self._queue.push({
	            event: 'volume',
	            action: function() {
	              self.volume.apply(self, args);
	            }
	          });
	
	          return self;
	        }
	
	        // Set the group volume.
	        if (typeof id === 'undefined') {
	          self._volume = vol;
	        }
	
	        // Update one or all volumes.
	        id = self._getSoundIds(id);
	        for (var i=0; i<id.length; i++) {
	          // Get the sound.
	          sound = self._soundById(id[i]);
	
	          if (sound) {
	            sound._volume = vol;
	
	            // Stop currently running fades.
	            if (!args[2]) {
	              self._stopFade(id[i]);
	            }
	
	            if (self._webAudio && sound._node && !sound._muted) {
	              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
	            } else if (sound._node && !sound._muted) {
	              sound._node.volume = vol * Howler.volume();
	            }
	
	            self._emit('volume', sound._id);
	          }
	        }
	      } else {
	        sound = id ? self._soundById(id) : self._sounds[0];
	        return sound ? sound._volume : 0;
	      }
	
	      return self;
	    },
	
	    /**
	     * Fade a currently playing sound between two volumes (if no id is passsed, all sounds will fade).
	     * @param  {Number} from The value to fade from (0.0 to 1.0).
	     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
	     * @param  {Number} len  Time in milliseconds to fade.
	     * @param  {Number} id   The sound id (omit to fade all sounds).
	     * @return {Howl}
	     */
	    fade: function(from, to, len, id) {
	      var self = this;
	
	      // If the sound hasn't loaded, add it to the load queue to fade when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'fade',
	          action: function() {
	            self.fade(from, to, len, id);
	          }
	        });
	
	        return self;
	      }
	
	      // Set the volume to the start position.
	      self.volume(from, id);
	
	      // Fade the volume of one or all sounds.
	      var ids = self._getSoundIds(id);
	      for (var i=0; i<ids.length; i++) {
	        // Get the sound.
	        var sound = self._soundById(ids[i]);
	
	        // Create a linear fade or fall back to timeouts with HTML5 Audio.
	        if (sound) {
	          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
	          if (!id) {
	            self._stopFade(ids[i]);
	          }
	
	          // If we are using Web Audio, let the native methods do the actual fade.
	          if (self._webAudio && !sound._muted) {
	            var currentTime = Howler.ctx.currentTime;
	            var end = currentTime + (len / 1000);
	            sound._volume = from;
	            sound._node.gain.setValueAtTime(from, currentTime);
	            sound._node.gain.linearRampToValueAtTime(to, end);
	          }
	
	          self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Starts the internal interval to fade a sound.
	     * @param  {Object} sound Reference to sound to fade.
	     * @param  {Number} from The value to fade from (0.0 to 1.0).
	     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
	     * @param  {Number} len  Time in milliseconds to fade.
	     * @param  {Number} id   The sound id to fade.
	     * @param  {Boolean} isGroup   If true, set the volume on the group.
	     */
	    _startFadeInterval: function(sound, from, to, len, id, isGroup) {
	      var self = this;
	      var vol = from;
	      var diff = to - from;
	      var steps = Math.abs(diff / 0.01);
	      var stepLen = Math.max(4, (steps > 0) ? len / steps : len);
	      var lastTick = Date.now();
	
	      // Store the value being faded to.
	      sound._fadeTo = to;
	
	      // Update the volume value on each interval tick.
	      sound._interval = setInterval(function() {
	        // Update the volume based on the time since the last tick.
	        var tick = (Date.now() - lastTick) / len;
	        lastTick = Date.now();
	        vol += diff * tick;
	
	        // Make sure the volume is in the right bounds.
	        vol = Math.max(0, vol);
	        vol = Math.min(1, vol);
	
	        // Round to within 2 decimal points.
	        vol = Math.round(vol * 100) / 100;
	
	        // Change the volume.
	        if (self._webAudio) {
	          sound._volume = vol;
	        } else {
	          self.volume(vol, sound._id, true);
	        }
	
	        // Set the group's volume.
	        if (isGroup) {
	          self._volume = vol;
	        }
	
	        // When the fade is complete, stop it and fire event.
	        if ((to < from && vol <= to) || (to > from && vol >= to)) {
	          clearInterval(sound._interval);
	          sound._interval = null;
	          sound._fadeTo = null;
	          self.volume(to, sound._id);
	          self._emit('fade', sound._id);
	        }
	      }, stepLen);
	    },
	
	    /**
	     * Internal method that stops the currently playing fade when
	     * a new fade starts, volume is changed or the sound is stopped.
	     * @param  {Number} id The sound id.
	     * @return {Howl}
	     */
	    _stopFade: function(id) {
	      var self = this;
	      var sound = self._soundById(id);
	
	      if (sound && sound._interval) {
	        if (self._webAudio) {
	          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
	        }
	
	        clearInterval(sound._interval);
	        sound._interval = null;
	        self.volume(sound._fadeTo, id);
	        sound._fadeTo = null;
	        self._emit('fade', id);
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   loop() -> Returns the group's loop value.
	     *   loop(id) -> Returns the sound id's loop value.
	     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
	     *   loop(loop, id) -> Sets the loop value of passed sound id.
	     * @return {Howl/Boolean} Returns self or current loop value.
	     */
	    loop: function() {
	      var self = this;
	      var args = arguments;
	      var loop, id, sound;
	
	      // Determine the values for loop and id.
	      if (args.length === 0) {
	        // Return the grou's loop value.
	        return self._loop;
	      } else if (args.length === 1) {
	        if (typeof args[0] === 'boolean') {
	          loop = args[0];
	          self._loop = loop;
	        } else {
	          // Return this sound's loop value.
	          sound = self._soundById(parseInt(args[0], 10));
	          return sound ? sound._loop : false;
	        }
	      } else if (args.length === 2) {
	        loop = args[0];
	        id = parseInt(args[1], 10);
	      }
	
	      // If no id is passed, get all ID's to be looped.
	      var ids = self._getSoundIds(id);
	      for (var i=0; i<ids.length; i++) {
	        sound = self._soundById(ids[i]);
	
	        if (sound) {
	          sound._loop = loop;
	          if (self._webAudio && sound._node && sound._node.bufferSource) {
	            sound._node.bufferSource.loop = loop;
	            if (loop) {
	              sound._node.bufferSource.loopStart = sound._start || 0;
	              sound._node.bufferSource.loopEnd = sound._stop;
	            }
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   rate() -> Returns the first sound node's current playback rate.
	     *   rate(id) -> Returns the sound id's current playback rate.
	     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
	     *   rate(rate, id) -> Sets the playback rate of passed sound id.
	     * @return {Howl/Number} Returns self or the current playback rate.
	     */
	    rate: function() {
	      var self = this;
	      var args = arguments;
	      var rate, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // We will simply return the current rate of the first node.
	        id = self._sounds[0]._id;
	      } else if (args.length === 1) {
	        // First check if this is an ID, and if not, assume it is a new rate value.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else {
	          rate = parseFloat(args[0]);
	        }
	      } else if (args.length === 2) {
	        rate = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // Update the playback rate or return the current value.
	      var sound;
	      if (typeof rate === 'number') {
	        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
	        if (self._state !== 'loaded') {
	          self._queue.push({
	            event: 'rate',
	            action: function() {
	              self.rate.apply(self, args);
	            }
	          });
	
	          return self;
	        }
	
	        // Set the group rate.
	        if (typeof id === 'undefined') {
	          self._rate = rate;
	        }
	
	        // Update one or all volumes.
	        id = self._getSoundIds(id);
	        for (var i=0; i<id.length; i++) {
	          // Get the sound.
	          sound = self._soundById(id[i]);
	
	          if (sound) {
	            // Keep track of our position when the rate changed and update the playback
	            // start position so we can properly adjust the seek position for time elapsed.
	            sound._rateSeek = self.seek(id[i]);
	            sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
	            sound._rate = rate;
	
	            // Change the playback rate.
	            if (self._webAudio && sound._node && sound._node.bufferSource) {
	              sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler.ctx.currentTime);
	            } else if (sound._node) {
	              sound._node.playbackRate = rate;
	            }
	
	            // Reset the timers.
	            var seek = self.seek(id[i]);
	            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
	            var timeout = (duration * 1000) / Math.abs(sound._rate);
	
	            // Start a new end timer if sound is already playing.
	            if (self._endTimers[id[i]] || !sound._paused) {
	              self._clearTimer(id[i]);
	              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
	            }
	
	            self._emit('rate', sound._id);
	          }
	        }
	      } else {
	        sound = self._soundById(id);
	        return sound ? sound._rate : self._rate;
	      }
	
	      return self;
	    },
	
	    /**
	     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
	     *   seek() -> Returns the first sound node's current seek position.
	     *   seek(id) -> Returns the sound id's current seek position.
	     *   seek(seek) -> Sets the seek position of the first sound node.
	     *   seek(seek, id) -> Sets the seek position of passed sound id.
	     * @return {Howl/Number} Returns self or the current seek position.
	     */
	    seek: function() {
	      var self = this;
	      var args = arguments;
	      var seek, id;
	
	      // Determine the values based on arguments.
	      if (args.length === 0) {
	        // We will simply return the current position of the first node.
	        id = self._sounds[0]._id;
	      } else if (args.length === 1) {
	        // First check if this is an ID, and if not, assume it is a new seek position.
	        var ids = self._getSoundIds();
	        var index = ids.indexOf(args[0]);
	        if (index >= 0) {
	          id = parseInt(args[0], 10);
	        } else if (self._sounds.length) {
	          id = self._sounds[0]._id;
	          seek = parseFloat(args[0]);
	        }
	      } else if (args.length === 2) {
	        seek = parseFloat(args[0]);
	        id = parseInt(args[1], 10);
	      }
	
	      // If there is no ID, bail out.
	      if (typeof id === 'undefined') {
	        return self;
	      }
	
	      // If the sound hasn't loaded, add it to the load queue to seek when capable.
	      if (self._state !== 'loaded') {
	        self._queue.push({
	          event: 'seek',
	          action: function() {
	            self.seek.apply(self, args);
	          }
	        });
	
	        return self;
	      }
	
	      // Get the sound.
	      var sound = self._soundById(id);
	
	      if (sound) {
	        if (typeof seek === 'number' && seek >= 0) {
	          // Pause the sound and update position for restarting playback.
	          var playing = self.playing(id);
	          if (playing) {
	            self.pause(id, true);
	          }
	
	          // Move the position of the track and cancel timer.
	          sound._seek = seek;
	          sound._ended = false;
	          self._clearTimer(id);
	
	          // Restart the playback if the sound was playing.
	          if (playing) {
	            self.play(id, true);
	          }
	
	          // Update the seek position for HTML5 Audio.
	          if (!self._webAudio && sound._node) {
	            sound._node.currentTime = seek;
	          }
	
	          // Wait for the play lock to be unset before emitting (HTML5 Audio).
	          if (playing && !self._webAudio) {
	            var emitSeek = function() {
	              if (!self._playLock) {
	                self._emit('seek', id);
	              } else {
	                setTimeout(emitSeek, 0);
	              }
	            };
	            setTimeout(emitSeek, 0);
	          } else {
	            self._emit('seek', id);
	          }
	        } else {
	          if (self._webAudio) {
	            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
	            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
	            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
	          } else {
	            return sound._node.currentTime;
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
	     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
	     * @return {Boolean} True if playing and false if not.
	     */
	    playing: function(id) {
	      var self = this;
	
	      // Check the passed sound ID (if any).
	      if (typeof id === 'number') {
	        var sound = self._soundById(id);
	        return sound ? !sound._paused : false;
	      }
	
	      // Otherwise, loop through all sounds and check if any are playing.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (!self._sounds[i]._paused) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	
	    /**
	     * Get the duration of this sound. Passing a sound id will return the sprite duration.
	     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
	     * @return {Number} Audio duration in seconds.
	     */
	    duration: function(id) {
	      var self = this;
	      var duration = self._duration;
	
	      // If we pass an ID, get the sound and return the sprite length.
	      var sound = self._soundById(id);
	      if (sound) {
	        duration = self._sprite[sound._sprite][1] / 1000;
	      }
	
	      return duration;
	    },
	
	    /**
	     * Returns the current loaded state of this Howl.
	     * @return {String} 'unloaded', 'loading', 'loaded'
	     */
	    state: function() {
	      return this._state;
	    },
	
	    /**
	     * Unload and destroy the current Howl object.
	     * This will immediately stop all sound instances attached to this group.
	     */
	    unload: function() {
	      var self = this;
	
	      // Stop playing any active sounds.
	      var sounds = self._sounds;
	      for (var i=0; i<sounds.length; i++) {
	        // Stop the sound if it is currently playing.
	        if (!sounds[i]._paused) {
	          self.stop(sounds[i]._id);
	        }
	
	        // Remove the source or disconnect.
	        if (!self._webAudio) {
	          // Set the source to 0-second silence to stop any downloading (except in IE).
	          var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
	          if (!checkIE) {
	            sounds[i]._node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
	          }
	
	          // Remove any event listeners.
	          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
	          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
	        }
	
	        // Empty out all of the nodes.
	        delete sounds[i]._node;
	
	        // Make sure all timers are cleared out.
	        self._clearTimer(sounds[i]._id);
	
	        // Remove the references in the global Howler object.
	        var index = Howler._howls.indexOf(self);
	        if (index >= 0) {
	          Howler._howls.splice(index, 1);
	        }
	      }
	
	      // Delete this sound from the cache (if no other Howl is using it).
	      var remCache = true;
	      for (i=0; i<Howler._howls.length; i++) {
	        if (Howler._howls[i]._src === self._src) {
	          remCache = false;
	          break;
	        }
	      }
	
	      if (cache && remCache) {
	        delete cache[self._src];
	      }
	
	      // Clear global errors.
	      Howler.noAudio = false;
	
	      // Clear out `self`.
	      self._state = 'unloaded';
	      self._sounds = [];
	      self = null;
	
	      return null;
	    },
	
	    /**
	     * Listen to a custom event.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to call.
	     * @param  {Number}   id    (optional) Only listen to events for this sound.
	     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
	     * @return {Howl}
	     */
	    on: function(event, fn, id, once) {
	      var self = this;
	      var events = self['_on' + event];
	
	      if (typeof fn === 'function') {
	        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
	      }
	
	      return self;
	    },
	
	    /**
	     * Remove a custom event. Call without parameters to remove all events.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
	     * @param  {Number}   id    (optional) Only remove events for this sound.
	     * @return {Howl}
	     */
	    off: function(event, fn, id) {
	      var self = this;
	      var events = self['_on' + event];
	      var i = 0;
	
	      // Allow passing just an event and ID.
	      if (typeof fn === 'number') {
	        id = fn;
	        fn = null;
	      }
	
	      if (fn || id) {
	        // Loop through event store and remove the passed function.
	        for (i=0; i<events.length; i++) {
	          var isId = (id === events[i].id);
	          if (fn === events[i].fn && isId || !fn && isId) {
	            events.splice(i, 1);
	            break;
	          }
	        }
	      } else if (event) {
	        // Clear out all events of this type.
	        self['_on' + event] = [];
	      } else {
	        // Clear out all events of every type.
	        var keys = Object.keys(self);
	        for (i=0; i<keys.length; i++) {
	          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
	            self[keys[i]] = [];
	          }
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Listen to a custom event and remove it once fired.
	     * @param  {String}   event Event name.
	     * @param  {Function} fn    Listener to call.
	     * @param  {Number}   id    (optional) Only listen to events for this sound.
	     * @return {Howl}
	     */
	    once: function(event, fn, id) {
	      var self = this;
	
	      // Setup the event listener.
	      self.on(event, fn, id, 1);
	
	      return self;
	    },
	
	    /**
	     * Emit all events of a specific type and pass the sound id.
	     * @param  {String} event Event name.
	     * @param  {Number} id    Sound ID.
	     * @param  {Number} msg   Message to go with event.
	     * @return {Howl}
	     */
	    _emit: function(event, id, msg) {
	      var self = this;
	      var events = self['_on' + event];
	
	      // Loop through event store and fire all functions.
	      for (var i=events.length-1; i>=0; i--) {
	        // Only fire the listener if the correct ID is used.
	        if (!events[i].id || events[i].id === id || event === 'load') {
	          setTimeout(function(fn) {
	            fn.call(this, id, msg);
	          }.bind(self, events[i].fn), 0);
	
	          // If this event was setup with `once`, remove it.
	          if (events[i].once) {
	            self.off(event, events[i].fn, events[i].id);
	          }
	        }
	      }
	
	      // Pass the event type into load queue so that it can continue stepping.
	      self._loadQueue(event);
	
	      return self;
	    },
	
	    /**
	     * Queue of actions initiated before the sound has loaded.
	     * These will be called in sequence, with the next only firing
	     * after the previous has finished executing (even if async like play).
	     * @return {Howl}
	     */
	    _loadQueue: function(event) {
	      var self = this;
	
	      if (self._queue.length > 0) {
	        var task = self._queue[0];
	
	        // Remove this task if a matching event was passed.
	        if (task.event === event) {
	          self._queue.shift();
	          self._loadQueue();
	        }
	
	        // Run the task if no event type is passed.
	        if (!event) {
	          task.action();
	        }
	      }
	
	      return self;
	    },
	
	    /**
	     * Fired when playback ends at the end of the duration.
	     * @param  {Sound} sound The sound object to work with.
	     * @return {Howl}
	     */
	    _ended: function(sound) {
	      var self = this;
	      var sprite = sound._sprite;
	
	      // If we are using IE and there was network latency we may be clipping
	      // audio before it completes playing. Lets check the node to make sure it
	      // believes it has completed, before ending the playback.
	      if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
	        setTimeout(self._ended.bind(self, sound), 100);
	        return self;
	      }
	
	      // Should this sound loop?
	      var loop = !!(sound._loop || self._sprite[sprite][2]);
	
	      // Fire the ended event.
	      self._emit('end', sound._id);
	
	      // Restart the playback for HTML5 Audio loop.
	      if (!self._webAudio && loop) {
	        self.stop(sound._id, true).play(sound._id);
	      }
	
	      // Restart this timer if on a Web Audio loop.
	      if (self._webAudio && loop) {
	        self._emit('play', sound._id);
	        sound._seek = sound._start || 0;
	        sound._rateSeek = 0;
	        sound._playStart = Howler.ctx.currentTime;
	
	        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
	        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
	      }
	
	      // Mark the node as paused.
	      if (self._webAudio && !loop) {
	        sound._paused = true;
	        sound._ended = true;
	        sound._seek = sound._start || 0;
	        sound._rateSeek = 0;
	        self._clearTimer(sound._id);
	
	        // Clean up the buffer source.
	        self._cleanBuffer(sound._node);
	
	        // Attempt to auto-suspend AudioContext if no sounds are still playing.
	        Howler._autoSuspend();
	      }
	
	      // When using a sprite, end the track.
	      if (!self._webAudio && !loop) {
	        self.stop(sound._id);
	      }
	
	      return self;
	    },
	
	    /**
	     * Clear the end timer for a sound playback.
	     * @param  {Number} id The sound ID.
	     * @return {Howl}
	     */
	    _clearTimer: function(id) {
	      var self = this;
	
	      if (self._endTimers[id]) {
	        // Clear the timeout or remove the ended listener.
	        if (typeof self._endTimers[id] !== 'function') {
	          clearTimeout(self._endTimers[id]);
	        } else {
	          var sound = self._soundById(id);
	          if (sound && sound._node) {
	            sound._node.removeEventListener('ended', self._endTimers[id], false);
	          }
	        }
	
	        delete self._endTimers[id];
	      }
	
	      return self;
	    },
	
	    /**
	     * Return the sound identified by this ID, or return null.
	     * @param  {Number} id Sound ID
	     * @return {Object}    Sound object or null.
	     */
	    _soundById: function(id) {
	      var self = this;
	
	      // Loop through all sounds and find the one with this ID.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (id === self._sounds[i]._id) {
	          return self._sounds[i];
	        }
	      }
	
	      return null;
	    },
	
	    /**
	     * Return an inactive sound from the pool or create a new one.
	     * @return {Sound} Sound playback object.
	     */
	    _inactiveSound: function() {
	      var self = this;
	
	      self._drain();
	
	      // Find the first inactive node to recycle.
	      for (var i=0; i<self._sounds.length; i++) {
	        if (self._sounds[i]._ended) {
	          return self._sounds[i].reset();
	        }
	      }
	
	      // If no inactive node was found, create a new one.
	      return new Sound(self);
	    },
	
	    /**
	     * Drain excess inactive sounds from the pool.
	     */
	    _drain: function() {
	      var self = this;
	      var limit = self._pool;
	      var cnt = 0;
	      var i = 0;
	
	      // If there are less sounds than the max pool size, we are done.
	      if (self._sounds.length < limit) {
	        return;
	      }
	
	      // Count the number of inactive sounds.
	      for (i=0; i<self._sounds.length; i++) {
	        if (self._sounds[i]._ended) {
	          cnt++;
	        }
	      }
	
	      // Remove excess inactive sounds, going in reverse order.
	      for (i=self._sounds.length - 1; i>=0; i--) {
	        if (cnt <= limit) {
	          return;
	        }
	
	        if (self._sounds[i]._ended) {
	          // Disconnect the audio source when using Web Audio.
	          if (self._webAudio && self._sounds[i]._node) {
	            self._sounds[i]._node.disconnect(0);
	          }
	
	          // Remove sounds until we have the pool size.
	          self._sounds.splice(i, 1);
	          cnt--;
	        }
	      }
	    },
	
	    /**
	     * Get all ID's from the sounds pool.
	     * @param  {Number} id Only return one ID if one is passed.
	     * @return {Array}    Array of IDs.
	     */
	    _getSoundIds: function(id) {
	      var self = this;
	
	      if (typeof id === 'undefined') {
	        var ids = [];
	        for (var i=0; i<self._sounds.length; i++) {
	          ids.push(self._sounds[i]._id);
	        }
	
	        return ids;
	      } else {
	        return [id];
	      }
	    },
	
	    /**
	     * Load the sound back into the buffer source.
	     * @param  {Sound} sound The sound object to work with.
	     * @return {Howl}
	     */
	    _refreshBuffer: function(sound) {
	      var self = this;
	
	      // Setup the buffer source for playback.
	      sound._node.bufferSource = Howler.ctx.createBufferSource();
	      sound._node.bufferSource.buffer = cache[self._src];
	
	      // Connect to the correct node.
	      if (sound._panner) {
	        sound._node.bufferSource.connect(sound._panner);
	      } else {
	        sound._node.bufferSource.connect(sound._node);
	      }
	
	      // Setup looping and playback rate.
	      sound._node.bufferSource.loop = sound._loop;
	      if (sound._loop) {
	        sound._node.bufferSource.loopStart = sound._start || 0;
	        sound._node.bufferSource.loopEnd = sound._stop;
	      }
	      sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler.ctx.currentTime);
	
	      return self;
	    },
	
	    /**
	     * Prevent memory leaks by cleaning up the buffer source after playback.
	     * @param  {Object} node Sound's audio node containing the buffer source.
	     * @return {Howl}
	     */
	    _cleanBuffer: function(node) {
	      var self = this;
	
	      if (Howler._scratchBuffer) {
	        node.bufferSource.onended = null;
	        node.bufferSource.disconnect(0);
	        try { node.bufferSource.buffer = Howler._scratchBuffer; } catch(e) {}
	      }
	      node.bufferSource = null;
	
	      return self;
	    }
	  };
	
	  /** Single Sound Methods **/
	  /***************************************************************************/
	
	  /**
	   * Setup the sound object, which each node attached to a Howl group is contained in.
	   * @param {Object} howl The Howl parent group.
	   */
	  var Sound = function(howl) {
	    this._parent = howl;
	    this.init();
	  };
	  Sound.prototype = {
	    /**
	     * Initialize a new Sound object.
	     * @return {Sound}
	     */
	    init: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Setup the default parameters.
	      self._muted = parent._muted;
	      self._loop = parent._loop;
	      self._volume = parent._volume;
	      self._rate = parent._rate;
	      self._seek = 0;
	      self._paused = true;
	      self._ended = true;
	      self._sprite = '__default';
	
	      // Generate a unique ID for this sound.
	      self._id = ++Howler._counter;
	
	      // Add itself to the parent's pool.
	      parent._sounds.push(self);
	
	      // Create the new node.
	      self.create();
	
	      return self;
	    },
	
	    /**
	     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
	     * @return {Sound}
	     */
	    create: function() {
	      var self = this;
	      var parent = self._parent;
	      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;
	
	      if (parent._webAudio) {
	        // Create the gain node for controlling volume (the source will connect to this).
	        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
	        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
	        self._node.paused = true;
	        self._node.connect(Howler.masterGain);
	      } else {
	        self._node = new Audio();
	
	        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
	        self._errorFn = self._errorListener.bind(self);
	        self._node.addEventListener('error', self._errorFn, false);
	
	        // Listen for 'canplaythrough' event to let us know the sound is ready.
	        self._loadFn = self._loadListener.bind(self);
	        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);
	
	        // Setup the new audio node.
	        self._node.src = parent._src;
	        self._node.preload = 'auto';
	        self._node.volume = volume * Howler.volume();
	
	        // Begin loading the source.
	        self._node.load();
	      }
	
	      return self;
	    },
	
	    /**
	     * Reset the parameters of this sound to the original state (for recycle).
	     * @return {Sound}
	     */
	    reset: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Reset all of the parameters of this sound.
	      self._muted = parent._muted;
	      self._loop = parent._loop;
	      self._volume = parent._volume;
	      self._rate = parent._rate;
	      self._seek = 0;
	      self._rateSeek = 0;
	      self._paused = true;
	      self._ended = true;
	      self._sprite = '__default';
	
	      // Generate a new ID so that it isn't confused with the previous sound.
	      self._id = ++Howler._counter;
	
	      return self;
	    },
	
	    /**
	     * HTML5 Audio error listener callback.
	     */
	    _errorListener: function() {
	      var self = this;
	
	      // Fire an error event and pass back the code.
	      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
	
	      // Clear the event listener.
	      self._node.removeEventListener('error', self._errorFn, false);
	    },
	
	    /**
	     * HTML5 Audio canplaythrough listener callback.
	     */
	    _loadListener: function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Round up the duration to account for the lower precision in HTML5 Audio.
	      parent._duration = Math.ceil(self._node.duration * 10) / 10;
	
	      // Setup a sprite if none is defined.
	      if (Object.keys(parent._sprite).length === 0) {
	        parent._sprite = {__default: [0, parent._duration * 1000]};
	      }
	
	      if (parent._state !== 'loaded') {
	        parent._state = 'loaded';
	        parent._emit('load');
	        parent._loadQueue();
	      }
	
	      // Clear the event listener.
	      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
	    }
	  };
	
	  /** Helper Methods **/
	  /***************************************************************************/
	
	  var cache = {};
	
	  /**
	   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
	   * @param  {Howl} self
	   */
	  var loadBuffer = function(self) {
	    var url = self._src;
	
	    // Check if the buffer has already been cached and use it instead.
	    if (cache[url]) {
	      // Set the duration from the cache.
	      self._duration = cache[url].duration;
	
	      // Load the sound into this Howl.
	      loadSound(self);
	
	      return;
	    }
	
	    if (/^data:[^;]+;base64,/.test(url)) {
	      // Decode the base64 data URI without XHR, since some browsers don't support it.
	      var data = atob(url.split(',')[1]);
	      var dataView = new Uint8Array(data.length);
	      for (var i=0; i<data.length; ++i) {
	        dataView[i] = data.charCodeAt(i);
	      }
	
	      decodeAudioData(dataView.buffer, self);
	    } else {
	      // Load the buffer from the URL.
	      var xhr = new XMLHttpRequest();
	      xhr.open('GET', url, true);
	      xhr.withCredentials = self._xhrWithCredentials;
	      xhr.responseType = 'arraybuffer';
	      xhr.onload = function() {
	        // Make sure we get a successful response back.
	        var code = (xhr.status + '')[0];
	        if (code !== '0' && code !== '2' && code !== '3') {
	          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
	          return;
	        }
	
	        decodeAudioData(xhr.response, self);
	      };
	      xhr.onerror = function() {
	        // If there is an error, switch to HTML5 Audio.
	        if (self._webAudio) {
	          self._html5 = true;
	          self._webAudio = false;
	          self._sounds = [];
	          delete cache[url];
	          self.load();
	        }
	      };
	      safeXhrSend(xhr);
	    }
	  };
	
	  /**
	   * Send the XHR request wrapped in a try/catch.
	   * @param  {Object} xhr XHR to send.
	   */
	  var safeXhrSend = function(xhr) {
	    try {
	      xhr.send();
	    } catch (e) {
	      xhr.onerror();
	    }
	  };
	
	  /**
	   * Decode audio data from an array buffer.
	   * @param  {ArrayBuffer} arraybuffer The audio data.
	   * @param  {Howl}        self
	   */
	  var decodeAudioData = function(arraybuffer, self) {
	    // Decode the buffer into an audio source.
	    Howler.ctx.decodeAudioData(arraybuffer, function(buffer) {
	      if (buffer && self._sounds.length > 0) {
	        cache[self._src] = buffer;
	        loadSound(self, buffer);
	      }
	    }, function() {
	      self._emit('loaderror', null, 'Decoding audio data failed.');
	    });
	  };
	
	  /**
	   * Sound is now loaded, so finish setting everything up and fire the loaded event.
	   * @param  {Howl} self
	   * @param  {Object} buffer The decoded buffer sound source.
	   */
	  var loadSound = function(self, buffer) {
	    // Set the duration.
	    if (buffer && !self._duration) {
	      self._duration = buffer.duration;
	    }
	
	    // Setup a sprite if none is defined.
	    if (Object.keys(self._sprite).length === 0) {
	      self._sprite = {__default: [0, self._duration * 1000]};
	    }
	
	    // Fire the loaded event.
	    if (self._state !== 'loaded') {
	      self._state = 'loaded';
	      self._emit('load');
	      self._loadQueue();
	    }
	  };
	
	  /**
	   * Setup the audio context when available, or switch to HTML5 Audio mode.
	   */
	  var setupAudioContext = function() {
	    // Check if we are using Web Audio and setup the AudioContext if we are.
	    try {
	      if (typeof AudioContext !== 'undefined') {
	        Howler.ctx = new AudioContext();
	      } else if (typeof webkitAudioContext !== 'undefined') {
	        Howler.ctx = new webkitAudioContext();
	      } else {
	        Howler.usingWebAudio = false;
	      }
	    } catch(e) {
	      Howler.usingWebAudio = false;
	    }
	
	    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
	    // If it is, disable Web Audio as it causes crashing.
	    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
	    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	    var version = appVersion ? parseInt(appVersion[1], 10) : null;
	    if (iOS && version && version < 9) {
	      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
	      if (Howler._navigator && Howler._navigator.standalone && !safari || Howler._navigator && !Howler._navigator.standalone && !safari) {
	        Howler.usingWebAudio = false;
	      }
	    }
	
	    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
	    if (Howler.usingWebAudio) {
	      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
	      Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : 1, Howler.ctx.currentTime);
	      Howler.masterGain.connect(Howler.ctx.destination);
	    }
	
	    // Re-run the setup on Howler.
	    Howler._setup();
	  };
	
	  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return {
	        Howler: Howler,
	        Howl: Howl
	      };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	
	  // Add support for CommonJS libraries such as browserify.
	  if (true) {
	    exports.Howler = Howler;
	    exports.Howl = Howl;
	  }
	
	  // Define globally in case AMD is not available or unused.
	  if (typeof window !== 'undefined') {
	    window.HowlerGlobal = HowlerGlobal;
	    window.Howler = Howler;
	    window.Howl = Howl;
	    window.Sound = Sound;
	  } else if (typeof global !== 'undefined') { // Add to global in Node.js (for testing, etc).
	    global.HowlerGlobal = HowlerGlobal;
	    global.Howler = Howler;
	    global.Howl = Howl;
	    global.Sound = Sound;
	  }
	})();
	
	
	/*!
	 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
	 *  
	 *  howler.js v2.0.10
	 *  howlerjs.com
	 *
	 *  (c) 2013-2018, James Simpson of GoldFire Studios
	 *  goldfirestudios.com
	 *
	 *  MIT License
	 */
	
	(function() {
	
	  'use strict';
	
	  // Setup default properties.
	  HowlerGlobal.prototype._pos = [0, 0, 0];
	  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];
	
	  /** Global Methods **/
	  /***************************************************************************/
	
	  /**
	   * Helper method to update the stereo panning position of all current Howls.
	   * Future Howls will not use this value unless explicitly set.
	   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
	   * @return {Howler/Number}     Self or current stereo panning value.
	   */
	  HowlerGlobal.prototype.stereo = function(pan) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Loop through all Howls and update their stereo panning.
	    for (var i=self._howls.length-1; i>=0; i--) {
	      self._howls[i].stereo(pan);
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the position of the listener in 3D cartesian space. Sounds using
	   * 3D position will be relative to the listener's position.
	   * @param  {Number} x The x-position of the listener.
	   * @param  {Number} y The y-position of the listener.
	   * @param  {Number} z The z-position of the listener.
	   * @return {Howler/Array}   Self or current listener position.
	   */
	  HowlerGlobal.prototype.pos = function(x, y, z) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? self._pos[1] : y;
	    z = (typeof z !== 'number') ? self._pos[2] : z;
	
	    if (typeof x === 'number') {
	      self._pos = [x, y, z];
	
	      if (typeof self.ctx.listener.positionX !== 'undefined') {
	        self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
	      } else {
	        self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
	      }
	    } else {
	      return self._pos;
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the direction the listener is pointing in the 3D cartesian space.
	   * A front and up vector must be provided. The front is the direction the
	   * face of the listener is pointing, and up is the direction the top of the
	   * listener is pointing. Thus, these values are expected to be at right angles
	   * from each other.
	   * @param  {Number} x   The x-orientation of the listener.
	   * @param  {Number} y   The y-orientation of the listener.
	   * @param  {Number} z   The z-orientation of the listener.
	   * @param  {Number} xUp The x-orientation of the top of the listener.
	   * @param  {Number} yUp The y-orientation of the top of the listener.
	   * @param  {Number} zUp The z-orientation of the top of the listener.
	   * @return {Howler/Array}     Returns self or the current orientation vectors.
	   */
	  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self.ctx || !self.ctx.listener) {
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    var or = self._orientation;
	    y = (typeof y !== 'number') ? or[1] : y;
	    z = (typeof z !== 'number') ? or[2] : z;
	    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
	    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
	    zUp = (typeof zUp !== 'number') ? or[5] : zUp;
	
	    if (typeof x === 'number') {
	      self._orientation = [x, y, z, xUp, yUp, zUp];
	
	      if (typeof self.ctx.listener.forwardX !== 'undefined') {
	        self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.upX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.upY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
	        self.ctx.listener.upZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
	      } else {
	        self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
	      }
	    } else {
	      return or;
	    }
	
	    return self;
	  };
	
	  /** Group Methods **/
	  /***************************************************************************/
	
	  /**
	   * Add new properties to the core init.
	   * @param  {Function} _super Core init method.
	   * @return {Howl}
	   */
	  Howl.prototype.init = (function(_super) {
	    return function(o) {
	      var self = this;
	
	      // Setup user-defined default properties.
	      self._orientation = o.orientation || [1, 0, 0];
	      self._stereo = o.stereo || null;
	      self._pos = o.pos || null;
	      self._pannerAttr = {
	        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
	        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
	        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
	        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
	        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
	        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
	        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
	        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
	      };
	
	      // Setup event listeners.
	      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
	      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
	      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];
	
	      // Complete initilization with howler.js core's init function.
	      return _super.call(this, o);
	    };
	  })(Howl.prototype.init);
	
	  /**
	   * Get/set the stereo panning of the audio source for this sound or all in the group.
	   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Number}    Returns self or the current stereo panning value.
	   */
	  Howl.prototype.stereo = function(pan, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'stereo',
	        action: function() {
	          self.stereo(pan, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
	    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';
	
	    // Setup the group's stereo panning if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's stereo panning if no parameters are passed.
	      if (typeof pan === 'number') {
	        self._stereo = pan;
	        self._pos = [pan, 0, 0];
	      } else {
	        return self._stereo;
	      }
	    }
	
	    // Change the streo panning of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof pan === 'number') {
	          sound._stereo = pan;
	          sound._pos = [pan, 0, 0];
	
	          if (sound._node) {
	            // If we are falling back, make sure the panningModel is equalpower.
	            sound._pannerAttr.panningModel = 'equalpower';
	
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner || !sound._panner.pan) {
	              setupPanner(sound, pannerType);
	            }
	
	            if (pannerType === 'spatial') {
	              sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
	              sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
	              sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
	            } else {
	              sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
	            }
	          }
	
	          self._emit('stereo', sound._id);
	        } else {
	          return sound._stereo;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
	   * @param  {Number} x  The x-position of the audio source.
	   * @param  {Number} y  The y-position of the audio source.
	   * @param  {Number} z  The z-position of the audio source.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
	   */
	  Howl.prototype.pos = function(x, y, z, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change position when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'pos',
	        action: function() {
	          self.pos(x, y, z, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? 0 : y;
	    z = (typeof z !== 'number') ? -0.5 : z;
	
	    // Setup the group's spatial position if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's spatial position if no parameters are passed.
	      if (typeof x === 'number') {
	        self._pos = [x, y, z];
	      } else {
	        return self._pos;
	      }
	    }
	
	    // Change the spatial position of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof x === 'number') {
	          sound._pos = [x, y, z];
	
	          if (sound._node) {
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner || sound._panner.pan) {
	              setupPanner(sound, 'spatial');
	            }
	
	            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
	            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
	            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
	          }
	
	          self._emit('pos', sound._id);
	        } else {
	          return sound._pos;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
	   * space. Depending on how direction the sound is, based on the `cone` attributes,
	   * a sound pointing away from the listener can be quiet or silent.
	   * @param  {Number} x  The x-orientation of the source.
	   * @param  {Number} y  The y-orientation of the source.
	   * @param  {Number} z  The z-orientation of the source.
	   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
	   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
	   */
	  Howl.prototype.orientation = function(x, y, z, id) {
	    var self = this;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
	    if (self._state !== 'loaded') {
	      self._queue.push({
	        event: 'orientation',
	        action: function() {
	          self.orientation(x, y, z, id);
	        }
	      });
	
	      return self;
	    }
	
	    // Set the defaults for optional 'y' & 'z'.
	    y = (typeof y !== 'number') ? self._orientation[1] : y;
	    z = (typeof z !== 'number') ? self._orientation[2] : z;
	
	    // Setup the group's spatial orientation if no ID is passed.
	    if (typeof id === 'undefined') {
	      // Return the group's spatial orientation if no parameters are passed.
	      if (typeof x === 'number') {
	        self._orientation = [x, y, z];
	      } else {
	        return self._orientation;
	      }
	    }
	
	    // Change the spatial orientation of one or all sounds in group.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      // Get the sound.
	      var sound = self._soundById(ids[i]);
	
	      if (sound) {
	        if (typeof x === 'number') {
	          sound._orientation = [x, y, z];
	
	          if (sound._node) {
	            // Check if there is a panner setup and create a new one if not.
	            if (!sound._panner) {
	              // Make sure we have a position to setup the node with.
	              if (!sound._pos) {
	                sound._pos = self._pos || [0, 0, -0.5];
	              }
	
	              setupPanner(sound, 'spatial');
	            }
	
	            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
	            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
	            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
	          }
	
	          self._emit('orientation', sound._id);
	        } else {
	          return sound._orientation;
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /**
	   * Get/set the panner node's attributes for a sound or group of sounds.
	   * This method can optionall take 0, 1 or 2 arguments.
	   *   pannerAttr() -> Returns the group's values.
	   *   pannerAttr(id) -> Returns the sound id's values.
	   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
	   *   pannerAttr(o, id) -> Set's the values of passed sound id.
	   *
	   *   Attributes:
	   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
	   *                      inside of which there will be no volume reduction.
	   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
	   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
	   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
	   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
	   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
	   *                     listener. Can be `linear`, `inverse` or `exponential.
	   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
	   *                   will not be reduced any further.
	   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
	   *                   This is simply a variable of the distance model and has a different effect depending on which model
	   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
	   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
	   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
	   *                     with `inverse` and `exponential`.
	   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
	   *                     Can be `HRTF` or `equalpower`.
	   *
	   * @return {Howl/Object} Returns self or current panner attributes.
	   */
	  Howl.prototype.pannerAttr = function() {
	    var self = this;
	    var args = arguments;
	    var o, id, sound;
	
	    // Stop right here if not using Web Audio.
	    if (!self._webAudio) {
	      return self;
	    }
	
	    // Determine the values based on arguments.
	    if (args.length === 0) {
	      // Return the group's panner attribute values.
	      return self._pannerAttr;
	    } else if (args.length === 1) {
	      if (typeof args[0] === 'object') {
	        o = args[0];
	
	        // Set the grou's panner attribute values.
	        if (typeof id === 'undefined') {
	          if (!o.pannerAttr) {
	            o.pannerAttr = {
	              coneInnerAngle: o.coneInnerAngle,
	              coneOuterAngle: o.coneOuterAngle,
	              coneOuterGain: o.coneOuterGain,
	              distanceModel: o.distanceModel,
	              maxDistance: o.maxDistance,
	              refDistance: o.refDistance,
	              rolloffFactor: o.rolloffFactor,
	              panningModel: o.panningModel
	            };
	          }
	
	          self._pannerAttr = {
	            coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
	            coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
	            coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
	            distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
	            maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
	            refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
	            rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
	            panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
	          };
	        }
	      } else {
	        // Return this sound's panner attribute values.
	        sound = self._soundById(parseInt(args[0], 10));
	        return sound ? sound._pannerAttr : self._pannerAttr;
	      }
	    } else if (args.length === 2) {
	      o = args[0];
	      id = parseInt(args[1], 10);
	    }
	
	    // Update the values of the specified sounds.
	    var ids = self._getSoundIds(id);
	    for (var i=0; i<ids.length; i++) {
	      sound = self._soundById(ids[i]);
	
	      if (sound) {
	        // Merge the new values into the sound.
	        var pa = sound._pannerAttr;
	        pa = {
	          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
	          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
	          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
	          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
	          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
	          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
	          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
	          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
	        };
	
	        // Update the panner values or create a new panner if none exists.
	        var panner = sound._panner;
	        if (panner) {
	          panner.coneInnerAngle = pa.coneInnerAngle;
	          panner.coneOuterAngle = pa.coneOuterAngle;
	          panner.coneOuterGain = pa.coneOuterGain;
	          panner.distanceModel = pa.distanceModel;
	          panner.maxDistance = pa.maxDistance;
	          panner.refDistance = pa.refDistance;
	          panner.rolloffFactor = pa.rolloffFactor;
	          panner.panningModel = pa.panningModel;
	        } else {
	          // Make sure we have a position to setup the node with.
	          if (!sound._pos) {
	            sound._pos = self._pos || [0, 0, -0.5];
	          }
	
	          // Create a new panner node.
	          setupPanner(sound, 'spatial');
	        }
	      }
	    }
	
	    return self;
	  };
	
	  /** Single Sound Methods **/
	  /***************************************************************************/
	
	  /**
	   * Add new properties to the core Sound init.
	   * @param  {Function} _super Core Sound init method.
	   * @return {Sound}
	   */
	  Sound.prototype.init = (function(_super) {
	    return function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Setup user-defined default properties.
	      self._orientation = parent._orientation;
	      self._stereo = parent._stereo;
	      self._pos = parent._pos;
	      self._pannerAttr = parent._pannerAttr;
	
	      // Complete initilization with howler.js core Sound's init function.
	      _super.call(this);
	
	      // If a stereo or position was specified, set it up.
	      if (self._stereo) {
	        parent.stereo(self._stereo);
	      } else if (self._pos) {
	        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
	      }
	    };
	  })(Sound.prototype.init);
	
	  /**
	   * Override the Sound.reset method to clean up properties from the spatial plugin.
	   * @param  {Function} _super Sound reset method.
	   * @return {Sound}
	   */
	  Sound.prototype.reset = (function(_super) {
	    return function() {
	      var self = this;
	      var parent = self._parent;
	
	      // Reset all spatial plugin properties on this sound.
	      self._orientation = parent._orientation;
	      self._pos = parent._pos;
	      self._pannerAttr = parent._pannerAttr;
	
	      // Complete resetting of the sound.
	      return _super.call(this);
	    };
	  })(Sound.prototype.reset);
	
	  /** Helper Methods **/
	  /***************************************************************************/
	
	  /**
	   * Create a new panner node and save it on the sound.
	   * @param  {Sound} sound Specific sound to setup panning on.
	   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
	   */
	  var setupPanner = function(sound, type) {
	    type = type || 'spatial';
	
	    // Create the new panner node.
	    if (type === 'spatial') {
	      sound._panner = Howler.ctx.createPanner();
	      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
	      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
	      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
	      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
	      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
	      sound._panner.refDistance = sound._pannerAttr.refDistance;
	      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
	      sound._panner.panningModel = sound._pannerAttr.panningModel;
	      sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
	      sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
	      sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
	      sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
	      sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
	      sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
	    } else {
	      sound._panner = Howler.ctx.createStereoPanner();
	      sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
	    }
	
	    sound._panner.connect(sound._node);
	
	    // Update the connections.
	    if (!sound._paused) {
	      sound._parent.pause(sound._id, true).play(sound._id, true);
	    }
	  };
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict'; // eslint-disable-line strict
	
	/**
	 * Traverses properties on objects and arrays. If an intermediate property is
	 * either null or undefined, it is instead returned. The purpose of this method
	 * is to simplify extracting properties from a chain of maybe-typed properties.
	 *
	 * === EXAMPLE ===
	 *
	 * Consider the following type:
	 *
	 *   const props: {
	 *     user: ?{
	 *       name: string,
	 *       friends: ?Array<User>,
	 *     }
	 *   };
	 *
	 * Getting to the friends of my first friend would resemble:
	 *
	 *   props.user &&
	 *   props.user.friends &&
	 *   props.user.friends[0] &&
	 *   props.user.friends[0].friends
	 *
	 * Instead, `idx` allows us to safely write:
	 *
	 *   idx(props, _ => _.user.friends[0].friends)
	 *
	 * The second argument must be a function that returns one or more nested member
	 * expressions. Any other expression has undefined behavior.
	 *
	 * === NOTE ===
	 *
	 * The code below exists for the purpose of illustrating expected behavior and
	 * is not meant to be executed. The `idx` function is used in conjunction with a
	 * Babel transform that replaces it with better performing code:
	 *
	 *   props.user == null ? props.user :
	 *   props.user.friends == null ? props.user.friends :
	 *   props.user.friends[0] == null ? props.user.friends[0] :
	 *   props.user.friends[0].friends
	 *
	 * All this machinery exists due to the fact that an existential operator does
	 * not currently exist in JavaScript.
	 */
	
	function idx(input, accessor) {
	  try {
	    return accessor(input);
	  } catch (error) {
	    if (error instanceof TypeError) {
	      if (nullPattern.test(error)) {
	        return null;
	      } else if (undefinedPattern.test(error)) {
	        return undefined;
	      }
	    }
	    throw error;
	  }
	}
	
	/**
	 * Some actual error messages for null:
	 *
	 * TypeError: Cannot read property 'bar' of null
	 * TypeError: Cannot convert null value to object
	 * TypeError: foo is null
	 * TypeError: null has no properties
	 * TypeError: null is not an object (evaluating 'foo.bar')
	 * TypeError: null is not an object (evaluating '(" undefined ", null).bar')
	 */
	var nullPattern = /^null | null$|^[^(]* null /i;
	var undefinedPattern = /^undefined | undefined$|^[^(]* undefined /i;
	
	idx.default = idx;
	module.exports = idx;


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? factory(exports, __webpack_require__(10), __webpack_require__(1), __webpack_require__(13)) :
		typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
		(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	var React__default = 'default' in React ? React['default'] : React;
	
	// These functions can be stubbed out in specific environments
	var unstable_batchedUpdates$1 = undefined;
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	    module.exports = factory();
	}(commonjsGlobal, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        classCallCheck(this, EventEmitter);
	        this.listeners = [];
	    }
	
	    createClass(EventEmitter, [{
	        key: "on",
	        value: function on(cb) {
	            var _this = this;
	
	            this.listeners.push(cb);
	            return function () {
	                var index = _this.listeners.indexOf(cb);
	                if (index !== -1) _this.listeners.splice(index, 1);
	            };
	        }
	    }, {
	        key: "emit",
	        value: function emit(data) {
	            this.listeners.forEach(function (fn) {
	                return fn(data);
	            });
	        }
	    }]);
	    return EventEmitter;
	}();
	
	// Copied from React.PropTypes
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	            rest[_key - 6] = arguments[_key];
	        }
	
	        return mobx.untracked(function () {
	            componentName = componentName || "<<anonymous>>";
	            propFullName = propFullName || propName;
	            if (props[propName] == null) {
	                if (isRequired) {
	                    var actual = props[propName] === null ? "null" : "undefined";
	                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	                }
	                return null;
	            } else {
	                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	            }
	        });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	
	// Copied from React.PropTypes
	function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	        return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue["@@toStringTag"] === "Symbol") {
	        return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	        return true;
	    }
	
	    return false;
	}
	
	// Copied from React.PropTypes
	function getPropType(propValue) {
	    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	        return "array";
	    }
	    if (propValue instanceof RegExp) {
	        // Old webkits (at least until Android 4.0) return 'function' rather than
	        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	        // passes PropTypes.object.
	        return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	        return "symbol";
	    }
	    return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// Copied from React.PropTypes
	function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	        if (propValue instanceof Date) {
	            return "date";
	        } else if (propValue instanceof RegExp) {
	            return "regexp";
	        }
	    }
	    return propType;
	}
	
	function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        return mobx.untracked(function () {
	            if (allowNativeType) {
	                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	            }
	            var mobxChecker = void 0;
	            switch (mobxType) {
	                case "Array":
	                    mobxChecker = mobx.isObservableArray;
	                    break;
	                case "Object":
	                    mobxChecker = mobx.isObservableObject;
	                    break;
	                case "Map":
	                    mobxChecker = mobx.isObservableMap;
	                    break;
	                default:
	                    throw new Error("Unexpected mobxType: " + mobxType);
	            }
	            var propValue = props[propName];
	            if (!mobxChecker(propValue)) {
	                var preciseType = getPreciseType(propValue);
	                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	            }
	            return null;
	        });
	    });
	}
	
	function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	            rest[_key2 - 5] = arguments[_key2];
	        }
	
	        return mobx.untracked(function () {
	            if (typeof typeChecker !== "function") {
	                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	            }
	            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	            if (error instanceof Error) return error;
	            var propValue = props[propName];
	            for (var i = 0; i < propValue.length; i++) {
	                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	                if (error instanceof Error) return error;
	            }
	            return null;
	        });
	    });
	}
	
	var observableArray = createObservableTypeCheckerCreator(false, "Array");
	var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	var observableMap = createObservableTypeCheckerCreator(false, "Map");
	var observableObject = createObservableTypeCheckerCreator(false, "Object");
	var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	
	
	var propTypes = Object.freeze({
		observableArray: observableArray,
		observableArrayOf: observableArrayOf,
		observableMap: observableMap,
		observableObject: observableObject,
		arrayOrObservableArray: arrayOrObservableArray,
		arrayOrObservableArrayOf: arrayOrObservableArrayOf,
		objectOrObservableObject: objectOrObservableObject
	});
	
	function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	}
	
	var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	};
	Object.seal(injectorContextTypes);
	
	var proxiedInjectorProps = {
	    contextTypes: {
	        get: function get$$1() {
	            return injectorContextTypes;
	        },
	        set: function set$$1(_) {
	            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	        },
	        configurable: true,
	        enumerable: false
	    },
	    isMobxInjector: {
	        value: true,
	        writable: true,
	        configurable: true,
	        enumerable: true
	    }
	
	    /**
	     * Store Injection
	     */
	};function createStoreInjector(grabStoresFn, component, injectNames) {
	    var _class, _temp2;
	
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector = (_temp2 = _class = function (_Component) {
	        inherits(Injector, _Component);
	
	        function Injector() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            classCallCheck(this, Injector);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
	                _this.wrappedInstance = instance;
	            }, _temp), possibleConstructorReturn(_this, _ret);
	        }
	
	        createClass(Injector, [{
	            key: "render",
	            value: function render() {
	                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	                // See this test: 'using a custom injector is not too reactive' in inject.js
	                var newProps = {};
	                for (var key in this.props) {
	                    if (this.props.hasOwnProperty(key)) {
	                        newProps[key] = this.props[key];
	                    }
	                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	                for (var _key2 in additionalProps) {
	                    newProps[_key2] = additionalProps[_key2];
	                }
	
	                if (!isStateless(component)) {
	                    newProps.ref = this.storeRef;
	                }
	
	                return React.createElement(component, newProps);
	            }
	        }]);
	        return Injector;
	    }(React.Component), _class.displayName = displayName, _temp2);
	
	    // Static fields from component should be visible on the generated Injector
	
	    hoistNonReactStatics(Injector, component);
	
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	
	    return Injector;
	}
	
	function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	        storeNames.forEach(function (storeName) {
	            if (storeName in nextProps // prefer props over stores
	            ) return;
	            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	            nextProps[storeName] = baseStores[storeName];
	        });
	        return nextProps;
	    };
	}
	
	/**
	 * higher order component that injects stores to a child.
	 * takes either a varargs list of strings, which are stores read from the context,
	 * or a function that manually maps the available stores from the context to props:
	 * storesToProps(mobxStores, props, context) => newProps
	 */
	function inject() /* fn(stores, nextProps) or ...storeNames */{
	    var grabStoresFn = void 0;
	    if (typeof arguments[0] === "function") {
	        grabStoresFn = arguments[0];
	        return function (componentClass) {
	            var injected = createStoreInjector(grabStoresFn, componentClass);
	            injected.isMobxInjector = false; // supress warning
	            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	            // see #111
	            injected = observer(injected);
	            injected.isMobxInjector = true; // restore warning
	            return injected;
	        };
	    } else {
	        var storeNames = [];
	        for (var i = 0; i < arguments.length; i++) {
	            storeNames[i] = arguments[i];
	        }grabStoresFn = grabStoresByName(storeNames);
	        return function (componentClass) {
	            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	        };
	    }
	}
	
	/**
	 * dev tool support
	 */
	var isDevtoolsEnabled = false;
	
	var isUsingStaticRendering = false;
	
	var warnedAboutObserverInjectDeprecation = false;
	
	// WeakMap<Node, Object>;
	var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	var renderReporter = new EventEmitter();
	
	function findDOMNode$2(component) {
	    if (reactDom.findDOMNode) {
	        try {
	            return reactDom.findDOMNode(component);
	        } catch (e) {
	            // findDOMNode will throw in react-test-renderer, see:
	            // See https://github.com/mobxjs/mobx-react/issues/216
	            // Is there a better heuristic?
	            return null;
	        }
	    }
	    return null;
	}
	
	function reportRendering(component) {
	    var node = findDOMNode$2(component);
	    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
	
	    renderReporter.emit({
	        event: "render",
	        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	        totalTime: Date.now() - component.__$mobRenderStart,
	        component: component,
	        node: node
	    });
	}
	
	function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	}
	
	function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	}
	
	/**
	 * Errors reporter
	 */
	
	var errorsReporter = new EventEmitter();
	
	/**
	 * Utilities
	 */
	
	function patch(target, funcName) {
	    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var base = target[funcName];
	    var mixinFunc = reactiveMixin[funcName];
	    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
	        mixinFunc.apply(this, arguments);
	        base.apply(this, arguments);
	    } : function () {
	        base.apply(this, arguments);
	        mixinFunc.apply(this, arguments);
	    };
	
	    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
	    // ...but that breaks react-hot-loader, see #231...
	    target[funcName] = f;
	}
	
	function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	        return x !== 0 || 1 / x === 1 / y;
	    } else {
	        return x !== x && y !== y;
	    }
	}
	
	function makeComponentReactive(render) {
	    var _this2 = this;
	
	    if (isUsingStaticRendering === true) return render.call(this);
	
	    function makePropertyObservableReference(propName) {
	        var valueHolder = this[propName];
	        var atom = mobx.createAtom("reactive " + propName);
	        Object.defineProperty(this, propName, {
	            configurable: true,
	            enumerable: true,
	            get: function get$$1() {
	                atom.reportObserved();
	                return valueHolder;
	            },
	            set: function set$$1(v) {
	                if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
	                    valueHolder = v;
	                    skipRender = true;
	                    atom.reportChanged();
	                    skipRender = false;
	                } else {
	                    valueHolder = v;
	                }
	            }
	        });
	    }
	
	    function reactiveRender() {
	        var _this = this;
	
	        isRenderingPending = false;
	        var exception = undefined;
	        var rendering = undefined;
	        reaction.track(function () {
	            if (isDevtoolsEnabled) {
	                _this.__$mobRenderStart = Date.now();
	            }
	            try {
	                rendering = mobx._allowStateChanges(false, baseRender);
	            } catch (e) {
	                exception = e;
	            }
	            if (isDevtoolsEnabled) {
	                _this.__$mobRenderEnd = Date.now();
	            }
	        });
	        if (exception) {
	            errorsReporter.emit(exception);
	            throw exception;
	        }
	        return rendering;
	    }
	
	    // Generate friendly name for debugging
	    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	    /**
	     * If props are shallowly modified, react will render anyway,
	     * so atom.reportChanged() should not result in yet another re-render
	     */
	    var skipRender = false;
	    /**
	     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	     * so detect these changes
	     */
	    var isForcingUpdate = false;
	
	    // make this.props an observable reference, see #124
	    makePropertyObservableReference.call(this, "props");
	    // make state an observable reference
	    makePropertyObservableReference.call(this, "state");
	
	    // wire up reactive render
	    var baseRender = render.bind(this);
	    var isRenderingPending = false;
	
	    var reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
	        if (!isRenderingPending) {
	            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	            // See #85 / Pull #44
	            isRenderingPending = true;
	            if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
	            if (_this2.__$mobxIsUnmounted !== true) {
	                // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	                // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	                // However, people also claim this migth happen during unit tests..
	                var hasError = true;
	                try {
	                    isForcingUpdate = true;
	                    if (!skipRender) React.Component.prototype.forceUpdate.call(_this2);
	                    hasError = false;
	                } finally {
	                    isForcingUpdate = false;
	                    if (hasError) reaction.dispose();
	                }
	            }
	        }
	    });
	    reaction.reactComponent = this;
	    reactiveRender.$mobx = reaction;
	    this.render = reactiveRender;
	    return reactiveRender.call(this);
	}
	
	/**
	 * ReactiveMixin
	 */
	var reactiveMixin = {
	    componentWillUnmount: function componentWillUnmount() {
	        if (isUsingStaticRendering === true) return;
	        this.render.$mobx && this.render.$mobx.dispose();
	        this.__$mobxIsUnmounted = true;
	        if (isDevtoolsEnabled) {
	            var node = findDOMNode$2(this);
	            if (node && componentByNodeRegistry) {
	                componentByNodeRegistry.delete(node);
	            }
	            renderReporter.emit({
	                event: "destroy",
	                component: this,
	                node: node
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (isUsingStaticRendering) {
	            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	        }
	        // update on any state changes (as is the default)
	        if (this.state !== nextState) {
	            return true;
	        }
	        // update if props are shallowly not equal, inspired by PureRenderMixin
	        // we could return just 'false' here, and avoid the `skipRender` checks etc
	        // however, it is nicer if lifecycle events are triggered like usually,
	        // so we return true here if props are shallowly modified.
	        return !shallowEqual(this.props, nextProps);
	    }
	
	    /**
	     * Observer function / decorator
	     */
	};function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	        throw new Error("Store names should be provided as array");
	    }
	    if (Array.isArray(arg1)) {
	        // TODO: remove in next major
	        // component needs stores
	        if (!warnedAboutObserverInjectDeprecation) {
	            warnedAboutObserverInjectDeprecation = true;
	            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	        }
	        if (!arg2) {
	            // invoked as decorator
	            return function (componentClass) {
	                return observer(arg1, componentClass);
	            };
	        } else {
	            return inject.apply(null, arg1)(observer(arg2));
	        }
	    }
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	    if (componentClass.__proto__ === React.PureComponent) {
	        console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
	    }
	
	    // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	        var _class, _temp;
	
	        var observerComponent = observer((_temp = _class = function (_Component) {
	            inherits(_class, _Component);
	
	            function _class() {
	                classCallCheck(this, _class);
	                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            createClass(_class, [{
	                key: "render",
	                value: function render() {
	                    return componentClass.call(this, this.props, this.context);
	                }
	            }]);
	            return _class;
	        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	        hoistNonReactStatics(observerComponent, componentClass);
	        return observerComponent;
	    }
	
	    if (!componentClass) {
	        throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    var baseRender = target.render;
	    target.render = function () {
	        return makeComponentReactive.call(this, baseRender);
	    };
	    return componentClass;
	}
	
	function mixinLifecycleEvents(target) {
	    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	        patch(target, funcName);
	    });
	    if (!target.shouldComponentUpdate) {
	        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    } else {
	        // TODO: make throw in next major
	        console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
	    }
	}
	
	var Observer = observer(function (_ref) {
	    var children = _ref.children,
	        observerInject = _ref.inject,
	        render = _ref.render;
	
	    var component = children || render;
	    if (typeof component === "undefined") {
	        return null;
	    }
	    if (!observerInject) {
	        return component();
	    }
	    // TODO: remove in next major
	    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	});
	
	Observer.displayName = "Observer";
	
	var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	        return;
	    }
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	};
	
	Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component$$1) {
	  var prototype = Component$$1.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component$$1;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component$$1.displayName || Component$$1.name;
	    var newApiName =
	      typeof Component$$1.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component$$1;
	}
	
	var _class;
	var _temp;
	
	var specialReactKeys = { children: true, key: true, ref: true };
	
	var Provider = (_temp = _class = function (_Component) {
	    inherits(Provider, _Component);
	
	    function Provider(props, context) {
	        classCallCheck(this, Provider);
	
	        var _this = possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));
	
	        _this.state = props || {};
	        return _this;
	    }
	
	    createClass(Provider, [{
	        key: "render",
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }, {
	        key: "getChildContext",
	        value: function getChildContext() {
	            var stores = {};
	            // inherit stores
	            var baseStores = this.context.mobxStores;
	            if (baseStores) for (var key in baseStores) {
	                stores[key] = baseStores[key];
	            }
	            // add own stores
	            for (var _key in this.state) {
	                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
	            }return {
	                mobxStores: stores
	            };
	        }
	    }], [{
	        key: "getDerivedStateFromProps",
	        value: function getDerivedStateFromProps(nextProps, prevState) {
	            if (!nextProps) return null;
	            if (!prevState) return nextProps;
	
	            // Maybe this warning is too aggressive?
	            if (Object.keys(nextProps).length !== Object.keys(prevState).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	                if (!specialReactKeys[key] && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	            }return nextProps;
	        }
	    }]);
	    return Provider;
	}(React.Component), _class.contextTypes = {
	    mobxStores: objectOrObservableObject
	}, _class.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	}, _temp);
	
	// TODO: kill in next major
	
	polyfill(Provider);
	
	if (!React.Component) throw new Error("mobx-react requires React to be available");
	if (!mobx.spy) throw new Error("mobx-react requires mobx to be available");
	
	if (typeof reactDom.unstable_batchedUpdates === "function") mobx.configure({ reactionScheduler: reactDom.unstable_batchedUpdates });else if (typeof unstable_batchedUpdates$1 === "function") mobx.configure({ reactionScheduler: unstable_batchedUpdates$1 });
	
	var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	};
	
	/* DevTool support */
	// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js
	
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = { spy: mobx.spy, extras: { getDebugName: mobx.getDebugName } };
	    var mobxReact = {
	        renderReporter: renderReporter,
	        componentByNodeRegistry: componentByNodeRegistry,
	        componentByNodeRegistery: componentByNodeRegistry,
	        trackComponents: trackComponents
	    };
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	}
	
	exports.propTypes = propTypes;
	exports.PropTypes = propTypes;
	exports.onError = onError;
	exports.observer = observer;
	exports.Observer = Observer;
	exports.renderReporter = renderReporter;
	exports.componentByNodeRegistery = componentByNodeRegistry;
	exports.componentByNodeRegistry = componentByNodeRegistry;
	exports.trackComponents = trackComponents;
	exports.useStaticRendering = useStaticRendering;
	exports.Provider = Provider;
	exports.inject = inject;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var mobx = __webpack_require__(10);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	function __decorate(decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	}
	
	/**
	 * Returns the _actual_ type of the given tree node. (Or throws)
	 *
	 * @export
	 * @param {IStateTreeNode} object
	 * @returns {IType<S, T>}
	 */
	function getType$$1(object) {
	    return getStateTreeNode$$1(object).type;
	}
	/**
	 * Returns the _declared_ type of the given sub property of an object, array or map.
	 *
	 * @example
	 * const Box = types.model({ x: 0, y: 0 })
	 * const box = Box.create()
	 *
	 * console.log(getChildType(box, "x").name) // 'number'
	 *
	 * @export
	 * @param {IStateTreeNode} object
	 * @param {string} child
	 * @returns {IType<any, any>}
	 */
	function getChildType$$1(object, child) {
	    return getStateTreeNode$$1(object).getChildType(child);
	}
	/**
	 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
	 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
	 * Patches can be used to deep observe a model tree.
	 *
	 * @export
	 * @param {Object} target the model instance from which to receive patches
	 * @param {(patch: IJsonPatch, reversePatch) => void} callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
	 * @param {includeOldValue} boolean if oldValue is included in the patches, they can be inverted. However patches will become much bigger and might not be suitable for efficient transport
	 * @returns {IDisposer} function to remove the listener
	 */
	function onPatch$$1(target, callback) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof callback !== "function")
	            fail("expected second argument to be a function, got " + callback + " instead");
	    }
	    return getStateTreeNode$$1(target).onPatch(callback);
	}
	/**
	 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
	 * The listener will only be fire at the and of the current MobX (trans)action.
	 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
	 *
	 * @export
	 * @param {Object} target
	 * @param {(snapshot: any) => void} callback
	 * @returns {IDisposer}
	 */
	function onSnapshot$$1(target, callback) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof callback !== "function")
	            fail("expected second argument to be a function, got " + callback + " instead");
	    }
	    return getStateTreeNode$$1(target).onSnapshot(callback);
	}
	/**
	 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
	 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
	 *
	 * Can apply a single past, or an array of patches.
	 *
	 * @export
	 * @param {Object} target
	 * @param {IJsonPatch} patch
	 * @returns
	 */
	function applyPatch$$1(target, patch) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof patch !== "object")
	            fail("expected second argument to be an object or array, got " + patch + " instead");
	    }
	    getStateTreeNode$$1(target).applyPatches(asArray(patch));
	}
	/**
	 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
	 * Returns an recorder object with the following signature:
	 *
	 * @example
	 * export interface IPatchRecorder {
	 *      // the recorded patches
	 *      patches: IJsonPatch[]
	 *      // the inverse of the recorded patches
	 *      inversePatches: IJsonPatch[]
	 *      // stop recording patches
	 *      stop(target?: IStateTreeNode): any
	 *      // resume recording patches
	 *      resume()
	 *      // apply all the recorded patches on the given target (the original subject if omitted)
	 *      replay(target?: IStateTreeNode): any
	 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
	 *      // stops the recorder if not already stopped
	 *      undo(): void
	 * }
	 *
	 * @export
	 * @param {IStateTreeNode} subject
	 * @returns {IPatchRecorder}
	 */
	function recordPatches$$1(subject) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(subject))
	            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
	    }
	    var disposer = null;
	    function resume() {
	        if (disposer)
	            return;
	        disposer = onPatch$$1(subject, function (patch, inversePatch) {
	            recorder.rawPatches.push([patch, inversePatch]);
	        });
	    }
	    var recorder = {
	        rawPatches: [],
	        get patches() {
	            return this.rawPatches.map(function (_a) {
	                var a = _a[0];
	                return a;
	            });
	        },
	        get inversePatches() {
	            return this.rawPatches.map(function (_a) {
	                var _ = _a[0], b = _a[1];
	                return b;
	            });
	        },
	        stop: function () {
	            if (disposer)
	                disposer();
	            disposer = null;
	        },
	        resume: resume,
	        replay: function (target) {
	            applyPatch$$1(target || subject, recorder.patches);
	        },
	        undo: function (target) {
	            applyPatch$$1(target || subject, recorder.inversePatches.slice().reverse());
	        }
	    };
	    resume();
	    return recorder;
	}
	/**
	 * The inverse of `unprotect`
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 *
	 */
	function protect$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    if (!node.isRoot)
	        fail("`protect` can only be invoked on root nodes");
	    node.isProtectionEnabled = true;
	}
	/**
	 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
	 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
	 * For example because you are building a PoC or don't have any middleware attached to your tree.
	 *
	 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
	 *
	 * @example
	 * const Todo = types.model({
	 *     done: false
	 * }).actions(self => ({
	 *     toggle() {
	 *         self.done = !self.done
	 *     }
	 * }))
	 *
	 * const todo = Todo.create()
	 * todo.done = true // throws!
	 * todo.toggle() // OK
	 * unprotect(todo)
	 * todo.done = false // OK
	 */
	function unprotect$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    if (!node.isRoot)
	        fail("`unprotect` can only be invoked on root nodes");
	    node.isProtectionEnabled = false;
	}
	/**
	 * Returns true if the object is in protected mode, @see protect
	 */
	function isProtected$$1(target) {
	    return getStateTreeNode$$1(target).isProtected;
	}
	/**
	 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
	 *
	 * @export
	 * @param {Object} target
	 * @param {Object} snapshot
	 * @returns
	 */
	function applySnapshot$$1(target, snapshot) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).applySnapshot(snapshot);
	}
	/**
	 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
	 * structural sharing where possible. Doesn't require MobX transactions to be completed.
	 *
	 * @export
	 * @param {Object} target
	 * @returns {*}
	 */
	function getSnapshot$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).snapshot;
	}
	/**
	 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array
	 *
	 * @export
	 * @param {Object} target
	 * @param {number} depth = 1, how far should we look upward?
	 * @returns {boolean}
	 */
	function hasParent$$1(target, depth) {
	    if (depth === void 0) { depth = 1; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof depth !== "number")
	            fail("expected second argument to be a number, got " + depth + " instead");
	        if (depth < 0)
	            fail("Invalid depth: " + depth + ", should be >= 1");
	    }
	    var parent = getStateTreeNode$$1(target).parent;
	    while (parent) {
	        if (--depth === 0)
	            return true;
	        parent = parent.parent;
	    }
	    return false;
	}
	/**
	 * Returns the immediate parent of this object, or null.
	 *
	 * Note that the immediate parent can be either an object, map or array, and
	 * doesn't necessarily refer to the parent model
	 *
	 * @export
	 * @param {Object} target
	 * @param {number} depth = 1, how far should we look upward?
	 * @returns {*}
	 */
	function getParent$$1(target, depth) {
	    if (depth === void 0) { depth = 1; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof depth !== "number")
	            fail("expected second argument to be a number, got " + depth + " instead");
	        if (depth < 0)
	            fail("Invalid depth: " + depth + ", should be >= 1");
	    }
	    var d = depth;
	    var parent = getStateTreeNode$$1(target).parent;
	    while (parent) {
	        if (--d === 0)
	            return parent.storedValue;
	        parent = parent.parent;
	    }
	    return fail("Failed to find the parent of " + getStateTreeNode$$1(target) + " at depth " + depth);
	}
	/**
	 * Given an object in a model tree, returns the root object of that tree
	 *
	 * @export
	 * @param {Object} target
	 * @returns {*}
	 */
	function getRoot$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).root.storedValue;
	}
	/**
	 * Returns the path of the given object in the model tree
	 *
	 * @export
	 * @param {Object} target
	 * @returns {string}
	 */
	function getPath$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).path;
	}
	/**
	 * Returns the path of the given object as unescaped string array
	 *
	 * @export
	 * @param {Object} target
	 * @returns {string[]}
	 */
	function getPathParts$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return splitJsonPath$$1(getStateTreeNode$$1(target).path);
	}
	/**
	 * Returns true if the given object is the root of a model tree
	 *
	 * @export
	 * @param {Object} target
	 * @returns {boolean}
	 */
	function isRoot$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).isRoot;
	}
	/**
	 * Resolves a path relatively to a given object.
	 * Returns undefined if no value can be found.
	 *
	 * @export
	 * @param {Object} target
	 * @param {string} path - escaped json path
	 * @returns {*}
	 */
	function resolvePath$$1(target, path) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof path !== "string")
	            fail("expected second argument to be a number, got " + path + " instead");
	    }
	    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path);
	    return node ? node.value : undefined;
	}
	/**
	 * Resolves a model instance given a root target, the type and the identifier you are searching for.
	 * Returns undefined if no value can be found.
	 *
	 * @export
	 * @param {IType<any, any>} type
	 * @param {IStateTreeNode} target
	 * @param {(string | number)} identifier
	 * @returns {*}
	 */
	function resolveIdentifier$$1(type, target, identifier$$1) {
	    // check all arguments
	    if (false) {
	        if (!isType$$1(type))
	            fail("expected first argument to be a mobx-state-tree type, got " + type + " instead");
	        if (!isStateTreeNode$$1(target))
	            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
	        if (!(typeof identifier$$1 === "string" || typeof identifier$$1 === "number"))
	            fail("expected third argument to be a string or number, got " + identifier$$1 + " instead");
	    }
	    var node = getStateTreeNode$$1(target).root.identifierCache.resolve(type, "" + identifier$$1);
	    return node ? node.value : undefined;
	}
	/**
	 * Returns the identifier of the target node.
	 *
	 * @export
	 * @param {IStateTreeNode} target
	  * @returns {(string | null)}
	 */
	function getIdentifier$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).identifier;
	}
	/**
	 *
	 *
	 * @export
	 * @param {Object} target
	 * @param {string} path
	 * @returns {*}
	 */
	function tryResolve$$1(target, path) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof path !== "string")
	            fail("expected second argument to be a string, got " + path + " instead");
	    }
	    var node = resolveNodeByPath$$1(getStateTreeNode$$1(target), path, false);
	    if (node === undefined)
	        return undefined;
	    try {
	        return node.value;
	    }
	    catch (e) {
	        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
	        // see test / issue: 'try resolve doesn't work #686'
	        return undefined;
	    }
	}
	/**
	 * Given two state tree nodes that are part of the same tree,
	 * returns the shortest jsonpath needed to navigate from the one to the other
	 *
	 * @export
	 * @param {IStateTreeNode} base
	 * @param {IStateTreeNode} target
	 * @returns {string}
	 */
	function getRelativePath$$1(base, target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected second argument to be a mobx-state-tree node, got " + target + " instead");
	        if (!isStateTreeNode$$1(base))
	            fail("expected first argument to be a mobx-state-tree node, got " + base + " instead");
	    }
	    return getRelativePathBetweenNodes$$1(getStateTreeNode$$1(base), getStateTreeNode$$1(target));
	}
	/**
	 * Returns a deep copy of the given state tree node as new tree.
	 * Short hand for `snapshot(x) = getType(x).create(getSnapshot(x))`
	 *
	 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
	 *
	 * @export
	 * @template T
	 * @param {T} source
	 * @param {boolean | any} keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
	 * @returns {T}
	 */
	function clone$$1(source, keepEnvironment) {
	    if (keepEnvironment === void 0) { keepEnvironment = true; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(source))
	            fail("expected first argument to be a mobx-state-tree node, got " + source + " instead");
	    }
	    var node = getStateTreeNode$$1(source);
	    return node.type.create(node.snapshot, keepEnvironment === true
	        ? node.root._environment
	        : keepEnvironment === false ? undefined : keepEnvironment); // it's an object or something else
	}
	/**
	 * Removes a model element from the state tree, and let it live on as a new state tree
	 */
	function detach$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    getStateTreeNode$$1(target).detach();
	    return target;
	}
	/**
	 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
	 */
	function destroy$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    if (node.isRoot)
	        node.die();
	    else
	        node.parent.removeChild(node.subpath);
	}
	/**
	 * Returns true if the given state tree node is not killed yet.
	 * This means that the node is still a part of a tree, and that `destroy`
	 * has not been called. If a node is not alive anymore, the only thing one can do with it
	 * is requesting it's last path and snapshot
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @returns {boolean}
	 */
	function isAlive$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    return getStateTreeNode$$1(target).isAlive;
	}
	/**
	 * Use this utility to register a function that should be called whenever the
	 * targeted state tree node is destroyed. This is a useful alternative to managing
	 * cleanup methods yourself using the `beforeDestroy` hook.
	 *
	 * @example
	 * const Todo = types.model({
	 *   title: types.string
	 * }).actions(self => ({
	 *   afterCreate() {
	 *     const autoSaveDisposer = reaction(
	 *       () => getSnapshot(self),
	 *       snapshot => sendSnapshotToServerSomehow(snapshot)
	 *     )
	 *     // stop sending updates to server if this
	 *     // instance is destroyed
	 *     addDisposer(self, autoSaveDisposer)
	 *   }
	 * }))
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @param {() => void} disposer
	 */
	function addDisposer$$1(target, disposer) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof disposer !== "function")
	            fail("expected second argument to be a function, got " + disposer + " instead");
	    }
	    getStateTreeNode$$1(target).addDisposer(disposer);
	}
	/**
	 * Returns the environment of the current state tree. For more info on environments,
	 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
	 *
	 * Returns an empty environment if the tree wasn't initialized with an environment
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @returns {*}
	 */
	function getEnv$$1(target) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    var env = node.root._environment;
	    if (!!!env)
	        return EMPTY_OBJECT;
	    return env;
	}
	/**
	 * Performs a depth first walk through a tree
	 */
	function walk$$1(target, processor) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof processor !== "function")
	            fail("expected second argument to be a function, got " + processor + " instead");
	    }
	    var node = getStateTreeNode$$1(target);
	    // tslint:disable-next-line:no_unused-variable
	    node.getChildren().forEach(function (child) {
	        if (isStateTreeNode$$1(child.storedValue))
	            walk$$1(child.storedValue, processor);
	    });
	    processor(node.storedValue);
	}
	/**
	 * Returns a reflection of the node
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @returns {IModelReflectionData}
	 */
	function getMembers$$1(target) {
	    // check all arguments
	    if (false) {
	        var node_1 = getStateTreeNode$$1(target);
	        if (!(node_1.type instanceof ModelType$$1))
	            fail("expected the node's type to be of the type: model" +
	                target +
	                " instead. It's likely you passed an array or a map.");
	    }
	    var node = getStateTreeNode$$1(target);
	    var type = node.type;
	    var props = Object.getOwnPropertyNames(target);
	    var reflected = {
	        name: type.name,
	        properties: __assign({}, type.properties),
	        actions: [],
	        volatile: [],
	        views: []
	    };
	    props.forEach(function (key) {
	        if (key in reflected.properties)
	            return;
	        var descriptor = Object.getOwnPropertyDescriptor(target, key);
	        if (descriptor.get) {
	            if (mobx.isComputedProp(target, key))
	                reflected.views.push(key);
	            else
	                reflected.volatile.push(key);
	            return;
	        }
	        if (descriptor.value._isMSTAction === true)
	            reflected.actions.push(key);
	        else if (mobx.isObservableProp(target, key))
	            reflected.volatile.push(key);
	        else
	            reflected.views.push(key);
	    });
	    return reflected;
	}
	
	var ScalarNode$$1 = /** @class */ (function () {
	    function ScalarNode$$1(type, parent, subpath, environment, initialValue, storedValue, canAttachTreeNode, finalizeNewInstance) {
	        if (finalizeNewInstance === void 0) { finalizeNewInstance = noop; }
	        this.subpath = "";
	        this._environment = undefined;
	        this._autoUnbox = true; // unboxing is disabled when reading child nodes
	        this.state = NodeLifeCycle$$1.INITIALIZING;
	        this.type = type;
	        this.storedValue = storedValue;
	        this._parent = parent;
	        this.subpath = subpath;
	        this.storedValue = storedValue;
	        this._environment = environment;
	        this.unbox = this.unbox.bind(this);
	        if (canAttachTreeNode)
	            addHiddenFinalProp(this.storedValue, "$treenode", this);
	        var sawException = true;
	        try {
	            if (canAttachTreeNode)
	                addHiddenFinalProp(this.storedValue, "toJSON", toJSON$$1);
	            finalizeNewInstance(this, initialValue);
	            this.state = NodeLifeCycle$$1.CREATED;
	            sawException = false;
	        }
	        finally {
	            if (sawException) {
	                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
	                this.state = NodeLifeCycle$$1.DEAD;
	            }
	        }
	    }
	    Object.defineProperty(ScalarNode$$1.prototype, "path", {
	        /*
	         * Returnes (escaped) path representation as string
	         */
	        get: function () {
	            if (!this.parent)
	                return "";
	            return this.parent.path + "/" + escapeJsonPath$$1(this.subpath);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "isRoot", {
	        get: function () {
	            return this.parent === null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "parent", {
	        get: function () {
	            return this._parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "root", {
	        get: function () {
	            // future optimization: store root ref in the node and maintain it
	            if (!this._parent)
	                return fail("This scalar node is not part of a tree");
	            return this._parent.root;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScalarNode$$1.prototype.setParent = function (newParent, subpath) {
	        if (subpath === void 0) { subpath = null; }
	        if (this.parent !== newParent)
	            fail("Cannot change parent of immutable node");
	        if (this.subpath === subpath)
	            return;
	        this.subpath = subpath || "";
	    };
	    Object.defineProperty(ScalarNode$$1.prototype, "value", {
	        get: function () {
	            return this.type.getValue(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "snapshot", {
	        get: function () {
	            var snapshot = this.type.getSnapshot(this);
	            // avoid any external modification in dev mode
	            return freeze(snapshot);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ScalarNode$$1.prototype, "isAlive", {
	        get: function () {
	            return this.state !== NodeLifeCycle$$1.DEAD;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScalarNode$$1.prototype.unbox = function (childNode) {
	        if (childNode && this._autoUnbox === true)
	            return childNode.value;
	        return childNode;
	    };
	    ScalarNode$$1.prototype.toString = function () {
	        return this.type.name + "@" + (this.path || "<root>") + (this.isAlive ? "" : "[dead]");
	    };
	    ScalarNode$$1.prototype.die = function () {
	        this.state = NodeLifeCycle$$1.DEAD;
	    };
	    __decorate([
	        mobx.observable
	    ], ScalarNode$$1.prototype, "subpath", void 0);
	    return ScalarNode$$1;
	}());
	
	var nextNodeId = 1;
	var ObjectNode$$1 = /** @class */ (function () {
	    function ObjectNode$$1(type, parent, subpath, environment, initialValue, storedValue, canAttachTreeNode, finalizeNewInstance) {
	        if (finalizeNewInstance === void 0) { finalizeNewInstance = noop; }
	        var _this = this;
	        this.nodeId = ++nextNodeId;
	        this.subpath = "";
	        this._parent = null;
	        this._isRunningAction = false; // only relevant for root
	        this.isProtectionEnabled = true;
	        this.identifierAttribute = undefined; // not to be modified directly, only through model initialization
	        this._environment = undefined;
	        this._autoUnbox = true; // unboxing is disabled when reading child nodes
	        this.state = NodeLifeCycle$$1.INITIALIZING;
	        this.middlewares = EMPTY_ARRAY;
	        this.type = type;
	        this.storedValue = storedValue;
	        this._parent = parent;
	        this.subpath = subpath;
	        this._environment = environment;
	        this.unbox = this.unbox.bind(this);
	        this.preboot();
	        if (!parent)
	            this.identifierCache = new IdentifierCache$$1();
	        if (canAttachTreeNode)
	            addHiddenFinalProp(this.storedValue, "$treenode", this);
	        var sawException = true;
	        try {
	            if (canAttachTreeNode)
	                addHiddenFinalProp(this.storedValue, "toJSON", toJSON$$1);
	            this._isRunningAction = true;
	            finalizeNewInstance(this, initialValue);
	            this._isRunningAction = false;
	            if (parent)
	                parent.root.identifierCache.addNodeToCache(this);
	            else
	                this.identifierCache.addNodeToCache(this);
	            this.fireHook("afterCreate");
	            this.state = NodeLifeCycle$$1.CREATED;
	            sawException = false;
	        }
	        finally {
	            if (sawException) {
	                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
	                this.state = NodeLifeCycle$$1.DEAD;
	            }
	        }
	        var snapshotDisposer = mobx.reaction(function () { return _this.snapshot; }, function (snapshot) {
	            _this.emitSnapshot(snapshot);
	        }, {
	            onError: function (e) {
	                throw e;
	            }
	        });
	        this.addDisposer(snapshotDisposer);
	    }
	    Object.defineProperty(ObjectNode$$1.prototype, "path", {
	        /*
	         * Returnes (escaped) path representation as string
	         */
	        get: function () {
	            if (!this.parent)
	                return "";
	            return this.parent.path + "/" + escapeJsonPath$$1(this.subpath);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "isRoot", {
	        get: function () {
	            return this.parent === null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "parent", {
	        get: function () {
	            return this._parent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "root", {
	        // Optimization: make computed
	        get: function () {
	            var p, r = this;
	            while ((p = r.parent))
	                r = p;
	            return r;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.setParent = function (newParent, subpath) {
	        if (subpath === void 0) { subpath = null; }
	        if (this.parent === newParent && this.subpath === subpath)
	            return;
	        if (newParent) {
	            if (this._parent && newParent !== this._parent) {
	                fail("A node cannot exists twice in the state tree. Failed to add " + this + " to path '" + newParent.path + "/" + subpath + "'.");
	            }
	            if (!this._parent && newParent.root === this) {
	                fail("A state tree is not allowed to contain itself. Cannot assign " + this + " to path '" + newParent.path + "/" + subpath + "'");
	            }
	            if (!this._parent &&
	                !!this.root._environment &&
	                this.root._environment !== newParent.root._environment) {
	                fail("A state tree cannot be made part of another state tree as long as their environments are different.");
	            }
	        }
	        if (this.parent && !newParent) {
	            this.die();
	        }
	        else {
	            this.subpath = subpath || "";
	            if (newParent && newParent !== this._parent) {
	                newParent.root.identifierCache.mergeCache(this);
	                this._parent = newParent;
	                this.fireHook("afterAttach");
	            }
	        }
	    };
	    ObjectNode$$1.prototype.fireHook = function (name) {
	        var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
	        if (typeof fn === "function")
	            fn.apply(this.storedValue);
	    };
	    Object.defineProperty(ObjectNode$$1.prototype, "value", {
	        get: function () {
	            if (!this.isAlive)
	                return undefined;
	            return this.type.getValue(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "snapshot", {
	        get: function () {
	            if (!this.isAlive)
	                return undefined;
	            // advantage of using computed for a snapshot is that nicely respects transactions etc.
	            var snapshot = this.type.getSnapshot(this);
	            // avoid any external modification in dev mode
	            return freeze(snapshot);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.isRunningAction = function () {
	        if (this._isRunningAction)
	            return true;
	        if (this.isRoot)
	            return false;
	        return this.parent.isRunningAction();
	    };
	    Object.defineProperty(ObjectNode$$1.prototype, "identifier", {
	        get: function () {
	            // RF: do not read from the snapshot here, it can lead to cycle computations
	            // using bidirectional references
	            return this.identifierAttribute ? this.storedValue[this.identifierAttribute] : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ObjectNode$$1.prototype, "isAlive", {
	        get: function () {
	            return this.state !== NodeLifeCycle$$1.DEAD;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.assertAlive = function () {
	        if (!this.isAlive)
	            fail(this + " cannot be used anymore as it has died; it has been removed from a state tree. If you want to remove an element from a tree and let it live on, use 'detach' or 'clone' the value");
	    };
	    ObjectNode$$1.prototype.getChildNode = function (subpath) {
	        this.assertAlive();
	        this._autoUnbox = false;
	        try {
	            return this.type.getChildNode(this, subpath);
	        }
	        finally {
	            this._autoUnbox = true;
	        }
	    };
	    ObjectNode$$1.prototype.getChildren = function () {
	        this.assertAlive();
	        this._autoUnbox = false;
	        try {
	            return this.type.getChildren(this);
	        }
	        finally {
	            this._autoUnbox = true;
	        }
	    };
	    ObjectNode$$1.prototype.getChildType = function (key) {
	        return this.type.getChildType(key);
	    };
	    Object.defineProperty(ObjectNode$$1.prototype, "isProtected", {
	        get: function () {
	            return this.root.isProtectionEnabled;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObjectNode$$1.prototype.assertWritable = function () {
	        this.assertAlive();
	        if (!this.isRunningAction() && this.isProtected) {
	            fail("Cannot modify '" + this + "', the object is protected and can only be modified by using an action.");
	        }
	    };
	    ObjectNode$$1.prototype.removeChild = function (subpath) {
	        this.type.removeChild(this, subpath);
	    };
	    ObjectNode$$1.prototype.unbox = function (childNode) {
	        if (childNode && this._autoUnbox === true)
	            return childNode.value;
	        return childNode;
	    };
	    ObjectNode$$1.prototype.toString = function () {
	        var identifier$$1 = this.identifier ? "(id: " + this.identifier + ")" : "";
	        return this.type.name + "@" + (this.path || "<root>") + identifier$$1 + (this.isAlive
	            ? ""
	            : "[dead]");
	    };
	    ObjectNode$$1.prototype.finalizeCreation = function () {
	        // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
	        if (this.state === NodeLifeCycle$$1.CREATED) {
	            if (this.parent) {
	                if (this.parent.state !== NodeLifeCycle$$1.FINALIZED) {
	                    // parent not ready yet, postpone
	                    return;
	                }
	                this.fireHook("afterAttach");
	            }
	            this.state = NodeLifeCycle$$1.FINALIZED;
	            for (var _i = 0, _a = this.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                if (child instanceof ObjectNode$$1)
	                    child.finalizeCreation();
	            }
	        }
	    };
	    ObjectNode$$1.prototype.detach = function () {
	        if (!this.isAlive)
	            fail("Error while detaching, node is not alive.");
	        if (this.isRoot)
	            return;
	        else {
	            this.fireHook("beforeDetach");
	            this._environment = this.root._environment; // make backup of environment
	            this.state = NodeLifeCycle$$1.DETACHING;
	            this.identifierCache = this.root.identifierCache.splitCache(this);
	            this.parent.removeChild(this.subpath);
	            this._parent = null;
	            this.subpath = "";
	            this.state = NodeLifeCycle$$1.FINALIZED;
	        }
	    };
	    ObjectNode$$1.prototype.preboot = function () {
	        var _this = this;
	        this.disposers = [];
	        this.middlewares = [];
	        this.snapshotSubscribers = [];
	        this.patchSubscribers = [];
	        // Optimization: this does not need to be done per instance
	        // if some pieces from createActionInvoker are extracted
	        this.applyPatches = createActionInvoker$$1(this.storedValue, "@APPLY_PATCHES", function (patches) {
	            patches.forEach(function (patch) {
	                var parts = splitJsonPath$$1(patch.path);
	                var node = resolveNodeByPathParts$$1(_this, parts.slice(0, -1));
	                node.applyPatchLocally(parts[parts.length - 1], patch);
	            });
	        }).bind(this.storedValue);
	        this.applySnapshot = createActionInvoker$$1(this.storedValue, "@APPLY_SNAPSHOT", function (snapshot) {
	            // if the snapshot is the same as the current one, avoid performing a reconcile
	            if (snapshot === _this.snapshot)
	                return;
	            // else, apply it by calling the type logic
	            return _this.type.applySnapshot(_this, snapshot);
	        }).bind(this.storedValue);
	    };
	    ObjectNode$$1.prototype.die = function () {
	        if (this.state === NodeLifeCycle$$1.DETACHING)
	            return;
	        if (isStateTreeNode$$1(this.storedValue)) {
	            // optimization: don't use walk, but getChildNodes for more efficiency
	            walk$$1(this.storedValue, function (child) {
	                var node = getStateTreeNode$$1(child);
	                if (node instanceof ObjectNode$$1)
	                    node.aboutToDie();
	            });
	            walk$$1(this.storedValue, function (child) {
	                var node = getStateTreeNode$$1(child);
	                if (node instanceof ObjectNode$$1)
	                    node.finalizeDeath();
	            });
	        }
	    };
	    ObjectNode$$1.prototype.aboutToDie = function () {
	        this.disposers.splice(0).forEach(function (f) { return f(); });
	        this.fireHook("beforeDestroy");
	    };
	    ObjectNode$$1.prototype.finalizeDeath = function () {
	        // invariant: not called directly but from "die"
	        this.root.identifierCache.notifyDied(this);
	        var self = this;
	        var oldPath = this.path;
	        addReadOnlyProp(this, "snapshot", this.snapshot); // kill the computed prop and just store the last snapshot
	        this.patchSubscribers.splice(0);
	        this.snapshotSubscribers.splice(0);
	        this.patchSubscribers.splice(0);
	        this.state = NodeLifeCycle$$1.DEAD;
	        this._parent = null;
	        this.subpath = "";
	        // This is quite a hack, once interceptable objects / arrays / maps are extracted from mobx,
	        // we could express this in a much nicer way
	        // TODO: should be possible to obtain id's still...
	        Object.defineProperty(this.storedValue, "$mobx", {
	            get: function () {
	                fail("This object has died and is no longer part of a state tree. It cannot be used anymore. The object (of type '" + self
	                    .type
	                    .name + "') used to live at '" + oldPath + "'. It is possible to access the last snapshot of this object using 'getSnapshot', or to create a fresh copy using 'clone'. If you want to remove an object from the tree without killing it, use 'detach' instead.");
	            }
	        });
	    };
	    ObjectNode$$1.prototype.onSnapshot = function (onChange) {
	        return registerEventHandler(this.snapshotSubscribers, onChange);
	    };
	    ObjectNode$$1.prototype.emitSnapshot = function (snapshot) {
	        this.snapshotSubscribers.forEach(function (f) { return f(snapshot); });
	    };
	    ObjectNode$$1.prototype.onPatch = function (handler) {
	        return registerEventHandler(this.patchSubscribers, handler);
	    };
	    ObjectNode$$1.prototype.emitPatch = function (basePatch, source) {
	        if (this.patchSubscribers.length) {
	            var localizedPatch = extend({}, basePatch, {
	                path: source.path.substr(this.path.length) + "/" + basePatch.path // calculate the relative path of the patch
	            });
	            var _a = splitPatch$$1(localizedPatch), patch_1 = _a[0], reversePatch_1 = _a[1];
	            this.patchSubscribers.forEach(function (f) { return f(patch_1, reversePatch_1); });
	        }
	        if (this.parent)
	            this.parent.emitPatch(basePatch, source);
	    };
	    ObjectNode$$1.prototype.addDisposer = function (disposer) {
	        this.disposers.unshift(disposer);
	    };
	    ObjectNode$$1.prototype.removeMiddleware = function (handler) {
	        this.middlewares = this.middlewares.filter(function (middleware) { return middleware.handler !== handler; });
	    };
	    ObjectNode$$1.prototype.addMiddleWare = function (handler, includeHooks) {
	        var _this = this;
	        if (includeHooks === void 0) { includeHooks = true; }
	        this.middlewares.push({ handler: handler, includeHooks: includeHooks });
	        return function () {
	            _this.removeMiddleware(handler);
	        };
	    };
	    ObjectNode$$1.prototype.applyPatchLocally = function (subpath, patch) {
	        this.assertWritable();
	        this.type.applyPatchLocally(this, subpath, patch);
	    };
	    __decorate([
	        mobx.observable
	    ], ObjectNode$$1.prototype, "subpath", void 0);
	    __decorate([
	        mobx.observable
	    ], ObjectNode$$1.prototype, "_parent", void 0);
	    __decorate([
	        mobx.computed
	    ], ObjectNode$$1.prototype, "path", null);
	    __decorate([
	        mobx.computed
	    ], ObjectNode$$1.prototype, "value", null);
	    __decorate([
	        mobx.computed
	    ], ObjectNode$$1.prototype, "snapshot", null);
	    return ObjectNode$$1;
	}());
	
	var TypeFlags$$1;
	(function (TypeFlags$$1) {
	    TypeFlags$$1[TypeFlags$$1["String"] = 1] = "String";
	    TypeFlags$$1[TypeFlags$$1["Number"] = 2] = "Number";
	    TypeFlags$$1[TypeFlags$$1["Boolean"] = 4] = "Boolean";
	    TypeFlags$$1[TypeFlags$$1["Date"] = 8] = "Date";
	    TypeFlags$$1[TypeFlags$$1["Literal"] = 16] = "Literal";
	    TypeFlags$$1[TypeFlags$$1["Array"] = 32] = "Array";
	    TypeFlags$$1[TypeFlags$$1["Map"] = 64] = "Map";
	    TypeFlags$$1[TypeFlags$$1["Object"] = 128] = "Object";
	    TypeFlags$$1[TypeFlags$$1["Frozen"] = 256] = "Frozen";
	    TypeFlags$$1[TypeFlags$$1["Optional"] = 512] = "Optional";
	    TypeFlags$$1[TypeFlags$$1["Reference"] = 1024] = "Reference";
	    TypeFlags$$1[TypeFlags$$1["Identifier"] = 2048] = "Identifier";
	    TypeFlags$$1[TypeFlags$$1["Late"] = 4096] = "Late";
	    TypeFlags$$1[TypeFlags$$1["Refinement"] = 8192] = "Refinement";
	    TypeFlags$$1[TypeFlags$$1["Union"] = 16384] = "Union";
	    TypeFlags$$1[TypeFlags$$1["Null"] = 32768] = "Null";
	    TypeFlags$$1[TypeFlags$$1["Undefined"] = 65536] = "Undefined";
	})(TypeFlags$$1 || (TypeFlags$$1 = {}));
	/*
	 * A complex type produces a MST node (Node in the state tree)
	 */
	var ComplexType$$1 = /** @class */ (function () {
	    function ComplexType$$1(name) {
	        this.isType = true;
	        this.name = name;
	    }
	    ComplexType$$1.prototype.create = function (snapshot, environment) {
	        if (snapshot === void 0) { snapshot = this.getDefaultSnapshot(); }
	        typecheck$$1(this, snapshot);
	        return this.instantiate(null, "", environment, snapshot).value;
	    };
	    ComplexType$$1.prototype.isAssignableFrom = function (type) {
	        return type === this;
	    };
	    ComplexType$$1.prototype.validate = function (value, context) {
	        if (isStateTreeNode$$1(value)) {
	            return getType$$1(value) === this || this.isAssignableFrom(getType$$1(value))
	                ? typeCheckSuccess$$1()
	                : typeCheckFailure$$1(context, value);
	            // it is tempting to compare snapshots, but in that case we should always clone on assignments...
	        }
	        return this.isValidSnapshot(value, context);
	    };
	    ComplexType$$1.prototype.is = function (value) {
	        return this.validate(value, [{ path: "", type: this }]).length === 0;
	    };
	    ComplexType$$1.prototype.reconcile = function (current, newValue) {
	        if (current.snapshot === newValue)
	            // newValue is the current snapshot of the node, noop
	            return current;
	        if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue) === current)
	            // the current node is the same as the new one
	            return current;
	        if (current.type === this &&
	            isMutable(newValue) &&
	            !isStateTreeNode$$1(newValue) &&
	            (!current.identifierAttribute ||
	                current.identifier === newValue[current.identifierAttribute])) {
	            // the newValue has no node, so can be treated like a snapshot
	            // we can reconcile
	            current.applySnapshot(newValue);
	            return current;
	        }
	        // current node cannot be recycled in any way
	        var parent = current.parent, subpath = current.subpath;
	        current.die();
	        // attempt to reuse the new one
	        if (isStateTreeNode$$1(newValue) && this.isAssignableFrom(getType$$1(newValue))) {
	            // newValue is a Node as well, move it here..
	            var newNode = getStateTreeNode$$1(newValue);
	            newNode.setParent(parent, subpath);
	            return newNode;
	        }
	        // nothing to do, we have to create a new node
	        return this.instantiate(parent, subpath, current._environment, newValue);
	    };
	    Object.defineProperty(ComplexType$$1.prototype, "Type", {
	        get: function () {
	            return fail("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ComplexType$$1.prototype, "SnapshotType", {
	        get: function () {
	            return fail("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        mobx.action
	    ], ComplexType$$1.prototype, "create", null);
	    return ComplexType$$1;
	}());
	var Type$$1 = /** @class */ (function (_super) {
	    __extends(Type$$1, _super);
	    function Type$$1(name) {
	        return _super.call(this, name) || this;
	    }
	    Type$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    Type$$1.prototype.getSnapshot = function (node) {
	        return node.storedValue;
	    };
	    Type$$1.prototype.getDefaultSnapshot = function () {
	        return undefined;
	    };
	    Type$$1.prototype.applySnapshot = function (node, snapshot) {
	        fail("Immutable types do not support applying snapshots");
	    };
	    Type$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        fail("Immutable types do not support applying patches");
	    };
	    Type$$1.prototype.getChildren = function (node) {
	        return EMPTY_ARRAY;
	    };
	    Type$$1.prototype.getChildNode = function (node, key) {
	        return fail("No child '" + key + "' available in type: " + this.name);
	    };
	    Type$$1.prototype.getChildType = function (key) {
	        return fail("No child '" + key + "' available in type: " + this.name);
	    };
	    Type$$1.prototype.reconcile = function (current, newValue) {
	        // reconcile only if type and value are still the same
	        if (current.type === this && current.storedValue === newValue)
	            return current;
	        var res = this.instantiate(current.parent, current.subpath, current._environment, newValue);
	        current.die();
	        return res;
	    };
	    Type$$1.prototype.removeChild = function (node, subpath) {
	        return fail("No child '" + subpath + "' available in type: " + this.name);
	    };
	    return Type$$1;
	}(ComplexType$$1));
	function isType$$1(value) {
	    return typeof value === "object" && value && value.isType === true;
	}
	
	var runningActions = new Map();
	/**
	 * Convenience utility to create action based middleware that supports async processes more easily.
	 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
	 *
	 * The create middleware tracks the process of an action (assuming it passes the `filter`).
	 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
	 *
	 * See the `atomic` middleware for an example
	 *
	 * @export
	 * @template T
	 * @template any
	 * @param {{
	 *     filter?: (call: IMiddlewareEvent) => boolean
	 *     onStart: (call: IMiddlewareEvent) => T
	 *     onResume: (call: IMiddlewareEvent, context: T) => void
	 *     onSuspend: (call: IMiddlewareEvent, context: T) => void
	 *     onSuccess: (call: IMiddlewareEvent, context: T, result: any) => void
	 *     onFail: (call: IMiddlewareEvent, context: T, error: any) => void
	 * }} hooks
	 * @returns {IMiddlewareHandler}
	 */
	function createActionTrackingMiddleware(hooks) {
	    return function actionTrackingMiddleware(call, next, abort) {
	        switch (call.type) {
	            case "action": {
	                if (!hooks.filter || hooks.filter(call) === true) {
	                    var context = hooks.onStart(call);
	                    hooks.onResume(call, context);
	                    runningActions.set(call.id, {
	                        call: call,
	                        context: context,
	                        async: false
	                    });
	                    try {
	                        var res = next(call);
	                        hooks.onSuspend(call, context);
	                        if (runningActions.get(call.id).async === false) {
	                            runningActions.delete(call.id);
	                            hooks.onSuccess(call, context, res);
	                        }
	                        return res;
	                    }
	                    catch (e) {
	                        runningActions.delete(call.id);
	                        hooks.onFail(call, context, e);
	                        throw e;
	                    }
	                }
	                else {
	                    return next(call);
	                }
	            }
	            case "flow_spawn": {
	                var root = runningActions.get(call.rootId);
	                root.async = true;
	                return next(call);
	            }
	            case "flow_resume":
	            case "flow_resume_error": {
	                var root = runningActions.get(call.rootId);
	                hooks.onResume(call, root.context);
	                try {
	                    return next(call);
	                }
	                finally {
	                    hooks.onSuspend(call, root.context);
	                }
	            }
	            case "flow_throw": {
	                var root = runningActions.get(call.rootId);
	                runningActions.delete(call.id);
	                hooks.onFail(call, root.context, call.args[0]);
	                return next(call);
	            }
	            case "flow_return": {
	                var root = runningActions.get(call.rootId);
	                runningActions.delete(call.id);
	                hooks.onSuccess(call, root.context, call.args[0]);
	                return next(call);
	            }
	        }
	    };
	}
	
	function serializeArgument(node, actionName, index, arg) {
	    if (arg instanceof Date)
	        return { $MST_DATE: arg.getTime() };
	    if (isPrimitive(arg))
	        return arg;
	    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
	    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
	    if (isStateTreeNode$$1(arg))
	        return serializeTheUnserializable("[MSTNode: " + getType$$1(arg).name + "]");
	    if (typeof arg === "function")
	        return serializeTheUnserializable("[function]");
	    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg))
	        return serializeTheUnserializable("[object " + ((arg && arg.constructor && arg.constructor.name) || "Complex Object") + "]");
	    try {
	        // Check if serializable, cycle free etc...
	        // MWE: there must be a better way....
	        JSON.stringify(arg); // or throws
	        return arg;
	    }
	    catch (e) {
	        return serializeTheUnserializable("" + e);
	    }
	}
	function deserializeArgument(adm, value) {
	    if (value && typeof value === "object" && "$MST_DATE" in value)
	        return new Date(value["$MST_DATE"]);
	    return value;
	}
	function serializeTheUnserializable(baseType) {
	    return {
	        $MST_UNSERIALIZABLE: true,
	        type: baseType
	    };
	}
	/**
	 * Applies an action or a series of actions in a single MobX transaction.
	 * Does not return any value
	 * Takes an action description as produced by the `onAction` middleware.
	 *
	 * @export
	 * @param {Object} target
	 * @param {IActionCall[]} actions
	 * @param {IActionCallOptions} [options]
	 */
	function applyAction$$1(target, actions) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (typeof actions !== "object")
	            fail("expected second argument to be an object or array, got " + actions + " instead");
	    }
	    mobx.runInAction(function () {
	        asArray(actions).forEach(function (action$$1) { return baseApplyAction(target, action$$1); });
	    });
	}
	function baseApplyAction(target, action$$1) {
	    var resolvedTarget = tryResolve$$1(target, action$$1.path || "");
	    if (!resolvedTarget)
	        return fail("Invalid action path: " + (action$$1.path || ""));
	    var node = getStateTreeNode$$1(resolvedTarget);
	    // Reserved functions
	    if (action$$1.name === "@APPLY_PATCHES") {
	        return applyPatch$$1.call(null, resolvedTarget, action$$1.args[0]);
	    }
	    if (action$$1.name === "@APPLY_SNAPSHOT") {
	        return applySnapshot$$1.call(null, resolvedTarget, action$$1.args[0]);
	    }
	    if (!(typeof resolvedTarget[action$$1.name] === "function"))
	        fail("Action '" + action$$1.name + "' does not exist in '" + node.path + "'");
	    return resolvedTarget[action$$1.name].apply(resolvedTarget, action$$1.args ? action$$1.args.map(function (v) { return deserializeArgument(node, v); }) : []);
	}
	/**
	 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
	 * Returns an recorder object with the following signature:
	 *
	 * @example
	 * export interface IActionRecorder {
	 *      // the recorded actions
	 *      actions: ISerializedActionCall[]
	 *      // stop recording actions
	 *      stop(): any
	 *      // apply all the recorded actions on the given object
	 *      replay(target: IStateTreeNode): any
	 * }
	 *
	 * @export
	 * @param {IStateTreeNode} subject
	 * @returns {IPatchRecorder}
	 */
	function recordActions$$1(subject) {
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(subject))
	            fail("expected first argument to be a mobx-state-tree node, got " + subject + " instead");
	    }
	    var recorder = {
	        actions: [],
	        stop: function () { return disposer(); },
	        replay: function (target) {
	            applyAction$$1(target, recorder.actions);
	        }
	    };
	    var disposer = onAction$$1(subject, recorder.actions.push.bind(recorder.actions));
	    return recorder;
	}
	/**
	 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
	 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
	 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
	 *
	 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
	 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
	 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
	 *
	 * @example
	 * const Todo = types.model({
	 *   task: types.string
	 * })
	 *
	 * const TodoStore = types.model({
	 *   todos: types.array(Todo)
	 * }).actions(self => ({
	 *   add(todo) {
	 *     self.todos.push(todo);
	 *   }
	 * }))
	 *
	 * const s = TodoStore.create({ todos: [] })
	 *
	 * let disposer = onAction(s, (call) => {
	 *   console.log(call);
	 * })
	 *
	 * s.add({ task: "Grab a coffee" })
	 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @param {(call: ISerializedActionCall) => void} listener
	 * @param attachAfter {boolean} (default false) fires the listener *after* the action has executed instead of before.
	 * @returns {IDisposer}
	 */
	function onAction$$1(target, listener, attachAfter) {
	    if (attachAfter === void 0) { attachAfter = false; }
	    // check all arguments
	    if (false) {
	        if (!isStateTreeNode$$1(target))
	            fail("expected first argument to be a mobx-state-tree node, got " + target + " instead");
	        if (!isRoot$$1(target))
	            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
	        if (!isProtected$$1(target))
	            console.warn("[mobx-state-tree] Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
	    }
	    function fireListener(rawCall) {
	        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
	            var sourceNode_1 = getStateTreeNode$$1(rawCall.context);
	            listener({
	                name: rawCall.name,
	                path: getRelativePathBetweenNodes$$1(getStateTreeNode$$1(target), sourceNode_1),
	                args: rawCall.args.map(function (arg, index) {
	                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
	                })
	            });
	        }
	    }
	    return addMiddleware$$1(target, attachAfter
	        ? function onActionMiddleware(rawCall, next) {
	            var res = next(rawCall);
	            fireListener(rawCall);
	            return res;
	        }
	        : function onActionMiddleware(rawCall, next) {
	            fireListener(rawCall);
	            return next(rawCall);
	        });
	}
	
	var nextActionId = 1;
	var currentActionContext = null;
	function getNextActionId$$1() {
	    return nextActionId++;
	}
	function runWithActionContext$$1(context, fn) {
	    var node = getStateTreeNode$$1(context.context);
	    var baseIsRunningAction = node._isRunningAction;
	    var prevContext = currentActionContext;
	    node.assertAlive();
	    node._isRunningAction = true;
	    currentActionContext = context;
	    try {
	        return runMiddleWares(node, context, fn);
	    }
	    finally {
	        currentActionContext = prevContext;
	        node._isRunningAction = baseIsRunningAction;
	    }
	}
	function getActionContext$$1() {
	    if (!currentActionContext)
	        return fail("Not running an action!");
	    return currentActionContext;
	}
	function createActionInvoker$$1(target, name, fn) {
	    var res = function () {
	        var id = getNextActionId$$1();
	        return runWithActionContext$$1({
	            type: "action",
	            name: name,
	            id: id,
	            args: argsToArray(arguments),
	            context: target,
	            tree: getRoot$$1(target),
	            rootId: currentActionContext ? currentActionContext.rootId : id,
	            parentId: currentActionContext ? currentActionContext.id : 0
	        }, fn);
	    };
	    res._isMSTAction = true;
	    return res;
	}
	/**
	 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
	 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
	 *
	 * For more details, see the [middleware docs](docs/middleware.md)
	 *
	 * @export
	 * @param {IStateTreeNode} target
	 * @param {(action: IRawActionCall, next: (call: IRawActionCall) => any) => any} middleware
	 * @returns {IDisposer}
	 */
	function addMiddleware$$1(target, handler, includeHooks) {
	    if (includeHooks === void 0) { includeHooks = true; }
	    var node = getStateTreeNode$$1(target);
	    if (false) {
	        if (!node.isProtectionEnabled)
	            console.warn("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
	    }
	    return node.addMiddleWare(handler, includeHooks);
	}
	/**
	 * Binds middleware to a specific action
	 *
	 * @example
	 * type.actions(self => {
	 *   function takeA____() {
	 *       self.toilet.donate()
	 *       self.wipe()
	 *       self.wipe()
	 *       self.toilet.flush()
	 *   }
	 *   return {
	 *     takeA____: decorate(atomic, takeA____)
	 *   }
	 * })
	 *
	 * @export
	 * @template T
	 * @param {IMiddlewareHandler} handler
	 * @param Function} fn
	 * @returns the original function
	 */
	function decorate$$1(handler, fn) {
	    var middleware = { handler: handler, includeHooks: true };
	    if (fn.$mst_middleware)
	        fn.$mst_middleware.push(middleware);
	    else
	        fn.$mst_middleware = [middleware];
	    return fn;
	}
	function collectMiddlewares(node, baseCall, fn) {
	    var middlewares = fn.$mst_middleware || EMPTY_ARRAY;
	    var n = node;
	    // Find all middlewares. Optimization: cache this?
	    while (n) {
	        if (n.middlewares)
	            middlewares = middlewares.concat(n.middlewares);
	        n = n.parent;
	    }
	    return middlewares;
	}
	function runMiddleWares(node, baseCall, originalFn) {
	    var middlewares = collectMiddlewares(node, baseCall, originalFn);
	    // Short circuit
	    if (!middlewares.length)
	        return mobx.action(originalFn).apply(null, baseCall.args);
	    var index = 0;
	    var result = null;
	    function runNextMiddleware(call) {
	        var middleware = middlewares[index++];
	        var handler = middleware && middleware.handler;
	        var nextInvoked = false;
	        var abortInvoked = false;
	        function next(call, callback) {
	            nextInvoked = true;
	            // the result can contain
	            // - the non manipulated return value from an action
	            // - the non manipulated abort value
	            // - one of the above but manipulated through the callback function
	            if (callback) {
	                result = callback(runNextMiddleware(call) || result);
	            }
	            else {
	                result = runNextMiddleware(call);
	            }
	        }
	        function abort(value) {
	            abortInvoked = true;
	            // overwrite the result
	            // can be manipulated through middlewares earlier in the queue using the callback fn
	            result = value;
	        }
	        var invokeHandler = function () {
	            handler(call, next, abort);
	            if (false) {
	                if (!nextInvoked && !abortInvoked) {
	                    var node_1 = getStateTreeNode$$1(call.tree);
	                    fail("Neither the next() nor the abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node_1
	                        .type.name + " was invoked.");
	                }
	                if (nextInvoked && abortInvoked) {
	                    var node_2 = getStateTreeNode$$1(call.tree);
	                    fail("The next() and abort() callback within the middleware " + handler.name + " for the action: \"" + call.name + "\" on the node: " + node_2
	                        .type.name + " were invoked.");
	                }
	            }
	            return result;
	        };
	        if (handler && middleware.includeHooks) {
	            return invokeHandler();
	        }
	        else if (handler && !middleware.includeHooks) {
	            if (HookNames$$1[call.name])
	                return runNextMiddleware(call);
	            return invokeHandler();
	        }
	        else {
	            return mobx.action(originalFn).apply(null, call.args);
	        }
	    }
	    return runNextMiddleware(baseCall);
	}
	
	function safeStringify(value) {
	    try {
	        return JSON.stringify(value);
	    }
	    catch (e) {
	        return "<Unserializable: " + e + ">";
	    }
	}
	function prettyPrintValue$$1(value) {
	    return typeof value === "function"
	        ? "<function" + (value.name ? " " + value.name : "") + ">"
	        : isStateTreeNode$$1(value) ? "<" + value + ">" : "`" + safeStringify(value) + "`";
	}
	function shortenPrintValue(valueInString) {
	    return valueInString.length < 280
	        ? valueInString
	        : valueInString.substring(0, 272) + "......" + valueInString.substring(valueInString.length - 8);
	}
	function toErrorString(error) {
	    var value = error.value;
	    var type = error.context[error.context.length - 1].type;
	    var fullPath = error.context
	        .map(function (_a) {
	        var path = _a.path;
	        return path;
	    })
	        .filter(function (path) { return path.length > 0; })
	        .join("/");
	    var pathPrefix = fullPath.length > 0 ? "at path \"/" + fullPath + "\" " : "";
	    var currentTypename = isStateTreeNode$$1(value)
	        ? "value of type " + getStateTreeNode$$1(value).type.name + ":"
	        : isPrimitive(value) ? "value" : "snapshot";
	    var isSnapshotCompatible = type && isStateTreeNode$$1(value) && type.is(getStateTreeNode$$1(value).snapshot);
	    return ("" + pathPrefix + currentTypename + " " + prettyPrintValue$$1(value) + " is not assignable " + (type
	        ? "to type: `" + type.name + "`"
	        : "") +
	        (error.message ? " (" + error.message + ")" : "") +
	        (type
	            ? isPrimitiveType$$1(type)
	                ? "."
	                : ", expected an instance of `" + type.name + "` or a snapshot like `" + type.describe() + "` instead." +
	                    (isSnapshotCompatible
	                        ? " (Note that a snapshot of the provided value is compatible with the targeted type)"
	                        : "")
	            : "."));
	}
	
	function getContextForPath$$1(context, path, type) {
	    return context.concat([{ path: path, type: type }]);
	}
	function typeCheckSuccess$$1() {
	    return EMPTY_ARRAY;
	}
	function typeCheckFailure$$1(context, value, message) {
	    return [{ context: context, value: value, message: message }];
	}
	function flattenTypeErrors$$1(errors) {
	    return errors.reduce(function (a, i) { return a.concat(i); }, []);
	}
	// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
	function typecheck$$1(type, value) {
	    // if not in dev-mode, do not even try to run typecheck. Everything is developer fault!
	    if (true)
	        return;
	    typecheckPublic$$1(type, value);
	}
	/**
	 * Run's the typechecker on the given type.
	 * Throws if the given value is not according the provided type specification.
	 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
	 *
	 * @alias typecheck
	 * @export
	 * @param {IType<any, any>} type
	 * @param {*} value
	 */
	function typecheckPublic$$1(type, value) {
	    var errors = type.validate(value, [{ path: "", type: type }]);
	    if (errors.length > 0) {
	        console.error("Failed to create \"" + type.name + "\" from:", value);
	        fail("Error while converting " + shortenPrintValue(prettyPrintValue$$1(value)) + " to `" + type.name + "`:\n\n    " + errors.map(toErrorString).join("\n    "));
	    }
	}
	
	var IdentifierCache$$1 = /** @class */ (function () {
	    function IdentifierCache$$1() {
	        // n.b. in cache all identifiers are normalized to strings
	        this.cache = mobx.observable.map();
	    }
	    IdentifierCache$$1.prototype.addNodeToCache = function (node) {
	        if (node.identifierAttribute) {
	            var identifier$$1 = "" + node.identifier;
	            if (!this.cache.has(identifier$$1)) {
	                this.cache.set(identifier$$1, mobx.observable.array([], mobxShallow));
	            }
	            var set = this.cache.get(identifier$$1);
	            if (set.indexOf(node) !== -1)
	                fail("Already registered");
	            set.push(node);
	        }
	        return this;
	    };
	    IdentifierCache$$1.prototype.mergeCache = function (node) {
	        var _this = this;
	        mobx.values(node.identifierCache.cache).forEach(function (nodes) {
	            return nodes.forEach(function (child) {
	                _this.addNodeToCache(child);
	            });
	        });
	    };
	    IdentifierCache$$1.prototype.notifyDied = function (node) {
	        if (node.identifierAttribute) {
	            var set = this.cache.get("" + node.identifier);
	            if (set)
	                set.remove(node);
	        }
	    };
	    IdentifierCache$$1.prototype.splitCache = function (node) {
	        var res = new IdentifierCache$$1();
	        var basePath = node.path;
	        mobx.values(this.cache).forEach(function (nodes) {
	            for (var i = nodes.length - 1; i >= 0; i--) {
	                if (nodes[i].path.indexOf(basePath) === 0) {
	                    res.addNodeToCache(nodes[i]);
	                    nodes.splice(i, 1);
	                }
	            }
	        });
	        return res;
	    };
	    IdentifierCache$$1.prototype.resolve = function (type, identifier$$1) {
	        var set = this.cache.get("" + identifier$$1);
	        if (!set)
	            return null;
	        var matches = set.filter(function (candidate) { return type.isAssignableFrom(candidate.type); });
	        switch (matches.length) {
	            case 0:
	                return null;
	            case 1:
	                return matches[0];
	            default:
	                return fail("Cannot resolve a reference to type '" + type.name + "' with id: '" + identifier$$1 + "' unambigously, there are multiple candidates: " + matches
	                    .map(function (n) { return n.path; })
	                    .join(", "));
	        }
	    };
	    return IdentifierCache$$1;
	}());
	
	// TODO: split into object and scalar node?
	function createNode$$1(type, parent, subpath, environment, initialValue, createNewInstance, finalizeNewInstance) {
	    if (createNewInstance === void 0) { createNewInstance = identity; }
	    if (finalizeNewInstance === void 0) { finalizeNewInstance = noop; }
	    if (isStateTreeNode$$1(initialValue)) {
	        var targetNode = initialValue.$treenode;
	        if (!targetNode.isRoot)
	            fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + (parent
	                ? parent.path
	                : "") + "/" + subpath + "', but it lives already at '" + targetNode.path + "'");
	        targetNode.setParent(parent, subpath);
	        return targetNode;
	    }
	    var storedValue = createNewInstance(initialValue);
	    if (type.shouldAttachNode) {
	        var node = new ObjectNode$$1(type, parent, subpath, environment, initialValue, storedValue, type.shouldAttachNode, finalizeNewInstance);
	        node.finalizeCreation();
	        return node;
	    }
	    return new ScalarNode$$1(type, parent, subpath, environment, initialValue, storedValue, type.shouldAttachNode, finalizeNewInstance);
	}
	function isNode$$1(value) {
	    return value instanceof ScalarNode$$1 || value instanceof ObjectNode$$1;
	}
	
	var NodeLifeCycle$$1;
	(function (NodeLifeCycle$$1) {
	    NodeLifeCycle$$1[NodeLifeCycle$$1["INITIALIZING"] = 0] = "INITIALIZING";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["CREATED"] = 1] = "CREATED";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["FINALIZED"] = 2] = "FINALIZED";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["DETACHING"] = 3] = "DETACHING";
	    NodeLifeCycle$$1[NodeLifeCycle$$1["DEAD"] = 4] = "DEAD"; // no coming back from this one
	})(NodeLifeCycle$$1 || (NodeLifeCycle$$1 = {}));
	/**
	 * Returns true if the given value is a node in a state tree.
	 * More precisely, that is, if the value is an instance of a
	 * `types.model`, `types.array` or `types.map`.
	 *
	 * @export
	 * @param {*} value
	 * @returns {value is IStateTreeNode}
	 */
	function isStateTreeNode$$1(value) {
	    return !!(value && value.$treenode);
	}
	function getStateTreeNode$$1(value) {
	    if (isStateTreeNode$$1(value))
	        return value.$treenode;
	    else
	        return fail("Value " + value + " is no MST Node");
	}
	
	function toJSON$$1() {
	    return getStateTreeNode$$1(this).snapshot;
	}
	var doubleDot = function (_) { return ".."; };
	function getRelativePathBetweenNodes$$1(base, target) {
	    // PRE condition target is (a child of) base!
	    if (base.root !== target.root)
	        fail("Cannot calculate relative path: objects '" + base + "' and '" + target + "' are not part of the same object tree");
	    var baseParts = splitJsonPath$$1(base.path);
	    var targetParts = splitJsonPath$$1(target.path);
	    var common = 0;
	    for (; common < baseParts.length; common++) {
	        if (baseParts[common] !== targetParts[common])
	            break;
	    }
	    // TODO: assert that no targetParts paths are "..", "." or ""!
	    return (baseParts
	        .slice(common)
	        .map(doubleDot)
	        .join("/") + joinJsonPath$$1(targetParts.slice(common)));
	}
	function resolveNodeByPath$$1(base, path, failIfResolveFails) {
	    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
	    return resolveNodeByPathParts$$1(base, splitJsonPath$$1(path), failIfResolveFails);
	}
	function resolveNodeByPathParts$$1(base, pathParts, failIfResolveFails) {
	    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
	    // counter part of getRelativePath
	    // note that `../` is not part of the JSON pointer spec, which is actually a prefix format
	    // in json pointer: "" = current, "/a", attribute a, "/" is attribute "" etc...
	    // so we treat leading ../ apart...
	    var current = base;
	    for (var i = 0; i < pathParts.length; i++) {
	        var part = pathParts[i];
	        if (part === "") {
	            current = current.root;
	            continue;
	        }
	        else if (part === "..") {
	            current = current.parent;
	            if (current)
	                continue; // not everything has a parent
	        }
	        else if (part === "." || part === "") {
	            // '/bla' or 'a//b' splits to empty strings
	            continue;
	        }
	        else if (current) {
	            if (current instanceof ScalarNode$$1) {
	                // check if the value of a scalar resolves to a state tree node (e.g. references)
	                // then we can continue resolving...
	                try {
	                    var value = current.value;
	                    if (isStateTreeNode$$1(value)) {
	                        current = getStateTreeNode$$1(value);
	                        // fall through
	                    }
	                }
	                catch (e) {
	                    if (!failIfResolveFails) {
	                        return undefined;
	                    }
	                    throw e;
	                }
	            }
	            if (current instanceof ObjectNode$$1) {
	                var subType = current.getChildType(part);
	                if (subType) {
	                    current = current.getChildNode(part);
	                    if (current)
	                        continue;
	                }
	            }
	        }
	        if (failIfResolveFails)
	            return fail("Could not resolve '" + part + "' in path '" + (joinJsonPath$$1(pathParts.slice(0, i)) ||
	                "/") + "' while resolving '" + joinJsonPath$$1(pathParts) + "'");
	        else
	            return undefined;
	    }
	    return current;
	}
	
	// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
	/*
	    All contents of this file are deprecated.
	
	    The term `process` has been replaced with `flow` to avoid conflicts with the
	    global `process` object.
	
	    Refer to `flow.ts` for any further changes to this implementation.
	*/
	var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. " +
	    "Note that the middleware event types starting with `process` now start with `flow`.";
	/**
	 * @deprecated has been renamed to `flow()`.
	 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
	 * Note that the middleware event types starting with `process` now start with `flow`.
	 *
	 * @export
	 * @alias process
	 * @returns {Promise}
	 */
	function process$1$$1(asyncAction) {
	    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
	    return flow(asyncAction);
	}
	
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	var mobxShallow = { deep: false };
	Object.freeze(mobxShallow);
	function fail(message) {
	    if (message === void 0) { message = "Illegal state"; }
	    throw new Error("[mobx-state-tree] " + message);
	}
	function identity(_) {
	    return _;
	}
	
	function noop() { }
	function isArray(val) {
	    return !!(Array.isArray(val) || mobx.isObservableArray(val));
	}
	function asArray(val) {
	    if (!val)
	        return EMPTY_ARRAY;
	    if (isArray(val))
	        return val;
	    return [val];
	}
	function extend(a) {
	    var b = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        b[_i - 1] = arguments[_i];
	    }
	    for (var i = 0; i < b.length; i++) {
	        var current = b[i];
	        for (var key in current)
	            a[key] = current[key];
	    }
	    return a;
	}
	
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function isMutable(value) {
	    return (value !== null &&
	        typeof value === "object" &&
	        !(value instanceof Date) &&
	        !(value instanceof RegExp));
	}
	function isPrimitive(value) {
	    if (value === null || value === undefined)
	        return true;
	    if (typeof value === "string" ||
	        typeof value === "number" ||
	        typeof value === "boolean" ||
	        value instanceof Date)
	        return true;
	    return false;
	}
	/*
	 * Freeze a value and return it (if not in production)
	 */
	function freeze(value) {
	    if (true)
	        return value;
	    return isPrimitive(value) ? value : Object.freeze(value);
	}
	/*
	 * Recursively freeze a value (if not in production)
	 */
	function deepFreeze(value) {
	    if (true)
	        return value;
	    freeze(value);
	    if (isPlainObject(value)) {
	        Object.keys(value).forEach(function (propKey) {
	            if (!isPrimitive(value[propKey]) &&
	                !Object.isFrozen(value[propKey])) {
	                deepFreeze(value[propKey]);
	            }
	        });
	    }
	    return value;
	}
	function isSerializable(value) {
	    return typeof value !== "function";
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenWritableProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addReadOnlyProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: true,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function remove(collection, item) {
	    var idx = collection.indexOf(item);
	    if (idx !== -1)
	        collection.splice(idx, 1);
	}
	function registerEventHandler(handlers, handler) {
	    handlers.push(handler);
	    return function () {
	        remove(handlers, handler);
	    };
	}
	
	function argsToArray(args) {
	    var res = new Array(args.length);
	    for (var i = 0; i < args.length; i++)
	        res[i] = args[i];
	    return res;
	}
	var deprecated = function () { };
	deprecated = function (id, message) {
	    // skip if running production
	    if (true)
	        return;
	    // warn if hasn't been warned before
	    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) {
	        console.warn("[mobx-state-tree] Deprecation warning: " + message);
	    }
	    // mark as warned to avoid duplicate warn message
	    if (deprecated.ids)
	        deprecated.ids[id] = true;
	};
	deprecated.ids = {};
	
	// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
	/**
	 * See [asynchronous actions](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/async-actions.md).
	 *
	 * @export
	 * @alias flow
	 * @returns {Promise}
	 */
	function flow(asyncAction) {
	    return createFlowSpawner(asyncAction.name, asyncAction);
	}
	function createFlowSpawner(name, generator) {
	    var spawner = function flowSpawner() {
	        // Implementation based on https://github.com/tj/co/blob/master/index.js
	        var runId = getNextActionId$$1();
	        var baseContext = getActionContext$$1();
	        var args = arguments;
	        function wrap(fn, type, arg) {
	            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
	            runWithActionContext$$1({
	                name: name,
	                type: type,
	                id: runId,
	                args: [arg],
	                tree: baseContext.tree,
	                context: baseContext.context,
	                parentId: baseContext.id,
	                rootId: baseContext.rootId
	            }, fn);
	        }
	        return new Promise(function (resolve, reject) {
	            var gen;
	            var init = function asyncActionInit() {
	                gen = generator.apply(null, arguments);
	                onFulfilled(undefined); // kick off the flow
	            };
	            init.$mst_middleware = spawner.$mst_middleware;
	            runWithActionContext$$1({
	                name: name,
	                type: "flow_spawn",
	                id: runId,
	                args: argsToArray(args),
	                tree: baseContext.tree,
	                context: baseContext.context,
	                parentId: baseContext.id,
	                rootId: baseContext.rootId
	            }, init);
	            function onFulfilled(res) {
	                var ret;
	                try {
	                    // prettier-ignore
	                    wrap(function (r) { ret = gen.next(r); }, "flow_resume", res);
	                }
	                catch (e) {
	                    // prettier-ignore
	                    setImmediate(function () {
	                        wrap(function (r) { reject(e); }, "flow_throw", e);
	                    });
	                    return;
	                }
	                next(ret);
	                return;
	            }
	            function onRejected(err) {
	                var ret;
	                try {
	                    // prettier-ignore
	                    wrap(function (r) { ret = gen.throw(r); }, "flow_resume_error", err); // or yieldError?
	                }
	                catch (e) {
	                    // prettier-ignore
	                    setImmediate(function () {
	                        wrap(function (r) { reject(e); }, "flow_throw", e);
	                    });
	                    return;
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret.done) {
	                    // prettier-ignore
	                    setImmediate(function () {
	                        wrap(function (r) { resolve(r); }, "flow_return", ret.value);
	                    });
	                    return;
	                }
	                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
	                if (!ret.value || typeof ret.value.then !== "function")
	                    fail("Only promises can be yielded to `async`, got: " + ret);
	                return ret.value.then(onFulfilled, onRejected);
	            }
	        });
	    };
	    return spawner;
	}
	
	function splitPatch$$1(patch) {
	    if (!("oldValue" in patch))
	        fail("Patches without `oldValue` field cannot be inversed");
	    return [stripPatch$$1(patch), invertPatch(patch)];
	}
	function stripPatch$$1(patch) {
	    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
	    // this removes the ability to undo the patch
	    switch (patch.op) {
	        case "add":
	            return { op: "add", path: patch.path, value: patch.value };
	        case "remove":
	            return { op: "remove", path: patch.path };
	        case "replace":
	            return { op: "replace", path: patch.path, value: patch.value };
	    }
	}
	function invertPatch(patch) {
	    switch (patch.op) {
	        case "add":
	            return {
	                op: "remove",
	                path: patch.path
	            };
	        case "remove":
	            return {
	                op: "add",
	                path: patch.path,
	                value: patch.oldValue
	            };
	        case "replace":
	            return {
	                op: "replace",
	                path: patch.path,
	                value: patch.oldValue
	            };
	    }
	}
	// simple simple simple check
	function isNumber(x) {
	    return typeof x === "number";
	}
	/**
	 * escape slashes and backslashes
	 * http://tools.ietf.org/html/rfc6901
	 */
	function escapeJsonPath$$1(str) {
	    if (isNumber(str) === true) {
	        return "" + str;
	    }
	    return str.replace(/~/g, "~1").replace(/\//g, "~0");
	}
	/**
	 * unescape slashes and backslashes
	 */
	function unescapeJsonPath$$1(str) {
	    return str.replace(/~0/g, "/").replace(/~1/g, "~");
	}
	/**
	 * Generates a json-path compliant json path from path parts
	 *
	 * @export
	 * @param {string[]} path
	 * @returns {string}
	 */
	function joinJsonPath$$1(path) {
	    // `/` refers to property with an empty name, while `` refers to root itself!
	    if (path.length === 0)
	        return "";
	    return "/" + path.map(escapeJsonPath$$1).join("/");
	}
	/**
	 * Splits and decodes a json path into several parts
	 *
	 * @export
	 * @param {string} path
	 * @returns {string[]}
	 */
	function splitJsonPath$$1(path) {
	    // `/` refers to property with an empty name, while `` refers to root itself!
	    var parts = path.split("/").map(unescapeJsonPath$$1);
	    // path '/a/b/c' -> a b c
	    // path '../../b/c -> .. .. b c
	    return parts[0] === "" ? parts.slice(1) : parts;
	}
	
	function mapToString$$1() {
	    return getStateTreeNode$$1(this) + "(" + this.size + " items)";
	}
	var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
	function put(value) {
	    if (!!!value)
	        fail("Map.put cannot be used to set empty values");
	    if (isStateTreeNode$$1(value)) {
	        var node = getStateTreeNode$$1(value);
	        if (false) {
	            if (!node.identifierAttribute)
	                return fail(needsIdentifierError);
	        }
	        this.set("" + node.identifier, node.value);
	        return this;
	    }
	    else if (!isMutable(value)) {
	        return fail("Map.put can only be used to store complex values");
	    }
	    else {
	        var mapType = getStateTreeNode$$1(this).type;
	        if (mapType.identifierMode === MapIdentifierMode$$1.NO)
	            return fail(needsIdentifierError);
	        if (mapType.identifierMode === MapIdentifierMode$$1.YES) {
	            this.set("" + value[mapType.identifierAttribute], value);
	            return this;
	        }
	        // we don't know the identifier attr yet, so we have to create the instance already to be able to determine
	        // luckily, needs to happen only once
	        var node = getStateTreeNode$$1(mapType.subType.create(value)); // FIXME: this will unecessarly first create and after that attach.
	        if (!node.identifierAttribute)
	            return fail(needsIdentifierError);
	        this.set("" + node.value[node.identifierAttribute], node.value);
	        return this;
	    }
	}
	var MapIdentifierMode$$1;
	(function (MapIdentifierMode$$1) {
	    MapIdentifierMode$$1[MapIdentifierMode$$1["UNKNOWN"] = 0] = "UNKNOWN";
	    MapIdentifierMode$$1[MapIdentifierMode$$1["YES"] = 1] = "YES";
	    MapIdentifierMode$$1[MapIdentifierMode$$1["NO"] = 2] = "NO";
	})(MapIdentifierMode$$1 || (MapIdentifierMode$$1 = {}));
	var MapType$$1 = /** @class */ (function (_super) {
	    __extends(MapType$$1, _super);
	    function MapType$$1(name, subType) {
	        var _this = _super.call(this, name) || this;
	        _this.shouldAttachNode = true;
	        _this.identifierMode = MapIdentifierMode$$1.UNKNOWN;
	        _this.identifierAttribute = undefined;
	        _this.flags = TypeFlags$$1.Map;
	        _this.createNewInstance = function () {
	            // const identifierAttr = getIdentifierAttribute(this.subType)
	            var map$$1 = mobx.observable.map({}, mobxShallow);
	            addHiddenFinalProp(map$$1, "put", put);
	            addHiddenFinalProp(map$$1, "toString", mapToString$$1);
	            return map$$1;
	        };
	        _this.finalizeNewInstance = function (node, snapshot) {
	            var objNode = node;
	            var instance = objNode.storedValue;
	            mobx._interceptReads(instance, objNode.unbox);
	            mobx.intercept(instance, function (c) { return _this.willChange(c); });
	            objNode.applySnapshot(snapshot);
	            mobx.observe(instance, _this.didChange);
	        };
	        _this.subType = subType;
	        return _this;
	    }
	    MapType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot, this.createNewInstance, this.finalizeNewInstance);
	    };
	    MapType$$1.prototype.describe = function () {
	        return "Map<string, " + this.subType.describe() + ">";
	    };
	    MapType$$1.prototype.getChildren = function (node) {
	        // return (node.storedValue as ObservableMap<any>).values()
	        return mobx.values(node.storedValue);
	    };
	    MapType$$1.prototype.getChildNode = function (node, key) {
	        var childNode = node.storedValue.get("" + key);
	        if (!childNode)
	            fail("Not a child " + key);
	        return childNode;
	    };
	    MapType$$1.prototype.willChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        var key = "" + change.name;
	        node.assertWritable();
	        switch (change.type) {
	            case "update":
	                {
	                    var newValue = change.newValue;
	                    var oldValue = change.object.get(key);
	                    if (newValue === oldValue)
	                        return null;
	                    typecheck$$1(this.subType, newValue);
	                    change.newValue = this.subType.reconcile(node.getChildNode(key), change.newValue);
	                    this.processIdentifier(key, change.newValue);
	                }
	                break;
	            case "add":
	                {
	                    typecheck$$1(this.subType, change.newValue);
	                    change.newValue = this.subType.instantiate(node, key, undefined, change.newValue);
	                    this.processIdentifier(key, change.newValue);
	                }
	                break;
	        }
	        return change;
	    };
	    MapType$$1.prototype.processIdentifier = function (expected, node) {
	        if (node instanceof ObjectNode$$1) {
	            // identifier cannot be determined up front, as they might need to go through unions etc
	            // but for maps, we do want them to be regular, and consistently used.
	            if (this.identifierMode === MapIdentifierMode$$1.UNKNOWN) {
	                this.identifierMode =
	                    node.identifierAttribute !== undefined
	                        ? MapIdentifierMode$$1.YES
	                        : MapIdentifierMode$$1.NO;
	                this.identifierAttribute = node.identifierAttribute;
	            }
	            if (node.identifierAttribute !== this.identifierAttribute)
	                // both undefined if type is NO
	                fail("The objects in a map should all have the same identifier attribute, expected '" + this
	                    .identifierAttribute + "', but child of type '" + node.type
	                    .name + "' declared attribute '" + node.identifierAttribute + "' as identifier");
	            if (this.identifierMode === MapIdentifierMode$$1.YES) {
	                var identifier$$1 = "" + node.identifier; // 'cause snapshots always have their identifiers as strings. blegh..
	                if (identifier$$1 !== expected)
	                    fail("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '" + identifier$$1 + "', but expected: '" + expected + "'");
	            }
	        }
	    };
	    MapType$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    MapType$$1.prototype.getSnapshot = function (node) {
	        var res = {};
	        node.getChildren().forEach(function (childNode) {
	            res[childNode.subpath] = childNode.snapshot;
	        });
	        return res;
	    };
	    MapType$$1.prototype.didChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        switch (change.type) {
	            case "update":
	                return void node.emitPatch({
	                    op: "replace",
	                    path: escapeJsonPath$$1(change.name),
	                    value: change.newValue.snapshot,
	                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
	                }, node);
	            case "add":
	                return void node.emitPatch({
	                    op: "add",
	                    path: escapeJsonPath$$1(change.name),
	                    value: change.newValue.snapshot,
	                    oldValue: undefined
	                }, node);
	            case "delete":
	                // a node got deleted, get the old snapshot and make the node die
	                var oldSnapshot = change.oldValue.snapshot;
	                change.oldValue.die();
	                // emit the patch
	                return void node.emitPatch({ op: "remove", path: escapeJsonPath$$1(change.name), oldValue: oldSnapshot }, node);
	        }
	    };
	    MapType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        var target = node.storedValue;
	        switch (patch.op) {
	            case "add":
	            case "replace":
	                target.set(subpath, patch.value);
	                break;
	            case "remove":
	                target.delete(subpath);
	                break;
	        }
	    };
	    MapType$$1.prototype.applySnapshot = function (node, snapshot) {
	        typecheck$$1(this, snapshot);
	        var target = node.storedValue;
	        var currentKeys = {};
	        Array.from(target.keys()).forEach(function (key) {
	            currentKeys[key] = false;
	        });
	        // Don't use target.replace, as it will throw all existing items first
	        for (var key in snapshot) {
	            target.set("" + key, snapshot[key]);
	            currentKeys["" + key] = true;
	        }
	        Object.keys(currentKeys).forEach(function (key) {
	            if (currentKeys[key] === false)
	                target.delete(key);
	        });
	    };
	    MapType$$1.prototype.getChildType = function (key) {
	        return this.subType;
	    };
	    MapType$$1.prototype.isValidSnapshot = function (value, context) {
	        var _this = this;
	        if (!isPlainObject(value)) {
	            return typeCheckFailure$$1(context, value, "Value is not a plain object");
	        }
	        return flattenTypeErrors$$1(Object.keys(value).map(function (path) {
	            return _this.subType.validate(value[path], getContextForPath$$1(context, path, _this.subType));
	        }));
	    };
	    MapType$$1.prototype.getDefaultSnapshot = function () {
	        return {};
	    };
	    MapType$$1.prototype.removeChild = function (node, subpath) {
	        
	        node.storedValue.delete(subpath);
	    };
	    __decorate([
	        mobx.action
	    ], MapType$$1.prototype, "applySnapshot", null);
	    return MapType$$1;
	}(ComplexType$$1));
	/**
	 * Creates a key based collection type who's children are all of a uniform declared type.
	 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
	 *
	 * This type will always produce [observable maps](https://mobx.js.org/refguide/map.html)
	 *
	 * @example
	 * const Todo = types.model({
	 *   id: types.identifier(types.number),
	 *   task: types.string
	 * })
	 *
	 * const TodoStore = types.model({
	 *   todos: types.map(Todo)
	 * })
	 *
	 * const s = TodoStore.create({ todos: {} })
	 * unprotect(s)
	 * s.todos.set(17, { task: "Grab coffee", id: 17 })
	 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
	 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
	 *
	 * @export
	 * @alias types.map
	 * @param {IType<S, T>} subtype
	 * @returns {IComplexType<S[], IObservableArray<T>>}
	 */
	function map$$1(subtype) {
	    return new MapType$$1("map<string, " + subtype.name + ">", subtype);
	}
	
	function arrayToString$$1() {
	    return getStateTreeNode$$1(this) + "(" + this.length + " items)";
	}
	var ArrayType$$1 = /** @class */ (function (_super) {
	    __extends(ArrayType$$1, _super);
	    function ArrayType$$1(name, subType) {
	        var _this = _super.call(this, name) || this;
	        _this.shouldAttachNode = true;
	        _this.flags = TypeFlags$$1.Array;
	        _this.createNewInstance = function () {
	            var array$$1 = mobx.observable.array([], mobxShallow);
	            addHiddenFinalProp(array$$1, "toString", arrayToString$$1);
	            return array$$1;
	        };
	        _this.finalizeNewInstance = function (node, snapshot) {
	            var objNode = node;
	            var instance = objNode.storedValue;
	            mobx._getAdministration(instance).dehancer = objNode.unbox;
	            mobx.intercept(instance, function (change) { return _this.willChange(change); });
	            objNode.applySnapshot(snapshot);
	            mobx.observe(instance, _this.didChange);
	        };
	        _this.subType = subType;
	        return _this;
	    }
	    ArrayType$$1.prototype.describe = function () {
	        return this.subType.describe() + "[]";
	    };
	    ArrayType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot, this.createNewInstance, this.finalizeNewInstance);
	    };
	    ArrayType$$1.prototype.getChildren = function (node) {
	        return node.storedValue.peek();
	    };
	    ArrayType$$1.prototype.getChildNode = function (node, key) {
	        var index = parseInt(key, 10);
	        if (index < node.storedValue.length)
	            return node.storedValue[index];
	        return fail("Not a child: " + key);
	    };
	    ArrayType$$1.prototype.willChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        node.assertWritable();
	        var childNodes = node.getChildren();
	        switch (change.type) {
	            case "update":
	                if (change.newValue === change.object[change.index])
	                    return null;
	                change.newValue = reconcileArrayChildren(node, this.subType, [childNodes[change.index]], [change.newValue], [change.index])[0];
	                break;
	            case "splice":
	                var index_1 = change.index, removedCount = change.removedCount, added = change.added;
	                change.added = reconcileArrayChildren(node, this.subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function (_, i) { return index_1 + i; }));
	                // update paths of remaining items
	                for (var i = index_1 + removedCount; i < childNodes.length; i++) {
	                    childNodes[i].setParent(node, "" + (i + added.length - removedCount));
	                }
	                break;
	        }
	        return change;
	    };
	    ArrayType$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    ArrayType$$1.prototype.getSnapshot = function (node) {
	        return node.getChildren().map(function (childNode) { return childNode.snapshot; });
	    };
	    ArrayType$$1.prototype.didChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        switch (change.type) {
	            case "update":
	                return void node.emitPatch({
	                    op: "replace",
	                    path: "" + change.index,
	                    value: change.newValue.snapshot,
	                    oldValue: change.oldValue ? change.oldValue.snapshot : undefined
	                }, node);
	            case "splice":
	                for (var i = change.removedCount - 1; i >= 0; i--)
	                    node.emitPatch({
	                        op: "remove",
	                        path: "" + (change.index + i),
	                        oldValue: change.removed[i].snapshot
	                    }, node);
	                for (var i = 0; i < change.addedCount; i++)
	                    node.emitPatch({
	                        op: "add",
	                        path: "" + (change.index + i),
	                        value: node.getChildNode("" + (change.index + i)).snapshot,
	                        oldValue: undefined
	                    }, node);
	                return;
	        }
	    };
	    ArrayType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        var target = node.storedValue;
	        var index = subpath === "-" ? target.length : parseInt(subpath);
	        switch (patch.op) {
	            case "replace":
	                target[index] = patch.value;
	                break;
	            case "add":
	                target.splice(index, 0, patch.value);
	                break;
	            case "remove":
	                target.splice(index, 1);
	                break;
	        }
	    };
	    ArrayType$$1.prototype.applySnapshot = function (node, snapshot) {
	        typecheck$$1(this, snapshot);
	        var target = node.storedValue;
	        target.replace(snapshot);
	    };
	    ArrayType$$1.prototype.getChildType = function (key) {
	        return this.subType;
	    };
	    ArrayType$$1.prototype.isValidSnapshot = function (value, context) {
	        var _this = this;
	        if (!isArray(value)) {
	            return typeCheckFailure$$1(context, value, "Value is not an array");
	        }
	        return flattenTypeErrors$$1(value.map(function (item, index) {
	            return _this.subType.validate(item, getContextForPath$$1(context, "" + index, _this.subType));
	        }));
	    };
	    ArrayType$$1.prototype.getDefaultSnapshot = function () {
	        return [];
	    };
	    ArrayType$$1.prototype.removeChild = function (node, subpath) {
	        node.storedValue.splice(parseInt(subpath, 10), 1);
	    };
	    __decorate([
	        mobx.action
	    ], ArrayType$$1.prototype, "applySnapshot", null);
	    return ArrayType$$1;
	}(ComplexType$$1));
	/**
	 * Creates an index based collection type who's children are all of a uniform declared type.
	 *
	 * This type will always produce [observable arrays](https://mobx.js.org/refguide/array.html)
	 *
	 * @example
	 * const Todo = types.model({
	 *   task: types.string
	 * })
	 *
	 * const TodoStore = types.model({
	 *   todos: types.array(Todo)
	 * })
	 *
	 * const s = TodoStore.create({ todos: [] })
	 * unprotect(s) // needed to allow modifying outside of an action
	 * s.todos.push({ task: "Grab coffee" })
	 * console.log(s.todos[0]) // prints: "Grab coffee"
	 *
	 * @export
	 * @alias types.array
	 * @param {IType<S, T>} subtype
	 * @returns {IComplexType<S[], IObservableArray<T>>}
	 */
	function array$$1(subtype) {
	    if (false) {
	        if (!isType$$1(subtype))
	            fail("expected a mobx-state-tree type as first argument, got " + subtype + " instead");
	    }
	    return new ArrayType$$1(subtype.name + "[]", subtype);
	}
	function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
	    var oldNode, newValue, hasNewNode = false, oldMatch = undefined;
	    for (var i = 0;; i++) {
	        hasNewNode = i <= newValues.length - 1;
	        oldNode = oldNodes[i];
	        newValue = hasNewNode ? newValues[i] : undefined;
	        // for some reason, instead of newValue we got a node, fallback to the storedValue
	        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
	        if (isNode$$1(newValue))
	            newValue = newValue.storedValue;
	        // both are empty, end
	        if (!oldNode && !hasNewNode) {
	            break;
	            // new one does not exists, old one dies
	        }
	        else if (!hasNewNode) {
	            oldNode.die();
	            oldNodes.splice(i, 1);
	            i--;
	            // there is no old node, create it
	        }
	        else if (!oldNode) {
	            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
	            if (isStateTreeNode$$1(newValue) && getStateTreeNode$$1(newValue).parent === parent) {
	                // this node is owned by this parent, but not in the reconcilable set, so it must be double
	                fail("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '" + parent.path + "/" + newPaths[i] + "', but it lives already at '" + getStateTreeNode$$1(newValue).path + "'");
	            }
	            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue));
	            // both are the same, reconcile
	        }
	        else if (areSame(oldNode, newValue)) {
	            oldNodes[i] = valueAsNode(childType, parent, "" + newPaths[i], newValue, oldNode);
	            // nothing to do, try to reorder
	        }
	        else {
	            oldMatch = undefined;
	            // find a possible candidate to reuse
	            for (var j = i; j < oldNodes.length; j++) {
	                if (areSame(oldNodes[j], newValue)) {
	                    oldMatch = oldNodes.splice(j, 1)[0];
	                    break;
	                }
	            }
	            oldNodes.splice(i, 0, valueAsNode(childType, parent, "" + newPaths[i], newValue, oldMatch));
	        }
	    }
	    return oldNodes;
	}
	// convert a value to a node at given parent and subpath. attempts to reuse old node if possible and given
	function valueAsNode(childType, parent, subpath, newValue, oldNode) {
	    // ensure the value is valid-ish
	    typecheck$$1(childType, newValue);
	    // the new value has a MST node
	    if (isStateTreeNode$$1(newValue)) {
	        var childNode_1 = getStateTreeNode$$1(newValue);
	        childNode_1.assertAlive();
	        // the node lives here
	        if (childNode_1.parent !== null && childNode_1.parent === parent) {
	            childNode_1.setParent(parent, subpath);
	            if (oldNode && oldNode !== childNode_1)
	                oldNode.die();
	            return childNode_1;
	        }
	    }
	    // there is old node and new one is a value/snapshot
	    if (oldNode) {
	        var childNode_2 = childType.reconcile(oldNode, newValue);
	        childNode_2.setParent(parent, subpath);
	        return childNode_2;
	    }
	    // nothing to do, create from scratch
	    var childNode = childType.instantiate(parent, subpath, parent._environment, newValue);
	    return childNode;
	}
	// given a value
	function areSame(oldNode, newValue) {
	    // the new value has the same node
	    if (isStateTreeNode$$1(newValue)) {
	        return getStateTreeNode$$1(newValue) === oldNode;
	    }
	    // the provided value is the snapshot of the old node
	    if (isMutable(newValue) && oldNode.snapshot === newValue)
	        return true;
	    // new value is a snapshot with the correct identifier
	    if (oldNode instanceof ObjectNode$$1 &&
	        oldNode.identifier !== null &&
	        oldNode.identifierAttribute &&
	        isPlainObject(newValue) &&
	        newValue[oldNode.identifierAttribute] === oldNode.identifier)
	        return true;
	    return false;
	}
	
	var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
	var HookNames$$1;
	(function (HookNames$$1) {
	    HookNames$$1["afterCreate"] = "afterCreate";
	    HookNames$$1["afterAttach"] = "afterAttach";
	    HookNames$$1["postProcessSnapshot"] = "postProcessSnapshot";
	    HookNames$$1["beforeDetach"] = "beforeDetach";
	    HookNames$$1["beforeDestroy"] = "beforeDestroy";
	})(HookNames$$1 || (HookNames$$1 = {}));
	function objectTypeToString() {
	    return getStateTreeNode$$1(this).toString();
	}
	var defaultObjectOptions = {
	    name: "AnonymousModel",
	    properties: {},
	    initializers: EMPTY_ARRAY
	};
	function toPropertiesObject(properties) {
	    // loop through properties and ensures that all items are types
	    return Object.keys(properties).reduce(function (properties, key) {
	        // warn if user intended a HOOK
	        if (key in HookNames$$1)
	            return fail("Hook '" + key + "' was defined as property. Hooks should be defined as part of the actions");
	        // the user intended to use a view
	        var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	        if ("get" in descriptor) {
	            fail("Getters are not supported as properties. Please use views instead");
	        }
	        // undefined and null are not valid
	        var value = descriptor.value;
	        if (value === null || value === undefined) {
	            fail("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
	            // its a primitive, convert to its type
	        }
	        else if (isPrimitive(value)) {
	            return Object.assign({}, properties, (_a = {},
	                _a[key] = optional$$1(getPrimitiveFactoryFromValue$$1(value), value),
	                _a));
	            // its already a type
	        }
	        else if (isType$$1(value)) {
	            return properties;
	            // its a function, maybe the user wanted a view?
	        }
	        else if (typeof value === "function") {
	            fail("Functions are not supported as properties, use views instead");
	            // no other complex values
	        }
	        else if (typeof value === "object") {
	            fail("In property '" + key + "': base models should not contain complex values: '" + value + "'");
	            // WTF did you pass in mate?
	        }
	        else {
	            fail("Unexpected value for property '" + key + "'");
	        }
	        var _a;
	    }, properties);
	}
	var ModelType$$1 = /** @class */ (function (_super) {
	    __extends(ModelType$$1, _super);
	    function ModelType$$1(opts) {
	        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
	        _this.flags = TypeFlags$$1.Object;
	        _this.shouldAttachNode = true;
	        _this.properties = {};
	        _this.createNewInstance = function () {
	            var instance = mobx.observable.object(EMPTY_OBJECT, EMPTY_OBJECT, mobxShallow);
	            addHiddenFinalProp(instance, "toString", objectTypeToString);
	            return instance;
	        };
	        _this.finalizeNewInstance = function (node, snapshot) {
	            var objNode = node;
	            var instance = objNode.storedValue;
	            _this.forAllProps(function (name, type) {
	                mobx.extendObservable(instance, (_a = {},
	                    _a[name] = type.instantiate(objNode, name, objNode._environment, snapshot[name]),
	                    _a), EMPTY_OBJECT, mobxShallow);
	                mobx._interceptReads(instance, name, objNode.unbox);
	                var _a;
	            });
	            _this.initializers.reduce(function (self, fn) { return fn(self); }, instance);
	            mobx.intercept(instance, function (change) { return _this.willChange(change); });
	            mobx.observe(instance, _this.didChange);
	        };
	        _this.didChange = function (change) {
	            if (!_this.properties[change.name]) {
	                // don't emit patches for volatile state
	                return;
	            }
	            var node = getStateTreeNode$$1(change.object);
	            var oldValue = change.oldValue ? change.oldValue.snapshot : undefined;
	            node.emitPatch({
	                op: "replace",
	                path: escapeJsonPath$$1(change.name),
	                value: change.newValue.snapshot,
	                oldValue: oldValue
	            }, node);
	        };
	        var name = opts.name || defaultObjectOptions.name;
	        // TODO: this test still needed?
	        if (!/^\w[\w\d_]*$/.test(name))
	            fail("Typename should be a valid identifier: " + name);
	        Object.assign(_this, defaultObjectOptions, opts);
	        // ensures that any default value gets converted to its related type
	        _this.properties = toPropertiesObject(_this.properties);
	        freeze(_this.properties); // make sure nobody messes with it
	        return _this;
	    }
	    Object.defineProperty(ModelType$$1.prototype, "propertyNames", {
	        get: function () {
	            return Object.keys(this.properties);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModelType$$1.prototype.cloneAndEnhance = function (opts) {
	        return new ModelType$$1({
	            name: opts.name || this.name,
	            properties: Object.assign({}, this.properties, opts.properties),
	            initializers: this.initializers.concat(opts.initializers || []),
	            preProcessor: opts.preProcessor || this.preProcessor
	        });
	    };
	    ModelType$$1.prototype.actions = function (fn) {
	        var _this = this;
	        var actionInitializer = function (self) {
	            _this.instantiateActions(self, fn(self));
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [actionInitializer] });
	    };
	    ModelType$$1.prototype.instantiateActions = function (self, actions) {
	        // check if return is correct
	        if (!isPlainObject(actions))
	            fail("actions initializer should return a plain object containing actions");
	        // bind actions to the object created
	        Object.keys(actions).forEach(function (name) {
	            // warn if preprocessor was given
	            if (name === PRE_PROCESS_SNAPSHOT)
	                return fail("Cannot define action '" + PRE_PROCESS_SNAPSHOT + "', it should be defined using 'type.preProcessSnapshot(fn)' instead");
	            // apply hook composition
	            var action$$1 = actions[name];
	            var baseAction = self[name];
	            if (name in HookNames$$1 && baseAction) {
	                var specializedAction_1 = action$$1;
	                if (name === HookNames$$1.postProcessSnapshot)
	                    action$$1 = function (snapshot) { return specializedAction_1(baseAction(snapshot)); };
	                else
	                    action$$1 = function () {
	                        baseAction.apply(null, arguments);
	                        specializedAction_1.apply(null, arguments);
	                    };
	            }
	            // See #646, allow models to be mocked
	            
	            ( true ? addHiddenFinalProp : addHiddenWritableProp)(self, name, createActionInvoker$$1(self, name, action$$1));
	            return;
	        });
	    };
	    ModelType$$1.prototype.named = function (name) {
	        return this.cloneAndEnhance({ name: name });
	    };
	    ModelType$$1.prototype.props = function (properties) {
	        return this.cloneAndEnhance({ properties: properties });
	    };
	    ModelType$$1.prototype.volatile = function (fn) {
	        var _this = this;
	        var stateInitializer = function (self) {
	            _this.instantiateVolatileState(self, fn(self));
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [stateInitializer] });
	    };
	    ModelType$$1.prototype.instantiateVolatileState = function (self, state) {
	        // check views return
	        if (!isPlainObject(state))
	            fail("volatile state initializer should return a plain object containing state");
	        // TODO: typecheck & namecheck members of state?
	        mobx.extendObservable(self, state, EMPTY_OBJECT, mobxShallow);
	    };
	    ModelType$$1.prototype.extend = function (fn) {
	        var _this = this;
	        var initializer = function (self) {
	            var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, ["actions", "views", "state"]);
	            for (var key in rest)
	                fail("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '" + key + "'");
	            if (state)
	                _this.instantiateVolatileState(self, state);
	            if (views)
	                _this.instantiateViews(self, views);
	            if (actions)
	                _this.instantiateActions(self, actions);
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [initializer] });
	    };
	    ModelType$$1.prototype.views = function (fn) {
	        var _this = this;
	        var viewInitializer = function (self) {
	            _this.instantiateViews(self, fn(self));
	            return self;
	        };
	        return this.cloneAndEnhance({ initializers: [viewInitializer] });
	    };
	    ModelType$$1.prototype.instantiateViews = function (self, views) {
	        // check views return
	        if (!isPlainObject(views))
	            fail("views initializer should return a plain object containing views");
	        Object.keys(views).forEach(function (key) {
	            // is this a computed property?
	            var descriptor = Object.getOwnPropertyDescriptor(views, key);
	            var value = descriptor.value;
	            if ("get" in descriptor) {
	                // TODO: mobx currently does not allow redefining computes yet, pending #1121
	                if (mobx.isComputed(self.$mobx.values[key])) {
	                    // TODO: use `isComputed(self, key)`, pending mobx #1120
	                    
	                    self.$mobx.values[key] = mobx.computed(descriptor.get, {
	                        name: key,
	                        set: descriptor.set,
	                        context: self
	                    });
	                }
	                else {
	                    var tmp = {};
	                    Object.defineProperty(tmp, key, {
	                        get: descriptor.get,
	                        set: descriptor.set,
	                        enumerable: true
	                    });
	                    mobx.extendObservable(self, tmp, EMPTY_OBJECT, mobxShallow);
	                }
	            }
	            else if (typeof value === "function") {
	                // this is a view function, merge as is!
	                // See #646, allow models to be mocked
	                
	                ( true
	                    ? addHiddenFinalProp
	                    : addHiddenWritableProp)(self, key, value);
	            }
	            else {
	                fail("A view member should either be a function or getter based property");
	            }
	        });
	    };
	    ModelType$$1.prototype.preProcessSnapshot = function (preProcessor) {
	        var currentPreprocessor = this.preProcessor;
	        if (!currentPreprocessor)
	            return this.cloneAndEnhance({ preProcessor: preProcessor });
	        else
	            return this.cloneAndEnhance({
	                preProcessor: function (snapshot) { return currentPreprocessor(preProcessor(snapshot)); }
	            });
	    };
	    ModelType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, this.applySnapshotPreProcessor(snapshot), this.createNewInstance, this.finalizeNewInstance);
	        // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
	        // that pre-reserves all these fields for fast object-member lookups
	    };
	    ModelType$$1.prototype.willChange = function (change) {
	        var node = getStateTreeNode$$1(change.object);
	        node.assertWritable();
	        var type = this.properties[change.name];
	        // only properties are typed, state are stored as-is references
	        if (type) {
	            typecheck$$1(type, change.newValue);
	            change.newValue = type.reconcile(node.getChildNode(change.name), change.newValue);
	        }
	        return change;
	    };
	    ModelType$$1.prototype.getChildren = function (node) {
	        var _this = this;
	        var res = [];
	        this.forAllProps(function (name, type) {
	            res.push(_this.getChildNode(node, name));
	        });
	        return res;
	    };
	    ModelType$$1.prototype.getChildNode = function (node, key) {
	        if (!(key in this.properties))
	            return fail("Not a value property: " + key);
	        var childNode = node.storedValue.$mobx.values[key].value; // TODO: blegh!
	        if (!childNode)
	            return fail("Node not available for property " + key);
	        return childNode;
	    };
	    ModelType$$1.prototype.getValue = function (node) {
	        return node.storedValue;
	    };
	    ModelType$$1.prototype.getSnapshot = function (node) {
	        var _this = this;
	        var res = {};
	        this.forAllProps(function (name, type) {
	            // TODO: FIXME, make sure the observable ref is used!
	            
	            mobx.getAtom(node.storedValue, name).reportObserved();
	            res[name] = _this.getChildNode(node, name).snapshot;
	        });
	        if (typeof node.storedValue.postProcessSnapshot === "function") {
	            return node.storedValue.postProcessSnapshot.call(null, res);
	        }
	        return res;
	    };
	    ModelType$$1.prototype.applyPatchLocally = function (node, subpath, patch) {
	        if (!(patch.op === "replace" || patch.op === "add"))
	            fail("object does not support operation " + patch.op);
	        node.storedValue[subpath] = patch.value;
	    };
	    ModelType$$1.prototype.applySnapshot = function (node, snapshot) {
	        var s = this.applySnapshotPreProcessor(snapshot);
	        typecheck$$1(this, s);
	        this.forAllProps(function (name, type) {
	            node.storedValue[name] = s[name];
	        });
	    };
	    ModelType$$1.prototype.applySnapshotPreProcessor = function (snapshot) {
	        if (this.preProcessor)
	            return this.preProcessor.call(null, snapshot);
	        return snapshot;
	    };
	    ModelType$$1.prototype.getChildType = function (key) {
	        return this.properties[key];
	    };
	    ModelType$$1.prototype.isValidSnapshot = function (value, context) {
	        var _this = this;
	        var snapshot = this.applySnapshotPreProcessor(value);
	        if (!isPlainObject(snapshot)) {
	            return typeCheckFailure$$1(context, snapshot, "Value is not a plain object");
	        }
	        return flattenTypeErrors$$1(this.propertyNames.map(function (key) {
	            return _this.properties[key].validate(snapshot[key], getContextForPath$$1(context, key, _this.properties[key]));
	        }));
	    };
	    ModelType$$1.prototype.forAllProps = function (fn) {
	        var _this = this;
	        this.propertyNames.forEach(function (key) { return fn(key, _this.properties[key]); });
	    };
	    ModelType$$1.prototype.describe = function () {
	        var _this = this;
	        // optimization: cache
	        return ("{ " +
	            this.propertyNames.map(function (key) { return key + ": " + _this.properties[key].describe(); }).join("; ") +
	            " }");
	    };
	    ModelType$$1.prototype.getDefaultSnapshot = function () {
	        return {};
	    };
	    ModelType$$1.prototype.removeChild = function (node, subpath) {
	        node.storedValue[subpath] = null;
	    };
	    __decorate([
	        mobx.action
	    ], ModelType$$1.prototype, "applySnapshot", null);
	    return ModelType$$1;
	}(ComplexType$$1));
	/**
	 * Creates a new model type by providing a name, properties, volatile state and actions.
	 *
	 * See the [model type](https://github.com/mobxjs/mobx-state-tree#creating-models) description or the [getting started](https://github.com/mobxjs/mobx-state-tree/blob/master/docs/getting-started.md#getting-started-1) tutorial.
	 *
	 * @export
	 * @alias types.model
	 */
	function model$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
	    var properties = args.shift() || {};
	    return new ModelType$$1({ name: name, properties: properties });
	}
	/**
	 * Composes a new model from one or more existing model types.
	 * This method can be invoked in two forms:
	 * Given 2 or more model types, the types are composed into a new Type.
	 *
	 * @export
	 * @alias types.compose
	 */
	function compose$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // TODO: just join the base type names if no name is provided
	    var typeName = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
	    // check all parameters
	    if (false) {
	        args.forEach(function (type) {
	            if (!isType$$1(type))
	                fail("expected a mobx-state-tree type, got " + type + " instead");
	        });
	    }
	    return args
	        .reduce(function (prev, cur) {
	        return prev.cloneAndEnhance({
	            name: prev.name + "_" + cur.name,
	            properties: cur.properties,
	            initializers: cur.initializers
	        });
	    })
	        .named(typeName);
	}
	
	// TODO: implement CoreType using types.custom ?
	var CoreType$$1 = /** @class */ (function (_super) {
	    __extends(CoreType$$1, _super);
	    function CoreType$$1(name, flags, checker, initializer) {
	        if (initializer === void 0) { initializer = identity; }
	        var _this = _super.call(this, name) || this;
	        _this.shouldAttachNode = false;
	        _this.flags = flags;
	        _this.checker = checker;
	        _this.initializer = initializer;
	        return _this;
	    }
	    CoreType$$1.prototype.describe = function () {
	        return this.name;
	    };
	    CoreType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot, this.initializer);
	    };
	    CoreType$$1.prototype.isValidSnapshot = function (value, context) {
	        if (isPrimitive(value) && this.checker(value)) {
	            return typeCheckSuccess$$1();
	        }
	        var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
	        return typeCheckFailure$$1(context, value, "Value is not a " + typeName);
	    };
	    return CoreType$$1;
	}(Type$$1));
	/**
	 * Creates a type that can only contain a string value.
	 * This type is used for string values by default
	 *
	 * @export
	 * @alias types.string
	 * @example
	 * const Person = types.model({
	 *   firstName: types.string,
	 *   lastName: "Doe"
	 * })
	 */
	// tslint:disable-next-line:variable-name
	var string$$1 = new CoreType$$1("string", TypeFlags$$1.String, function (v) { return typeof v === "string"; });
	/**
	 * Creates a type that can only contain a numeric value.
	 * This type is used for numeric values by default
	 *
	 * @export
	 * @alias types.number
	 * @example
	 * const Vector = types.model({
	 *   x: types.number,
	 *   y: 0
	 * })
	 */
	// tslint:disable-next-line:variable-name
	var number$$1 = new CoreType$$1("number", TypeFlags$$1.Number, function (v) { return typeof v === "number"; });
	/**
	 * Creates a type that can only contain a boolean value.
	 * This type is used for boolean values by default
	 *
	 * @export
	 * @alias types.boolean
	 * @example
	 * const Thing = types.model({
	 *   isCool: types.boolean,
	 *   isAwesome: false
	 * })
	 */
	// tslint:disable-next-line:variable-name
	var boolean$$1 = new CoreType$$1("boolean", TypeFlags$$1.Boolean, function (v) { return typeof v === "boolean"; });
	/**
	 * The type of the value `null`
	 *
	 * @export
	 * @alias types.null
	 */
	var nullType$$1 = new CoreType$$1("null", TypeFlags$$1.Null, function (v) { return v === null; });
	/**
	 * The type of the value `undefined`
	 *
	 * @export
	 * @alias types.undefined
	 */
	var undefinedType$$1 = new CoreType$$1("undefined", TypeFlags$$1.Undefined, function (v) { return v === undefined; });
	/**
	 * Creates a type that can only contain a javascript Date value.
	 *
	 * @export
	 * @alias types.Date
	 * @example
	 * const LogLine = types.model({
	 *   timestamp: types.Date,
	 * })
	 *
	 * LogLine.create({ timestamp: new Date() })
	 */
	// tslint:disable-next-line:variable-name
	var DatePrimitive$$1 = new CoreType$$1("Date", TypeFlags$$1.Date, function (v) { return typeof v === "number" || v instanceof Date; }, function (v) { return (v instanceof Date ? v : new Date(v)); });
	DatePrimitive$$1.getSnapshot = function (node) {
	    return node.storedValue.getTime();
	};
	function getPrimitiveFactoryFromValue$$1(value) {
	    switch (typeof value) {
	        case "string":
	            return string$$1;
	        case "number":
	            return number$$1;
	        case "boolean":
	            return boolean$$1;
	        case "object":
	            if (value instanceof Date)
	                return DatePrimitive$$1;
	    }
	    return fail("Cannot determine primitive type from value " + value);
	}
	function isPrimitiveType$$1(type) {
	    return (isType$$1(type) &&
	        (type.flags & (TypeFlags$$1.String | TypeFlags$$1.Number | TypeFlags$$1.Boolean | TypeFlags$$1.Date)) >
	            0);
	}
	
	var Literal$$1 = /** @class */ (function (_super) {
	    __extends(Literal$$1, _super);
	    function Literal$$1(value) {
	        var _this = _super.call(this, JSON.stringify(value)) || this;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Literal;
	        _this.value = value;
	        return _this;
	    }
	    Literal$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, snapshot);
	    };
	    Literal$$1.prototype.describe = function () {
	        return JSON.stringify(this.value);
	    };
	    Literal$$1.prototype.isValidSnapshot = function (value, context) {
	        if (isPrimitive(value) && value === this.value) {
	            return typeCheckSuccess$$1();
	        }
	        return typeCheckFailure$$1(context, value, "Value is not a literal " + JSON.stringify(this.value));
	    };
	    return Literal$$1;
	}(Type$$1));
	/**
	 * The literal type will return a type that will match only the exact given type.
	 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
	 * You can use literal to match exact strings for example the exact male or female string.
	 *
	 * @example
	 * const Person = types.model({
	 *     name: types.string,
	 *     gender: types.union(types.literal('male'), types.literal('female'))
	 * })
	 *
	 * @export
	 * @alias types.literal
	 * @template S
	 * @param {S} value The value to use in the strict equal check
	 * @returns {ISimpleType<S>}
	 */
	function literal$$1(value) {
	    // check that the given value is a primitive
	    if (false) {
	        if (!isPrimitive(value))
	            fail("Literal types can be built only on top of primitives");
	    }
	    return new Literal$$1(value);
	}
	
	var Refinement$$1 = /** @class */ (function (_super) {
	    __extends(Refinement$$1, _super);
	    function Refinement$$1(name, type, predicate, message) {
	        var _this = _super.call(this, name) || this;
	        _this.type = type;
	        _this.predicate = predicate;
	        _this.message = message;
	        return _this;
	    }
	    Object.defineProperty(Refinement$$1.prototype, "flags", {
	        get: function () {
	            return this.type.flags | TypeFlags$$1.Refinement;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Refinement$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.type.shouldAttachNode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Refinement$$1.prototype.describe = function () {
	        return this.name;
	    };
	    Refinement$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        // create the child type
	        var inst = this.type.instantiate(parent, subpath, environment, value);
	        return inst;
	    };
	    Refinement$$1.prototype.isAssignableFrom = function (type) {
	        return this.type.isAssignableFrom(type);
	    };
	    Refinement$$1.prototype.isValidSnapshot = function (value, context) {
	        var subtypeErrors = this.type.validate(value, context);
	        if (subtypeErrors.length > 0)
	            return subtypeErrors;
	        var snapshot = isStateTreeNode$$1(value) ? getStateTreeNode$$1(value).snapshot : value;
	        if (!this.predicate(snapshot)) {
	            return typeCheckFailure$$1(context, value, this.message(value));
	        }
	        return typeCheckSuccess$$1();
	    };
	    return Refinement$$1;
	}(Type$$1));
	/**
	 * `types.refinement(baseType, (snapshot) => boolean)` creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
	 *
	 * @export
	 * @alias types.refinement
	 * @template T
	 * @param {string} name
	 * @param {IType<T, T>} type
	 * @param {(snapshot: T) => boolean} predicate
	 * @returns {IType<T, T>}
	 */
	function refinement$$1() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var name = typeof args[0] === "string" ? args.shift() : isType$$1(args[0]) ? args[0].name : null;
	    var type = args[0];
	    var predicate = args[1];
	    var message = args[2]
	        ? args[2]
	        : function (v) { return "Value does not respect the refinement predicate"; };
	    // ensures all parameters are correct
	    if (false) {
	        if (typeof name !== "string")
	            fail("expected a string as first argument, got " + name + " instead");
	        if (!isType$$1(type))
	            fail("expected a mobx-state-tree type as first or second argument, got " +
	                type +
	                " instead");
	        if (typeof predicate !== "function")
	            fail("expected a function as third argument, got " + predicate + " instead");
	        if (typeof message !== "function")
	            fail("expected a function as fourth argument, got " + message + " instead");
	    }
	    return new Refinement$$1(name, type, predicate, message);
	}
	
	/**
	 * Can be used to create an string based enumeration.
	 * (note: this methods is just sugar for a union of string literals)
	 *
	 * @example
	 * const TrafficLight = types.model({
	 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
	 * })
	 *
	 * @export
	 * @alias types.enumeration
	 * @param {string} name descriptive name of the enumeration (optional)
	 * @param {string[]} options possible values this enumeration can have
	 * @returns {ISimpleType<string>}
	 */
	function enumeration$$1(name, options) {
	    var realOptions = typeof name === "string" ? options : name;
	    // check all options
	    if (false) {
	        realOptions.forEach(function (option) {
	            if (typeof option !== "string")
	                fail("expected all options to be string, got " + type + " instead");
	        });
	    }
	    var type = union$$1.apply(void 0, realOptions.map(function (option) { return literal$$1("" + option); }));
	    if (typeof name === "string")
	        type.name = name;
	    return type;
	}
	
	var Union$$1 = /** @class */ (function (_super) {
	    __extends(Union$$1, _super);
	    function Union$$1(name, types, dispatcher) {
	        var _this = _super.call(this, name) || this;
	        _this.dispatcher = null;
	        _this.dispatcher = dispatcher;
	        _this.types = types;
	        return _this;
	    }
	    Object.defineProperty(Union$$1.prototype, "flags", {
	        get: function () {
	            var result = TypeFlags$$1.Union;
	            this.types.forEach(function (type) {
	                result |= type.flags;
	            });
	            return result;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Union$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.types.some(function (type) { return type.shouldAttachNode; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Union$$1.prototype.isAssignableFrom = function (type) {
	        return this.types.some(function (subType) { return subType.isAssignableFrom(type); });
	    };
	    Union$$1.prototype.describe = function () {
	        return "(" + this.types.map(function (factory) { return factory.describe(); }).join(" | ") + ")";
	    };
	    Union$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        return this.determineType(value).instantiate(parent, subpath, environment, value);
	    };
	    Union$$1.prototype.reconcile = function (current, newValue) {
	        return this.determineType(newValue).reconcile(current, newValue);
	    };
	    Union$$1.prototype.determineType = function (value) {
	        // try the dispatcher, if defined
	        if (this.dispatcher !== null) {
	            return this.dispatcher(value);
	        }
	        // find the most accomodating type
	        var applicableTypes = this.types.filter(function (type) { return type.is(value); });
	        if (applicableTypes.length > 1)
	            return fail("Ambiguos snapshot " + JSON.stringify(value) + " for union " + this
	                .name + ". Please provide a dispatch in the union declaration.");
	        return applicableTypes[0];
	    };
	    Union$$1.prototype.isValidSnapshot = function (value, context) {
	        if (this.dispatcher !== null) {
	            return this.dispatcher(value).validate(value, context);
	        }
	        var errors = this.types.map(function (type) { return type.validate(value, context); });
	        var applicableTypes = errors.filter(function (errorArray) { return errorArray.length === 0; });
	        if (applicableTypes.length > 1) {
	            return typeCheckFailure$$1(context, value, "Multiple types are applicable for the union (hint: provide a dispatch function)");
	        }
	        else if (applicableTypes.length === 0) {
	            return typeCheckFailure$$1(context, value, "No type is applicable for the union").concat(flattenTypeErrors$$1(errors));
	        }
	        return typeCheckSuccess$$1();
	    };
	    return Union$$1;
	}(Type$$1));
	/**
	 * types.union(dispatcher?, types...) create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form (snapshot) => Type.
	 *
	 * @export
	 * @alias types.union
	 * @param {(ITypeDispatcher | IType<any, any>)} dispatchOrType
	 * @param {...IType<any, any>[]} otherTypes
	 * @returns {IType<any, any>}
	 */
	function union$$1(dispatchOrType) {
	    var otherTypes = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        otherTypes[_i - 1] = arguments[_i];
	    }
	    var dispatcher = isType$$1(dispatchOrType) ? null : dispatchOrType;
	    var types = isType$$1(dispatchOrType) ? otherTypes.concat(dispatchOrType) : otherTypes;
	    var name = "(" + types.map(function (type) { return type.name; }).join(" | ") + ")";
	    // check all options
	    if (false) {
	        types.forEach(function (type) {
	            if (!isType$$1(type))
	                fail("expected all possible types to be a mobx-state-tree type, got " +
	                    type +
	                    " instead");
	        });
	    }
	    return new Union$$1(name, types, dispatcher);
	}
	
	var OptionalValue$$1 = /** @class */ (function (_super) {
	    __extends(OptionalValue$$1, _super);
	    function OptionalValue$$1(type, defaultValue) {
	        var _this = _super.call(this, type.name) || this;
	        _this.type = type;
	        _this.defaultValue = defaultValue;
	        return _this;
	    }
	    Object.defineProperty(OptionalValue$$1.prototype, "flags", {
	        get: function () {
	            return this.type.flags | TypeFlags$$1.Optional;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OptionalValue$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.type.shouldAttachNode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OptionalValue$$1.prototype.describe = function () {
	        return this.type.describe() + "?";
	    };
	    OptionalValue$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        if (typeof value === "undefined") {
	            var defaultValue = this.getDefaultValue();
	            var defaultSnapshot = isStateTreeNode$$1(defaultValue)
	                ? getStateTreeNode$$1(defaultValue).snapshot
	                : defaultValue;
	            return this.type.instantiate(parent, subpath, environment, defaultSnapshot);
	        }
	        return this.type.instantiate(parent, subpath, environment, value);
	    };
	    OptionalValue$$1.prototype.reconcile = function (current, newValue) {
	        return this.type.reconcile(current, this.type.is(newValue) ? newValue : this.getDefaultValue());
	    };
	    OptionalValue$$1.prototype.getDefaultValue = function () {
	        var defaultValue = typeof this.defaultValue === "function" ? this.defaultValue() : this.defaultValue;
	        if (typeof this.defaultValue === "function")
	            typecheck$$1(this, defaultValue);
	        return defaultValue;
	    };
	    OptionalValue$$1.prototype.isValidSnapshot = function (value, context) {
	        // defaulted values can be skipped
	        if (value === undefined) {
	            return typeCheckSuccess$$1();
	        }
	        // bounce validation to the sub-type
	        return this.type.validate(value, context);
	    };
	    OptionalValue$$1.prototype.isAssignableFrom = function (type) {
	        return this.type.isAssignableFrom(type);
	    };
	    return OptionalValue$$1;
	}(Type$$1));
	/**
	 * `types.optional` can be used to create a property with a default value.
	 * If the given value is not provided in the snapshot, it will default to the provided `defaultValue`.
	 * If `defaultValue` is a function, the function will be invoked for every new instance.
	 * Applying a snapshot in which the optional value is _not_ present, causes the value to be reset
	 *
	 * @example
	 * const Todo = types.model({
	 *   title: types.optional(types.string, "Test"),
	 *   done: types.optional(types.boolean, false),
	 *   created: types.optional(types.Date, () => new Date())
	 * })
	 *
	 * // it is now okay to omit 'created' and 'done'. created will get a freshly generated timestamp
	 * const todo = Todo.create({ title: "Get coffee "})
	 *
	 * @export
	 * @alias types.optional
	 */
	function optional$$1(type, defaultValueOrFunction) {
	    if (false) {
	        if (!isType$$1(type))
	            fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
	        var defaultValue = typeof defaultValueOrFunction === "function"
	            ? defaultValueOrFunction()
	            : defaultValueOrFunction;
	        var defaultSnapshot = isStateTreeNode$$1(defaultValue)
	            ? getStateTreeNode$$1(defaultValue).snapshot
	            : defaultValue;
	        typecheck$$1(type, defaultSnapshot);
	    }
	    return new OptionalValue$$1(type, defaultValueOrFunction);
	}
	
	var optionalNullType = optional$$1(nullType$$1, null);
	/**
	 * Maybe will make a type nullable, and also null by default.
	 *
	 * @export
	 * @alias types.maybe
	 * @template S
	 * @template T
	 * @param {IType<S, T>} type The type to make nullable
	 * @returns {(IType<S | null | undefined, T | null>)}
	 */
	function maybe$$1(type) {
	    if (false) {
	        if (!isType$$1(type))
	            fail("expected a mobx-state-tree type as first argument, got " + type + " instead");
	        if (type === frozen$$1) {
	            fail("Unable to declare `types.maybe(types.frozen)`. Frozen already accepts `null`. Consider using `types.optional(types.frozen, null)` instead.");
	        }
	    }
	    return union$$1(optionalNullType, type);
	}
	
	var Late$$1 = /** @class */ (function (_super) {
	    __extends(Late$$1, _super);
	    function Late$$1(name, definition) {
	        var _this = _super.call(this, name) || this;
	        _this._subType = null;
	        _this.definition = definition;
	        return _this;
	    }
	    Object.defineProperty(Late$$1.prototype, "flags", {
	        get: function () {
	            return this.subType.flags | TypeFlags$$1.Late;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Late$$1.prototype, "shouldAttachNode", {
	        get: function () {
	            return this.subType.shouldAttachNode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Late$$1.prototype, "subType", {
	        get: function () {
	            if (this._subType === null) {
	                this._subType = this.definition();
	            }
	            return this._subType;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Late$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return this.subType.instantiate(parent, subpath, environment, snapshot);
	    };
	    Late$$1.prototype.reconcile = function (current, newValue) {
	        return this.subType.reconcile(current, newValue);
	    };
	    Late$$1.prototype.describe = function () {
	        return this.subType.name;
	    };
	    Late$$1.prototype.isValidSnapshot = function (value, context) {
	        return this.subType.validate(value, context);
	    };
	    Late$$1.prototype.isAssignableFrom = function (type) {
	        return this.subType.isAssignableFrom(type);
	    };
	    return Late$$1;
	}(Type$$1));
	/**
	 * Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
	 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
	 * You need to declare an interface to explicit the return type of the late parameter function.
	 *
	 * @example
	 *  interface INode {
	 *       childs: INode[]
	 *  }
	 *
	 *   // TypeScript is'nt smart enough to infer self referencing types.
	 *  const Node = types.model({
	 *       childs: types.optional(types.array(types.late<any, INode>(() => Node)), [])
	 *  })
	 *
	 * @export
	 * @alias types.late
	 * @template S
	 * @template T
	 * @param {string} [name] The name to use for the type that will be returned.
	 * @param {ILateType<S, T>} type A function that returns the type that will be defined.
	 * @returns {IType<S, T>}
	 */
	function late$$1(nameOrType, maybeType) {
	    var name = typeof nameOrType === "string" ? nameOrType : "late(" + nameOrType.toString() + ")";
	    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
	    // checks that the type is actually a late type
	    if (false) {
	        if (!(typeof type === "function" && type.length === 0))
	            fail("Invalid late type, expected a function with zero arguments that returns a type, got: " +
	                type);
	    }
	    return new Late$$1(name, type);
	}
	
	var Frozen$$1 = /** @class */ (function (_super) {
	    __extends(Frozen$$1, _super);
	    function Frozen$$1() {
	        var _this = _super.call(this, "frozen") || this;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Frozen;
	        return _this;
	    }
	    Frozen$$1.prototype.describe = function () {
	        return "<any immutable value>";
	    };
	    Frozen$$1.prototype.instantiate = function (parent, subpath, environment, value) {
	        // create the node
	        return createNode$$1(this, parent, subpath, environment, deepFreeze(value));
	    };
	    Frozen$$1.prototype.isValidSnapshot = function (value, context) {
	        if (!isSerializable(value)) {
	            return typeCheckFailure$$1(context, value, "Value is not serializable and cannot be frozen");
	        }
	        return typeCheckSuccess$$1();
	    };
	    return Frozen$$1;
	}(Type$$1));
	/**
	 * Frozen can be used to story any value that is serializable in itself (that is valid JSON).
	 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
	 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
	 *
	 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
	 *
	 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
	 *
	 * @example
	 * const GameCharacter = types.model({
	 *   name: string,
	 *   location: types.frozen
	 * })
	 *
	 * const hero = GameCharacter.create({
	 *   name: "Mario",
	 *   location: { x: 7, y: 4 }
	 * })
	 *
	 * hero.location = { x: 10, y: 2 } // OK
	 * hero.location.x = 7 // Not ok!
	 *
	 * @alias types.frozen
	 */
	var frozen$$1 = new Frozen$$1();
	
	var StoredReference = /** @class */ (function () {
	    function StoredReference(mode, value) {
	        this.mode = mode;
	        this.value = value;
	        if (mode === "object") {
	            if (!isStateTreeNode$$1(value))
	                return fail("Can only store references to tree nodes, got: '" + value + "'");
	            var targetNode = getStateTreeNode$$1(value);
	            if (!targetNode.identifierAttribute)
	                return fail("Can only store references with a defined identifier attribute.");
	        }
	    }
	    return StoredReference;
	}());
	var BaseReferenceType$$1 = /** @class */ (function (_super) {
	    __extends(BaseReferenceType$$1, _super);
	    function BaseReferenceType$$1(targetType) {
	        var _this = _super.call(this, "reference(" + targetType.name + ")") || this;
	        _this.targetType = targetType;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Reference;
	        return _this;
	    }
	    BaseReferenceType$$1.prototype.describe = function () {
	        return this.name;
	    };
	    BaseReferenceType$$1.prototype.isAssignableFrom = function (type) {
	        return this.targetType.isAssignableFrom(type);
	    };
	    BaseReferenceType$$1.prototype.isValidSnapshot = function (value, context) {
	        return typeof value === "string" || typeof value === "number"
	            ? typeCheckSuccess$$1()
	            : typeCheckFailure$$1(context, value, "Value is not a valid identifier, which is a string or a number");
	    };
	    return BaseReferenceType$$1;
	}(Type$$1));
	var IdentifierReferenceType$$1 = /** @class */ (function (_super) {
	    __extends(IdentifierReferenceType$$1, _super);
	    function IdentifierReferenceType$$1(targetType) {
	        return _super.call(this, targetType) || this;
	    }
	    IdentifierReferenceType$$1.prototype.getValue = function (node) {
	        if (!node.isAlive)
	            return undefined;
	        var ref = node.storedValue;
	        // id already resolved, return
	        if (ref.mode === "object")
	            return ref.value;
	        // reference was initialized with the identifier of the target
	        var target = node.root.identifierCache.resolve(this.targetType, ref.value);
	        if (!target)
	            return fail("Failed to resolve reference '" + ref.value + "' to type '" + this.targetType
	                .name + "' (from node: " + node.path + ")");
	        return target.value;
	    };
	    IdentifierReferenceType$$1.prototype.getSnapshot = function (node) {
	        var ref = node.storedValue;
	        switch (ref.mode) {
	            case "identifier":
	                return ref.value;
	            case "object":
	                return getStateTreeNode$$1(ref.value).identifier;
	        }
	    };
	    IdentifierReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        return createNode$$1(this, parent, subpath, environment, new StoredReference(isStateTreeNode$$1(snapshot) ? "object" : "identifier", snapshot));
	    };
	    IdentifierReferenceType$$1.prototype.reconcile = function (current, newValue) {
	        if (current.type === this) {
	            var targetMode = isStateTreeNode$$1(newValue) ? "object" : "identifier";
	            var ref = current.storedValue;
	            if (targetMode === ref.mode && ref.value === newValue)
	                return current;
	        }
	        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newValue);
	        current.die();
	        return newNode;
	    };
	    return IdentifierReferenceType$$1;
	}(BaseReferenceType$$1));
	var CustomReferenceType$$1 = /** @class */ (function (_super) {
	    __extends(CustomReferenceType$$1, _super);
	    function CustomReferenceType$$1(targetType, options) {
	        var _this = _super.call(this, targetType) || this;
	        _this.options = options;
	        return _this;
	    }
	    CustomReferenceType$$1.prototype.getValue = function (node) {
	        if (!node.isAlive)
	            return undefined;
	        return this.options.get(node.storedValue, node.parent ? node.parent.storedValue : null);
	    };
	    CustomReferenceType$$1.prototype.getSnapshot = function (node) {
	        return node.storedValue;
	    };
	    CustomReferenceType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        var identifier$$1 = isStateTreeNode$$1(snapshot)
	            ? this.options.set(snapshot, parent ? parent.storedValue : null)
	            : snapshot;
	        return createNode$$1(this, parent, subpath, environment, identifier$$1);
	    };
	    CustomReferenceType$$1.prototype.reconcile = function (current, snapshot) {
	        var newIdentifier = isStateTreeNode$$1(snapshot)
	            ? this.options.set(snapshot, current ? current.storedValue : null)
	            : snapshot;
	        if (current.type === this) {
	            if (current.storedValue === newIdentifier)
	                return current;
	        }
	        var newNode = this.instantiate(current.parent, current.subpath, current._environment, newIdentifier);
	        current.die();
	        return newNode;
	    };
	    return CustomReferenceType$$1;
	}(BaseReferenceType$$1));
	/**
	 * Creates a reference to another type, which should have defined an identifier.
	 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
	 *
	 * @export
	 * @alias types.reference
	 */
	function reference$$1(subType, options) {
	    // check that a type is given
	    if (false) {
	        if (!isType$$1(subType))
	            fail("expected a mobx-state-tree type as first argument, got " + subType + " instead");
	        if (arguments.length === 2 && typeof arguments[1] === "string")
	            fail("References with base path are no longer supported. Please remove the base path.");
	    }
	    if (options)
	        return new CustomReferenceType$$1(subType, options);
	    else
	        return new IdentifierReferenceType$$1(subType);
	}
	
	var IdentifierType$$1 = /** @class */ (function (_super) {
	    __extends(IdentifierType$$1, _super);
	    function IdentifierType$$1(identifierType) {
	        var _this = _super.call(this, "identifier(" + identifierType.name + ")") || this;
	        _this.identifierType = identifierType;
	        _this.shouldAttachNode = false;
	        _this.flags = TypeFlags$$1.Identifier;
	        return _this;
	    }
	    IdentifierType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        if (!parent || !isStateTreeNode$$1(parent.storedValue))
	            return fail("Identifier types can only be instantiated as direct child of a model type");
	        if (parent.identifierAttribute)
	            fail("Cannot define property '" + subpath + "' as object identifier, property '" + parent.identifierAttribute + "' is already defined as identifier property");
	        parent.identifierAttribute = subpath;
	        return createNode$$1(this, parent, subpath, environment, snapshot);
	    };
	    IdentifierType$$1.prototype.reconcile = function (current, newValue) {
	        if (current.storedValue !== newValue)
	            return fail("Tried to change identifier from '" + current.storedValue + "' to '" + newValue + "'. Changing identifiers is not allowed.");
	        return current;
	    };
	    IdentifierType$$1.prototype.describe = function () {
	        return "identifier(" + this.identifierType.describe() + ")";
	    };
	    IdentifierType$$1.prototype.isValidSnapshot = function (value, context) {
	        if (value === undefined ||
	            value === null ||
	            typeof value === "string" ||
	            typeof value === "number")
	            return this.identifierType.validate(value, context);
	        return typeCheckFailure$$1(context, value, "Value is not a valid identifier, which is a string or a number");
	    };
	    return IdentifierType$$1;
	}(Type$$1));
	/**
	 * Identifiers are used to make references, lifecycle events and reconciling works.
	 * Inside a state tree, for each type can exist only one instance for each given identifier.
	 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
	 * Identifier can be used only as type property of a model.
	 * This type accepts as parameter the value type of the identifier field that can be either string or number.
	 *
	 * @example
	 *  const Todo = types.model("Todo", {
	 *      id: types.identifier(types.string),
	 *      title: types.string
	 *  })
	 *
	 * @export
	 * @alias types.identifier
	 * @template T
	 * @param {IType<T, T>} baseType
	 * @returns {IType<T, T>}
	 */
	function identifier$$1(baseType) {
	    if (baseType === void 0) { baseType = string$$1; }
	    if (false) {
	        if (!isType$$1(baseType))
	            fail("expected a mobx-state-tree type as first argument, got " + baseType + " instead");
	    }
	    return new IdentifierType$$1(baseType);
	}
	
	/**
	 * Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
	 *
	 * The signature of the options is:
	 *
	 * ```javascript
	 * export type CustomTypeOptions<S, T> = {
	 *     // Friendly name
	 *     name: string
	 *     // given a serialized value, how to turn it into the target type
	 *     fromSnapshot(snapshot: S): T
	 *     // return the serialization of the current value
	 *     toSnapshot(value: T): S
	 *     // if true, this is a converted value, if false, it's a snapshot
	 *     isTargetType(value: T | S): boolean
	 *     // a non empty string is assumed to be a validation error
	 *     getValidationMessage?(snapshot: S): string
	 * }
	 * ```
	 *
	 * @export
	 * @alias types.custom
	 *
	 * @example
	 * const DecimalPrimitive = types.custom<string, Decimal>({
	 *     name: "Decimal",
	 *     fromSnapshot(value: string) {
	 *         return new Decimal(value)
	 *     },
	 *     toSnapshot(value: Decimal) {
	 *         return value.toString()
	 *     },
	 *     isTargetType(value: string | Decimal): boolean {
	 *         return value instanceof Decimal
	 *     },
	 *     getValidationMessage(value: string): string {
	 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
	 *         return `'${value}' doesn't look like a valid decimal number`
	 *     }
	 * })
	 *
	 * const Wallet = types.model({
	 *     balance: DecimalPrimitive
	 * })
	 */
	function custom$$1(options) {
	    return new CustomType$$1(options);
	}
	var CustomType$$1 = /** @class */ (function (_super) {
	    __extends(CustomType$$1, _super);
	    function CustomType$$1(options) {
	        var _this = _super.call(this, options.name) || this;
	        _this.options = options;
	        _this.flags = TypeFlags$$1.Reference;
	        _this.shouldAttachNode = false;
	        return _this;
	    }
	    CustomType$$1.prototype.describe = function () {
	        return this.name;
	    };
	    CustomType$$1.prototype.isAssignableFrom = function (type) {
	        return type === this;
	    };
	    CustomType$$1.prototype.isValidSnapshot = function (value, context) {
	        if (this.options.isTargetType(value))
	            return typeCheckSuccess$$1();
	        var typeError = this.options.getValidationMessage(value);
	        if (typeError) {
	            return typeCheckFailure$$1(context, value, "Invalid value for type '" + this.name + "': " + typeError);
	        }
	        return typeCheckSuccess$$1();
	    };
	    CustomType$$1.prototype.getValue = function (node) {
	        if (!node.isAlive)
	            return undefined;
	        return node.storedValue;
	    };
	    CustomType$$1.prototype.getSnapshot = function (node) {
	        return this.options.toSnapshot(node.storedValue);
	    };
	    CustomType$$1.prototype.instantiate = function (parent, subpath, environment, snapshot) {
	        var valueToStore = this.options.isTargetType(snapshot)
	            ? snapshot
	            : this.options.fromSnapshot(snapshot);
	        return createNode$$1(this, parent, subpath, environment, valueToStore);
	    };
	    CustomType$$1.prototype.reconcile = function (current, value) {
	        var isSnapshot = !this.options.isTargetType(value);
	        var unchanged = current.type === this &&
	            (isSnapshot ? value === current.snapshot : value === current.storedValue);
	        if (unchanged)
	            return current;
	        var valueToStore = isSnapshot ? this.options.fromSnapshot(value) : value;
	        var newNode = this.instantiate(current.parent, current.subpath, current._environment, valueToStore);
	        current.die();
	        return newNode;
	    };
	    return CustomType$$1;
	}(Type$$1));
	
	/*
	 * All imports / exports should be proxied through this file.
	 * Why? It gives us full control over the module load order, preventing circular dependency isses
	 */
	
	/* all code is initially loaded through internal, to avoid circular dep issues */
	// tslint:disable-next-line:no_unused-variable
	var types = {
	    enumeration: enumeration$$1,
	    model: model$$1,
	    compose: compose$$1,
	    custom: custom$$1,
	    reference: reference$$1,
	    union: union$$1,
	    optional: optional$$1,
	    literal: literal$$1,
	    maybe: maybe$$1,
	    refinement: refinement$$1,
	    string: string$$1,
	    boolean: boolean$$1,
	    number: number$$1,
	    Date: DatePrimitive$$1,
	    map: map$$1,
	    array: array$$1,
	    frozen: frozen$$1,
	    identifier: identifier$$1,
	    late: late$$1,
	    undefined: undefinedType$$1,
	    null: nullType$$1
	};
	
	exports.types = types;
	exports.typecheck = typecheckPublic$$1;
	exports.escapeJsonPath = escapeJsonPath$$1;
	exports.unescapeJsonPath = unescapeJsonPath$$1;
	exports.joinJsonPath = joinJsonPath$$1;
	exports.splitJsonPath = splitJsonPath$$1;
	exports.decorate = decorate$$1;
	exports.addMiddleware = addMiddleware$$1;
	exports.process = process$1$$1;
	exports.isStateTreeNode = isStateTreeNode$$1;
	exports.flow = flow;
	exports.applyAction = applyAction$$1;
	exports.onAction = onAction$$1;
	exports.recordActions = recordActions$$1;
	exports.createActionTrackingMiddleware = createActionTrackingMiddleware;
	exports.getType = getType$$1;
	exports.getChildType = getChildType$$1;
	exports.onPatch = onPatch$$1;
	exports.onSnapshot = onSnapshot$$1;
	exports.applyPatch = applyPatch$$1;
	exports.recordPatches = recordPatches$$1;
	exports.protect = protect$$1;
	exports.unprotect = unprotect$$1;
	exports.isProtected = isProtected$$1;
	exports.applySnapshot = applySnapshot$$1;
	exports.getSnapshot = getSnapshot$$1;
	exports.hasParent = hasParent$$1;
	exports.getParent = getParent$$1;
	exports.getRoot = getRoot$$1;
	exports.getPath = getPath$$1;
	exports.getPathParts = getPathParts$$1;
	exports.isRoot = isRoot$$1;
	exports.resolvePath = resolvePath$$1;
	exports.resolveIdentifier = resolveIdentifier$$1;
	exports.getIdentifier = getIdentifier$$1;
	exports.tryResolve = tryResolve$$1;
	exports.getRelativePath = getRelativePath$$1;
	exports.clone = clone$$1;
	exports.detach = detach$$1;
	exports.destroy = destroy$$1;
	exports.isAlive = isAlive$$1;
	exports.addDisposer = addDisposer$$1;
	exports.getEnv = getEnv$$1;
	exports.walk = walk$$1;
	exports.getMembers = getMembers$$1;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108).setImmediate))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	var enumerableDescriptorCache = {};
	var nonEnumerableDescriptorCache = {};
	function createPropertyInitializerDescriptor(prop, enumerable) {
	    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
	    return (cache[prop] ||
	        (cache[prop] = {
	            configurable: true,
	            enumerable: enumerable,
	            get: function () {
	                initializeInstance(this);
	                return this[prop];
	            },
	            set: function (value) {
	                initializeInstance(this);
	                this[prop] = value;
	            }
	        }));
	}
	function initializeInstance(target) {
	    if (target.__mobxDidRunLazyInitializers === true)
	        return;
	    var decorators = target.__mobxDecorators;
	    if (decorators) {
	        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
	        for (var key in decorators) {
	            var d = decorators[key];
	            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
	        }
	    }
	}
	function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
	    return function decoratorFactory() {
	        var decoratorArguments;
	        var decorator = function decorate(target, prop, descriptor, applyImmediately
	        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
	        // as the instance to apply the decorator to equals the target
	        ) {
	            if (applyImmediately === true) {
	                propertyCreator(target, prop, descriptor, target, decoratorArguments);
	                return null;
	            }
	            if (false)
	                fail$1("This function is a decorator, but it wasn't invoked like a decorator");
	            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
	                var inheritedDecorators = target.__mobxDecorators;
	                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
	            }
	            target.__mobxDecorators[prop] = {
	                prop: prop,
	                propertyCreator: propertyCreator,
	                descriptor: descriptor,
	                decoratorTarget: target,
	                decoratorArguments: decoratorArguments
	            };
	            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
	        };
	        if (quacksLikeADecorator(arguments)) {
	            // @decorator
	            decoratorArguments = EMPTY_ARRAY;
	            return decorator.apply(null, arguments);
	        }
	        else {
	            // @decorator(args)
	            decoratorArguments = Array.prototype.slice.call(arguments);
	            return decorator;
	        }
	    };
	}
	function quacksLikeADecorator(args) {
	    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
	        (args.length === 4 && args[3] === true));
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = __assign({}, event, { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(__assign({}, change, { spyReportEnd: true }));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
	    });
	}
	
	function createAction(actionName, fn) {
	    if (false) {
	        invariant(typeof fn === "function", "`action` can only be invoked on functions");
	        if (typeof actionName !== "string" || !actionName)
	            fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    var res = function () {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    finally {
	        endAction(runInfo);
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy)
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	}
	function allowStateChanges(allowStateChanges, func) {
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	
	function dontReassignFields() {
	    fail$1(("production") !== "production" && "@action fields are not reassignable");
	}
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor) {
	            if (false) {
	                return fail$1("@action cannot be used with getters");
	            }
	            // babel / typescript
	            // @action method() { }
	            if (descriptor.value) {
	                // typescript
	                return {
	                    value: createAction(name, descriptor.value),
	                    enumerable: false,
	                    configurable: true,
	                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
	                };
	            }
	            // babel only: @action method = () => {}
	            var initializer_1 = descriptor.initializer;
	            return {
	                enumerable: false,
	                configurable: true,
	                writable: true,
	                initializer: function () {
	                    // N.B: we can't immediately invoke initializer; this would be wrong
	                    return createAction(name, initializer_1.call(this));
	                }
	            };
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function actionFieldDecorator(name) {
	    // Simple property that writes on first invocation to the current instance
	    return function (target, prop, descriptor) {
	        Object.defineProperty(target, prop, {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return undefined;
	            },
	            set: function (value) {
	                addHiddenFinalProp(this, prop, action(name, value));
	            }
	        });
	    };
	}
	function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
	    if (applyToInstance === true) {
	        defineBoundAction(target, propertyName, descriptor.value);
	        return null;
	    }
	    if (descriptor) {
	        // if (descriptor.value)
	        // Typescript / Babel: @action.bound method() { }
	        // also: babel @action.bound method = () => {}
	        return {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
	                return this[propertyName];
	            },
	            set: dontReassignFields
	        };
	    }
	    // field decorator Typescript @action.bound method = () => {}
	    return {
	        enumerable: false,
	        configurable: true,
	        set: function (v) {
	            defineBoundAction(this, propertyName, v);
	        },
	        get: function () {
	            return undefined;
	        }
	    };
	}
	
	var action = function action(arg1, arg2, arg3, arg4) {
	    // action(fn() {})
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    // action("name", fn() {})
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    // @action("name") fn() {}
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    // @action fn() {}
	    if (arg4 === true) {
	        // apply to instance immediately
	        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
	    }
	    else {
	        return namedActionDecorator(arg2).apply(null, arguments);
	    }
	};
	action.bound = boundActionDecorator;
	function runInAction(arg1, arg2) {
	    // TODO: deprecate?
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    if (false) {
	        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
	        if (typeof actionName !== "string" || !actionName)
	            fail$1("actions should have valid names, got: '" + actionName + "'");
	    }
	    return executeAction(actionName, fn, this, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys$$1 = Object.keys(a), key;
	        length = keys$$1.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys$$1[length];
	            if (!(has$$1(b, key) && eq(a[key], b[key], aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.peek();
	    if (isES6Map(a) || isObservableMap(a))
	        return iteratorToArray(a.entries());
	    return a;
	}
	function has$$1(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	/**
	 * Creates a named reactive view and keeps it alive, so that the view is always
	 * updated if one of the dependencies changes, even when the view is not further used by something else.
	 * @param view The reactive view
	 * @returns disposer function, which can be used to stop the view from being updated in the future.
	 */
	function autorun(view, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    if (false) {
	        invariant(typeof view === "function", "Autorun expects a function as first argument");
	        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
	    }
	    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
	    var runSync = !opts.scheduler && !opts.delay;
	    var reaction;
	    if (runSync) {
	        // normal autorun
	        reaction = new Reaction(name, function () {
	            this.track(reactionRunner);
	        }, opts.onError);
	    }
	    else {
	        var scheduler_1 = createSchedulerFromOptions(opts);
	        // debounced autorun
	        var isScheduled_1 = false;
	        reaction = new Reaction(name, function () {
	            if (!isScheduled_1) {
	                isScheduled_1 = true;
	                scheduler_1(function () {
	                    isScheduled_1 = false;
	                    if (!reaction.isDisposed)
	                        reaction.track(reactionRunner);
	                });
	            }
	        }, opts.onError);
	    }
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	var run = function (f) { return f(); };
	function createSchedulerFromOptions(opts) {
	    return opts.scheduler
	        ? opts.scheduler
	        : opts.delay ? function (f) { return setTimeout(f, opts.delay); } : run;
	}
	function reaction(expression, effect, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    if (typeof opts === "boolean") {
	        opts = { fireImmediately: opts };
	        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
	    }
	    if (false) {
	        invariant(typeof expression === "function", "First argument to reaction should be a function");
	        invariant(typeof opts === "object", "Third argument of reactions should be an object");
	    }
	    var name = opts.name || "Reaction@" + getNextId();
	    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
	    var runSync = !opts.scheduler && !opts.delay;
	    var scheduler = createSchedulerFromOptions(opts);
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.compareStructural
	        ? comparer.structural
	        : opts.equals || comparer.default;
	    var r = new Reaction(name, function () {
	        if (firstTime || runSync) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            scheduler(reactionRunner);
	        }
	    }, opts.onError);
	    function reactionRunner() {
	        isScheduled = false; // Q: move into reaction runner?
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effectAction(value, r);
	        if (!firstTime && changed === true)
	            effectAction(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function wrapErrorHandler(errorHandler, baseFn) {
	    return function () {
	        try {
	            return baseFn.apply(this, arguments);
	        }
	        catch (e) {
	            errorHandler.call(this, e);
	        }
	    };
	}
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce an new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(options) {
	        var _this = this;
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isBeingObserved = false;
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        if (false)
	            return fail$1("missing option for computed: get");
	        this.derivation = options.get;
	        this.name = options.name || "ComputedValue@" + getNextId();
	        if (options.set)
	            this.setter = createAction(this.name + "-setter", options.set);
	        this.equals =
	            options.equals ||
	                (options.compareStructural || options.struct
	                    ? comparer.structural
	                    : comparer.default);
	        this.scope = options.context;
	        this.requiresReaction = !!options.requiresReaction;
	        if (options.keepAlive === true) {
	            // dangerous: never exposed, so this cmputed value should not depend on observables
	            // that live globally, or it will never get disposed! (nor anything attached to it)
	            autorun(function () { return _this.get(); });
	        }
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () { };
	    ComputedValue.prototype.onBecomeObserved = function () { };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        if (this.isComputing)
	            fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
	        if (globalState.inBatch === 0) {
	            if (shouldCompute(this)) {
	                this.warnAboutUntrackedRead();
	                startBatch(); // See perf test 'computed memoization'
	                this.value = this.computeValue(false);
	                endBatch();
	            }
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this
	                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, ("production") !== "production" &&
	                "[ComputedValue '" + this
	                    .name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                name: this.name
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = this.computeValue(true);
	        var changed = wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue);
	        if (changed) {
	            this.value = newValue;
	        }
	        return changed;
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            if (globalState.disableErrorBoundaries === true) {
	                res = this.derivation.call(this.scope);
	            }
	            else {
	                try {
	                    res = this.derivation.call(this.scope);
	                }
	                catch (e) {
	                    res = new CaughtException(e);
	                }
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.suspend = function () {
	        clearObserving(this);
	        this.value = undefined; // don't hold on to computed value!
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.warnAboutUntrackedRead = function () {
	        if (true)
	            return;
	        if (this.requiresReaction === true) {
	            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
	        }
	        if (this.isTracing !== TraceMode.NONE) {
	            console.log("[mobx.trace] '" + this
	                .name + "' is being read outside a reactive context. Doing a full recompute");
	        }
	        if (globalState.computedRequiresReaction) {
	            console.warn("[mobx] Computed value " + this
	                .name + " is being read outside a reactive context. Doing a full recompute");
	        }
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ComputedValue;
	}());
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	var UNCHANGED = {};
	declareAtom();
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.hasUnreportedChange = false;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    name: this.name,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.value !== newValue ? newValue : UNCHANGED;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(Atom));
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, name, defaultEnhancer) {
	        this.target = target;
	        this.name = name;
	        this.defaultEnhancer = defaultEnhancer;
	        this.values = {};
	    }
	    ObservableObjectAdministration.prototype.read = function (owner, key) {
	        if (this.target !== owner) {
	            this.illegalAccess(owner, key);
	            return;
	        }
	        return this.values[key].get();
	    };
	    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
	        var instance = this.target;
	        if (instance !== owner) {
	            this.illegalAccess(owner, key);
	            return;
	        }
	        var observable = this.values[key];
	        if (observable instanceof ComputedValue) {
	            observable.set(newValue);
	            return;
	        }
	        // intercept
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "update",
	                object: instance,
	                name: key,
	                newValue: newValue
	            });
	            if (!change)
	                return;
	            newValue = change.newValue;
	        }
	        newValue = observable.prepareNewValue(newValue);
	        // notify spy & observers
	        if (newValue !== UNCHANGED) {
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: instance,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableObjectAdministration.prototype.remove = function (key) {
	        if (!this.values[key])
	            return;
	        var target = this.target;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: target,
	                name: key,
	                type: "remove"
	            });
	            if (!change)
	                return;
	        }
	        try {
	            startBatch();
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var oldValue = this.values[key].get();
	            if (this.keys)
	                this.keys.remove(key);
	            delete this.values[key];
	            delete this.target[key];
	            var change = notify || notifySpy
	                ? {
	                    type: "remove",
	                    object: target,
	                    oldValue: oldValue,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	        finally {
	            endBatch();
	        }
	    };
	    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
	        /**
	         * This happens if a property is accessed through the prototype chain, but the property was
	         * declared directly as own property on the prototype.
	         *
	         * E.g.:
	         * class A {
	         * }
	         * extendObservable(A.prototype, { x: 1 })
	         *
	         * classB extens A {
	         * }
	         * console.log(new B().x)
	         *
	         * It is unclear whether the property should be considered 'static' or inherited.
	         * Either use `console.log(A.x)`
	         * or: decorate(A, { x: observable })
	         *
	         * When using decorate, the property will always be redeclared as own property on the actual instance
	         */
	        return fail$1("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        ("production") !== "production" &&
	            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableObjectAdministration.prototype.getKeys = function () {
	        var _this = this;
	        if (this.keys === undefined) {
	            this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true);
	        }
	        return this.keys.slice();
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name, defaultEnhancer) {
	    if (name === void 0) { name = ""; }
	    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
	    var adm = target.$mobx;
	    if (adm)
	        return adm;
	    ("production") !== "production" &&
	        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservableProperty(target, propName, newValue, enhancer) {
	    var adm = asObservableObject(target);
	    assertPropertyConfigurable(target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
	    if (adm.keys)
	        adm.keys.push(propName);
	    notifyPropertyAddition(adm, target, propName, newValue);
	}
	function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
	propName, options) {
	    var adm = asObservableObject(target);
	    options.name = adm.name + "." + propName;
	    options.context = target;
	    adm.values[propName] = new ComputedValue(options);
	    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = {};
	var computedPropertyConfigs = {};
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.read(this, propName);
	            },
	            set: function (v) {
	                this.$mobx.write(this, propName, v);
	            }
	        }));
	}
	function getAdministrationForComputedPropOwner(owner) {
	    var adm = owner.$mobx;
	    if (!adm) {
	        // because computed props are declared on proty,
	        // the current instance might not have been initialized yet
	        initializeInstance(owner);
	        return owner.$mobx;
	    }
	    return adm;
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return getAdministrationForComputedPropOwner(this).read(this, propName);
	            },
	            set: function (v) {
	                getAdministrationForComputedPropOwner(this).write(this, propName, v);
	            }
	        }));
	}
	function notifyPropertyAddition(adm, object, key, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: key,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart(__assign({}, change, { name: adm.name, key: key }));
	    if (notify)
	        notifyListeners(adm, change);
	    if (notifySpy)
	        spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
	        if (false) {
	            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
	        }
	        var initialValue = descriptor
	            ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value
	            : undefined;
	        defineObservableProperty(target, propertyName, initialValue, enhancer);
	    });
	    var res = 
	    // Extra process checks, as this happens during module initialization
	    typeof process !== "undefined" && ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}) && ("production") !== "production"
	        ? function observableDecorator() {
	            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
	            // and simply return the created prop decorator
	            if (arguments.length < 2)
	                return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
	            return decorator.apply(null, arguments);
	        }
	        : decorator;
	    res.enhancer = enhancer;
	    return res;
	}
	
	function _isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (false)
	            return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
	        if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value.$mobx ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	function isObservable(value) {
	    if (arguments.length !== 1)
	        fail$1(("production") !== "production" &&
	            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isObservable(value);
	}
	function isObservableProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail$1(("production") !== "production" && "expected a property name as second argument");
	    return _isObservable(value, propName);
	}
	
	function _isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	function isComputed(value) {
	    if (arguments.length > 1)
	        return fail$1(("production") !== "production" &&
	            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isComputed(value);
	}
	function isComputedProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail$1(("production") !== "production" &&
	            "isComputed expected a property name as second argument");
	    return _isComputed(value, propName);
	}
	
	var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
	    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
	    // Optimization: faster on decorator target or instance? Assuming target
	    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
	    var options = decoratorArgs[0] || {};
	    defineComputedProperty(instance, propertyName, __assign({}, options, { get: get, set: set }));
	});
	var computedStructDecorator = computedDecorator({ equals: comparer.structural });
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        // @computed
	        return computedDecorator.apply(null, arguments);
	    }
	    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
	        // @computed({ options })
	        return computedDecorator.apply(null, arguments);
	    }
	    // computed(expr, options?)
	    if (false) {
	        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
	        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
	    }
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.get = arg1;
	    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
	    opts.name = opts.name || arg1.name || ""; /* for generated name */
	    return new ComputedValue(opts);
	};
	computed.struct = computedStructDecorator;
	
	function extendShallowObservable(target, properties, decorators) {
	    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
	    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
	}
	function extendObservable(target, properties, decorators, options) {
	    if (false) {
	        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
	        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
	        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
	        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
	        if (decorators)
	            for (var key in decorators)
	                if (!(key in properties))
	                    fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
	    }
	    options = asCreateObservableOptions(options);
	    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
	    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
	    startBatch();
	    try {
	        for (var key in properties) {
	            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	            if (false) {
	                if (Object.getOwnPropertyDescriptor(target, key))
	                    fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
	                if (isComputed(descriptor.value))
	                    fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
	            }
	            var decorator = decorators && key in decorators
	                ? decorators[key]
	                : descriptor.get ? computedDecorator : defaultDecorator;
	            if (false)
	                return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
	            var resultDescriptor = decorator(target, key, descriptor, true);
	            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
	            )
	                Object.defineProperty(target, key, resultDescriptor);
	        }
	    }
	    finally {
	        endBatch();
	    }
	    return target;
	}
	
	// Predefined bags of create observable options, to avoid allocating temporarily option objects
	// in the majority of cases
	var defaultCreateObservableOptions = {
	    deep: true,
	    name: undefined,
	    defaultDecorator: undefined
	};
	var shallowCreateObservableOptions = {
	    deep: false,
	    name: undefined,
	    defaultDecorator: undefined
	};
	Object.freeze(defaultCreateObservableOptions);
	Object.freeze(shallowCreateObservableOptions);
	function assertValidOption(key) {
	    if (!/^(deep|name|defaultDecorator)$/.test(key))
	        fail$1("invalid option for (extend)observable: " + key);
	}
	function asCreateObservableOptions(thing) {
	    if (thing === null || thing === undefined)
	        return defaultCreateObservableOptions;
	    if (typeof thing === "string")
	        return { name: thing, deep: true };
	    if (false) {
	        if (typeof thing !== "object")
	            return fail$1("expected options object");
	        Object.keys(thing).forEach(assertValidOption);
	    }
	    return thing;
	}
	function getEnhancerFromOptions(options) {
	    return options.defaultDecorator
	        ? options.defaultDecorator.enhancer
	        : options.deep === false ? referenceEnhancer : deepEnhancer;
	}
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v, arg2, arg3) {
	    // @observable someProp;
	    if (typeof arguments[1] === "string") {
	        return deepDecorator.apply(null, arguments);
	    }
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = isPlainObject(v)
	        ? observable.object(v, arg2, arg3)
	        : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : v;
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    fail$1(("production") !== "production" &&
	        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
	}
	var observableFactories = {
	    box: function (value, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        var o = asCreateObservableOptions(options);
	        return new ObservableValue(value, getEnhancerFromOptions(o), o.name);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
	        return observable.box(value, { name: name, deep: false });
	    },
	    array: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        var o = asCreateObservableOptions(options);
	        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
	        return observable.array(initialValues, { name: name, deep: false });
	    },
	    map: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        var o = asCreateObservableOptions(options);
	        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
	        return observable.map(initialValues, { name: name, deep: false });
	    },
	    object: function (props, decorators, options) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("object");
	        var o = asCreateObservableOptions(options);
	        return extendObservable({}, props, decorators, o);
	    },
	    shallowObject: function (props, name) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("shallowObject");
	        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
	        return observable.object(props, {}, { name: name, deep: false });
	    },
	    ref: refDecorator,
	    shallow: shallowDecorator,
	    deep: deepDecorator,
	    struct: refStructDecorator
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	function incorrectlyUsedAsDecorator(methodName) {
	    fail$1(
	    // process.env.NODE_ENV !== "production" &&
	    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	function deepEnhancer(v, _, name) {
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, { name: name });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name });
	    if (isES6Map(v))
	        return observable.map(v, { name: name });
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.array(v, { name: name, deep: false });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name, deep: false });
	    if (isES6Map(v))
	        return observable.map(v, { name: name, deep: false });
	    return fail$1(("production") !== "production" &&
	        "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if (false)
	        throw "observable.struct should not be used with observable values";
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	function iteratorSymbol() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	function makeIterable(iterator) {
	    iterator[iteratorSymbol()] = self;
	    return iterator;
	}
	function self() {
	    return this;
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
	        if (typeof Map !== "function") {
	            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
	        }
	        this._data = new Map();
	        this._hasMap = new Map();
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return this._data.has(key);
	    };
	    ObservableMap.prototype.has = function (key) {
	        if (this._hasMap.has(key))
	            return this._hasMap.get(key).get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data.get(key).value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            transaction(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable = _this._data.get(key);
	                observable.setNewValue(undefined);
	                _this._data.delete(key);
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap.get(key);
	        if (entry) {
	            entry.setNewValue(value);
	        }
	        else {
	            entry = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
	            this._hasMap.set(key, entry);
	        }
	        return entry;
	    };
	    ObservableMap.prototype._updateValue = function (key, newValue) {
	        var observable = this._data.get(key);
	        newValue = observable.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(__assign({}, change, { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (key, newValue) {
	        var _this = this;
	        transaction(function () {
	            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + key, false);
	            _this._data.set(key, observable);
	            newValue = observable.value; // value might have been changed
	            _this._updateHasMapEntry(key, true);
	            _this._keys.push(key);
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: key,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign({}, change, { name: this.name, key: key }));
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        if (this.has(key))
	            return this.dehanceValue(this._data.get(key).get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        return this._keys[iteratorSymbol()]();
	    };
	    ObservableMap.prototype.values = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable({
	            next: function () {
	                return nextIndex < self._keys.length
	                    ? { value: self.get(self._keys[nextIndex++]), done: false }
	                    : { value: undefined, done: true };
	            }
	        });
	    };
	    ObservableMap.prototype.entries = function () {
	        var self = this;
	        var nextIndex = 0;
	        return makeIterable({
	            next: function () {
	                if (nextIndex < self._keys.length) {
	                    var key = self._keys[nextIndex++];
	                    return {
	                        value: [key, self.get(key)],
	                        done: false
	                    };
	                }
	                return { done: true };
	            }
	        });
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            if (isPlainObject(other))
	                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	            else if (Array.isArray(other))
	                other.forEach(function (_a) {
	                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
	                    return _this.set(key, value);
	                });
	            else if (isES6Map(other))
	                other.forEach(function (value, key) { return _this.set(key, value); });
	            else if (other !== null && other !== undefined)
	                fail$1("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        transaction(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys(values);
	            var oldKeys = _this._keys;
	            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
	            missingKeys.forEach(function (k) { return _this.delete(k); });
	            _this.merge(values);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a plain object that represents this map.
	     * Note that all the keys being stringified.
	     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
	     */
	    ObservableMap.prototype.toPOJO = function () {
	        var _this = this;
	        var res = {};
	        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
	        return res;
	    };
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        var _this = this;
	        var res = new Map();
	        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
	        return res;
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toPOJO();
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        ("production") !== "production" &&
	            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	addHiddenFinalProp(ObservableMap.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Map");
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            if (property !== undefined)
	                fail$1(("production") !== "production" &&
	                    "It is not possible to get index atoms from arrays");
	            return thing.$mobx.atom;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return getAtom(anyThing._keys);
	            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
	            if (!observable)
	                fail$1(("production") !== "production" &&
	                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail$1(("production") !== "production" && "please specify a property");
	            var observable = thing.$mobx.values[property];
	            if (!observable)
	                fail$1(("production") !== "production" &&
	                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail$1(("production") !== "production" && "Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    if (!thing)
	        fail$1("Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    initializeInstance(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    fail$1(("production") !== "production" && "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	function onBecomeObserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeObserved", thing, arg2, arg3);
	}
	function onBecomeUnobserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
	}
	function interceptHook(hook, thing, arg2, arg3) {
	    var atom = typeof arg2 === "string" ? getAtom(thing, arg2) : getAtom(thing);
	    var cb = typeof arg2 === "string" ? arg3 : arg2;
	    var orig = atom[hook];
	    if (typeof orig !== "function")
	        return fail$1(("production") !== "production" && "Not an atom that can be (un)observed");
	    atom[hook] = function () {
	        orig.call(this);
	        cb.call(this);
	    };
	    return function () {
	        atom[hook] = orig;
	    };
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var Atom;
	var isAtom;
	function declareAtom() {
	    if (Atom)
	        return;
	    Atom = /** @class */ (function () {
	        /**
	         * Create a new atom. For debugging purposes it is recommended to give it a name.
	         * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	         */
	        function AtomImpl(name) {
	            if (name === void 0) { name = "Atom@" + getNextId(); }
	            this.name = name;
	            this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	            this.isBeingObserved = false;
	            this.observers = [];
	            this.observersIndexes = {};
	            this.diffValue = 0;
	            this.lastAccessedBy = 0;
	            this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	        }
	        AtomImpl.prototype.onBecomeUnobserved = function () {
	            // noop
	        };
	        AtomImpl.prototype.onBecomeObserved = function () {
	            /* noop */
	        };
	        /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     * Returns true if there is currently a reactive context.
	     */
	        AtomImpl.prototype.reportObserved = function () {
	            return reportObserved(this);
	        };
	        /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	        AtomImpl.prototype.reportChanged = function () {
	            startBatch();
	            propagateChanged(this);
	            endBatch();
	        };
	        AtomImpl.prototype.toString = function () {
	            return this.name;
	        };
	        return AtomImpl;
	    }());
	    isAtom = createInstanceofPredicate("Atom", Atom);
	}
	function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	    var atom = new Atom(name);
	    onBecomeObserved(atom, onBecomeObservedHandler);
	    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
	    return atom;
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */ (function () {
	    function StubArray() {
	    }
	    return StubArray;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.atom = new Atom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined && this.values.length > 0)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = EMPTY_ARRAY;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems =
	            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	        var _a;
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(__assign({}, change, { name: this.atom.name }));
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray = /** @class */ (function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            _this.spliceWithArray(0, 0, initialValues);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        if (arguments.length === 3)
	            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = __spread(oldItems.slice(0, toIndex), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
	                .values
	                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray));
	declareIterator(ObservableArray.prototype, function () {
	    
	    this.$mobx.atom.reportObserved();
	    var self = this;
	    var nextIndex = 0;
	    return makeIterable({
	        next: function () {
	            return nextIndex < self.length
	                ? { value: self[nextIndex++], done: false }
	                : { done: true, value: undefined };
	        }
	    });
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	    addHiddenProp(ObservableArray.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Array");
	}
	// Internet Explorer on desktop doesn't support this.....
	// So, let's don't do this to avoid different semantics
	// See #1395
	// addHiddenProp(
	//     ObservableArray.prototype,
	//     typeof Symbol !== "undefined" ? Symbol.isConcatSpreadable as any : "@@isConcatSpreadable",
	//     {
	//         enumerable: false,
	//         configurable: true,
	//         value: true
	//     }
	// )
	/**
	 * Wrap function from prototype
	 */
	
	[
	    "every",
	    "filter",
	    "forEach",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "map",
	    "reduce",
	    "reduceRight",
	    "slice",
	    "some",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	var EMPTY_OBJECT = {};
	Object.freeze(EMPTY_OBJECT);
	function getGlobal() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail$1(message) {
	    invariant(false, message);
	    throw "X"; // unreachable
	}
	function invariant(check, message) {
	    if (!check)
	        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg, thing) {
	    if (true)
	        return false;
	    if (thing) {
	        return deprecated("'" + msg + "', use '" + thing + "' instead.");
	    }
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    if (false)
	        fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
	        return true;
	    return false;
	}
	function getMapLikeKeys(map) {
	    if (isPlainObject(map))
	        return Object.keys(map);
	    if (Array.isArray(map))
	        return map.map(function (_a) {
	            var _b = __read(_a, 1), key = _b[0];
	            return key;
	        });
	    if (isES6Map(map) || isObservableMap(map))
	        return iteratorToArray(map.keys());
	    return fail$1("Cannot get keys from '" + map + "'");
	}
	// use Array.from in Mobx 5
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = [
	    "mobxGuid",
	    "spyListeners",
	    "enforceActions",
	    "computedRequiresReaction",
	    "disableErrorBoundaries",
	    "runId"
	];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         */
	        this.version = 5;
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.enforceActions = false;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	        /**
	         * Warn if computed values are accessed outside a reactive context
	         */
	        this.computedRequiresReaction = false;
	        /*
	         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
	         * the stack when an exception occurs while debugging.
	         */
	        this.disableErrorBoundaries = false;
	    }
	    return MobXGlobals;
	}());
	var globalState = new MobXGlobals();
	var runInIsolationCalled = false;
	{
	    var global_1 = getGlobal();
	    if (!global_1.__mobxInstanceCount) {
	        global_1.__mobxInstanceCount = 1;
	    }
	    else {
	        global_1.__mobxInstanceCount++;
	        setTimeout(function () {
	            if (!runInIsolationCalled) {
	                fail$1(("production") !== "production" &&
	                    "There are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	            }
	        }, 1);
	    }
	}
	function isolateGlobalState() {
	    runInIsolationCalled = true;
	    getGlobal().__mobxInstanceCount--;
	}
	function getGlobalState() {
	    return globalState;
	}
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.enforceActions;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	// function invariantObservers(observable: IObservable) {
	//     const list = observable.observers
	//     const map = observable.observersIndexes
	//     const l = list.length
	//     for (let i = 0; i < l; i++) {
	//         const id = list[i].__mapid
	//         if (i) {
	//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
	//         } else {
	//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
	//         }
	//     }
	//     invariant(
	//         list.length === 0 || Object.keys(map).length === list.length - 1,
	//         "INTERNAL ERROR there is no junk in map"
	//     )
	// }
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (observable.isPendingUnobservation === false) {
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                if (observable.isBeingObserved) {
	                    // if this observable had reactive observers, trigger the hooks
	                    observable.isBeingObserved = false;
	                    observable.onBecomeUnobserved();
	                }
	                if (observable instanceof ComputedValue) {
	                    // computed values are automatically teared down when the last observer leaves
	                    // this process happens recursively, this computed might be the last observabe of another, etc..
	                    observable.suspend();
	                }
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	            if (!observable.isBeingObserved) {
	                observable.isBeingObserved = true;
	                observable.onBecomeObserved();
	            }
	        }
	        return true;
	    }
	    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
	        queueForUnobservation(observable);
	    }
	    return false;
	}
	// function invariantLOS(observable: IObservable, msg: string) {
	//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
	//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
	//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
	//     throw new Error(
	//         "lowestObserverState is wrong for " +
	//             msg +
	//             " because " +
	//             min +
	//             " < " +
	//             observable.lowestObserverState
	//     )
	// }
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    if (globalState.disableErrorBoundaries) {
	                        obj.get();
	                    }
	                    else {
	                        try {
	                            obj.get();
	                        }
	                        catch (e) {
	                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                            untrackedEnd(prevUntracked);
	                            return true;
	                        }
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            return false;
	        }
	    }
	}
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers$$1)
	        fail$1(("production") !== "production" &&
	            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && (hasObservers$$1 || globalState.enforceActions === "strict"))
	        fail$1(("production") !== "production" &&
	            (globalState.enforceActions
	                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
	                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
	                atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    if (globalState.disableErrorBoundaries === true) {
	        result = f.call(context);
	    }
	    else {
	        try {
	            result = f.call(context);
	        }
	        catch (e) {
	            result = new CaughtException(e);
	        }
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail$1(("production") !== "production" &&
	            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate, errorHandler) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.errorHandler = errorHandler;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                try {
	                    this.onInvalidate();
	                    if (this._isTrackPending && isSpyEnabled()) {
	                        // onInvalidate didn't trigger track right away..
	                        spyReport({
	                            name: this.name,
	                            type: "scheduled-reaction"
	                        });
	                    }
	                }
	                catch (e) {
	                    this.reportExceptionInDerivation(e);
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                name: this.name,
	                type: "reaction"
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        if (globalState.disableErrorBoundaries)
	            throw error;
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
	        console.error(message, error);
	        /** If debugging brought you here, please, read the above message :-). Tnx! */
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                name: this.name,
	                message: message,
	                error: "" + error
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	function when(predicate, arg1, arg2) {
	    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
	        return whenPromise(predicate, arg1);
	    return _when(predicate, arg1, arg2 || {});
	}
	function _when(predicate, effect, opts) {
	    var timeoutHandle;
	    if (typeof opts.timeout === "number") {
	        timeoutHandle = setTimeout(function () {
	            if (!disposer.$mobx.isDisposed) {
	                disposer();
	                var error = new Error("WHEN_TIMEOUT");
	                if (opts.onError)
	                    opts.onError(error);
	                else
	                    throw error;
	            }
	        }, opts.timeout);
	    }
	    opts.name = opts.name || "When@" + getNextId();
	    var effectAction = createAction(opts.name + "-effect", effect);
	    var disposer = autorun(function (r) {
	        if (predicate()) {
	            r.dispose();
	            if (timeoutHandle)
	                clearTimeout(timeoutHandle);
	            effectAction();
	        }
	    }, opts);
	    return disposer;
	}
	function whenPromise(predicate, opts) {
	    if (false)
	        return fail$1("the options 'onError' and 'promise' cannot be combined");
	    var cancel;
	    var res = new Promise(function (resolve, reject) {
	        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
	        cancel = function () {
	            disposer();
	            reject("WHEN_CANCELLED");
	        };
	    });
	    res.cancel = cancel;
	    return res;
	}
	
	function keys(obj) {
	    if (isObservableObject(obj)) {
	        return obj.$mobx.getKeys();
	    }
	    if (isObservableMap(obj)) {
	        return obj._keys.slice();
	    }
	    return fail$1(("production") !== "production" &&
	        "'keys()' can only be used on observable objects and maps");
	}
	function values(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) { return obj[key]; });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) { return obj.get(key); });
	    }
	    if (isObservableArray(obj)) {
	        return obj.slice();
	    }
	    return fail$1(("production") !== "production" &&
	        "'values()' can only be used on observable objects, arrays and maps");
	}
	function set(obj, key, value) {
	    if (arguments.length === 2) {
	        startBatch();
	        var values_1 = key;
	        try {
	            for (var key_1 in values_1)
	                set(obj, key_1, values_1[key_1]);
	        }
	        finally {
	            endBatch();
	        }
	        return;
	    }
	    if (isObservableObject(obj)) {
	        var adm = obj.$mobx;
	        var existingObservable = adm.values[key];
	        if (existingObservable) {
	            adm.write(obj, key, value);
	        }
	        else {
	            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
	        }
	    }
	    else if (isObservableMap(obj)) {
	        obj.set(key, value);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        startBatch();
	        if (key >= obj.length)
	            obj.length = key + 1;
	        obj[key] = value;
	        endBatch();
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'set()' can only be used on observable objects, arrays and maps");
	    }
	}
	function remove(obj, key) {
	    if (isObservableObject(obj)) {
	        
	        obj.$mobx.remove(key);
	    }
	    else if (isObservableMap(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        obj.splice(key, 1);
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'remove()' can only be used on observable objects, arrays and maps");
	    }
	}
	function has$1(obj, key) {
	    if (isObservableObject(obj)) {
	        // return keys(obj).indexOf(key) >= 0
	        var adm = getAdministration(obj);
	        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
	        return adm.values[key] instanceof ObservableValue;
	    }
	    else if (isObservableMap(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableArray(obj)) {
	        return key >= 0 && key < obj.length;
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'has()' can only be used on observable objects, arrays and maps");
	    }
	}
	function get(obj, key) {
	    if (!has$1(obj, key))
	        return undefined;
	    if (isObservableObject(obj)) {
	        return obj[key];
	    }
	    else if (isObservableMap(obj)) {
	        return obj.get(key);
	    }
	    else if (isObservableArray(obj)) {
	        return obj[key];
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "'get()' can only be used on observable objects, arrays and maps");
	    }
	}
	
	function decorate(thing, decorators) {
	    ("production") !== "production" &&
	        invariant(isPlainObject(decorators), "Decorators should be a key value map");
	    var target = typeof thing === "function" ? thing.prototype : thing;
	    for (var prop in decorators) {
	        var decorator = decorators[prop];
	        ("production") !== "production" &&
	            invariant(typeof decorator === "function", "Decorate: expected a decorator function for '" + prop + "'");
	        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
	        var newDescriptor = decorator(target, prop, descriptor);
	        if (newDescriptor)
	            Object.defineProperty(target, prop, newDescriptor);
	    }
	    return thing;
	}
	
	function configure(options) {
	    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
	    if (enforceActions !== undefined) {
	        if (typeof enforceActions !== "boolean" && enforceActions !== "strict")
	            return fail("Invalid configuration for 'enforceActions': " + enforceActions);
	        globalState.enforceActions = enforceActions;
	        globalState.allowStateChanges =
	            enforceActions === true || enforceActions === "strict" ? false : true;
	    }
	    if (computedRequiresReaction !== undefined) {
	        globalState.computedRequiresReaction = !!computedRequiresReaction;
	    }
	    if (options.isolateGlobalState === true) {
	        isolateGlobalState();
	    }
	    if (disableErrorBoundaries !== undefined) {
	        if (disableErrorBoundaries === true)
	            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
	        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
	    }
	    if (typeof arrayBuffer === "number") {
	        reserveArrayBuffer(arrayBuffer);
	    }
	    if (reactionScheduler) {
	        setReactionScheduler(reactionScheduler);
	    }
	}
	
	var generatorId = 0;
	function flow(generator) {
	    if (arguments.length !== 1)
	        fail$1(("production") && "Flow expects one 1 argument and cannot be used as decorator");
	    var name = generator.name || "<unnamed flow>";
	    // Implementation based on https://github.com/tj/co/blob/master/index.js
	    return function () {
	        var ctx = this;
	        var args = arguments;
	        var runId = ++generatorId;
	        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
	        var rejector;
	        var pendingPromise = undefined;
	        var res = new Promise(function (resolve, reject) {
	            var stepId = 0;
	            rejector = reject;
	            function onFulfilled(res) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function onRejected(err) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret && typeof ret.then === "function") {
	                    // an async iterator
	                    ret.then(next, reject);
	                    return;
	                }
	                if (ret.done)
	                    return resolve(ret.value);
	                pendingPromise = Promise.resolve(ret.value);
	                return pendingPromise.then(onFulfilled, onRejected);
	            }
	            onFulfilled(undefined); // kick off the process
	        });
	        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
	            try {
	                if (pendingPromise)
	                    cancelPromise(pendingPromise);
	                // Finally block can return (or yield) stuff..
	                var res_1 = gen.return();
	                // eat anything that promise would do, it's cancelled!
	                var yieldedPromise = Promise.resolve(res_1.value);
	                yieldedPromise.then(noop, noop);
	                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
	                // reject our original promise
	                rejector(new Error("FLOW_CANCELLED"));
	            }
	            catch (e) {
	                rejector(e); // there could be a throwing finally block
	            }
	        });
	        return res;
	    };
	}
	function cancelPromise(promise) {
	    if (typeof promise.cancel === "function")
	        promise.cancel();
	}
	
	var defaultOptions = {
	    detectCycles: true,
	    exportMapsAsObjects: true
	};
	function cache(map, key, value, options) {
	    if (options.detectCycles)
	        map.set(key, value);
	    return value;
	}
	function toJSHelper(source, options, __alreadySeen) {
	    if (!isObservable(source))
	        return source;
	    var detectCycles = options.detectCycles === true;
	    if (detectCycles &&
	        source !== null &&
	        typeof source === "object" &&
	        __alreadySeen.has(source)) {
	        return __alreadySeen.get(source);
	    }
	    if (isObservableArray(source)) {
	        var res = cache(__alreadySeen, source, [], options);
	        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
	        res.length = toAdd.length;
	        for (var i = 0, l = toAdd.length; i < l; i++)
	            res[i] = toAdd[i];
	        return res;
	    }
	    if (isObservableObject(source)) {
	        var res = cache(__alreadySeen, source, {}, options);
	        keys(source); // make sure we track the keys of the object
	        for (var key in source) {
	            res[key] = toJSHelper(source[key], options, __alreadySeen);
	        }
	        return res;
	    }
	    if (isObservableMap(source)) {
	        if (options.exportMapsAsObjects === false) {
	            var res_1 = cache(__alreadySeen, source, new Map(), options);
	            source.forEach(function (value, key) {
	                res_1.set(key, toJSHelper(value, options, __alreadySeen));
	            });
	            return res_1;
	        }
	        else {
	            var res_2 = cache(__alreadySeen, source, {}, options);
	            source.forEach(function (value, key) {
	                res_2[key] = toJSHelper(value, options, __alreadySeen);
	            });
	            return res_2;
	        }
	    }
	    if (isObservableValue(source))
	        return toJSHelper(source.get(), options, __alreadySeen);
	    return source;
	}
	function toJS(source, options) {
	    if (!isObservable(source))
	        return source;
	    // backward compatibility
	    if (typeof options === "boolean")
	        options = { detectCycles: options };
	    if (!options)
	        options = defaultOptions;
	    var detectCycles = options.detectCycles === true;
	    var __alreadySeen;
	    if (detectCycles)
	        __alreadySeen = new Map();
	    return toJSHelper(source, options, __alreadySeen);
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail$1(("production") !== "production" &&
	                "InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail$1(("production") !== "production" &&
	            "Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail$1(("production") !== "production" && "An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2016
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	try {
	    // define process.env if needed
	    // if this is not a production build in the first place
	    // (in which case the expression below would be substituted with 'production')
	    ("production");
	}
	catch (e) {
	    var g = typeof window !== "undefined" ? window : global;
	    if (typeof process === "undefined")
	        g.process = {};
	    g.process.env = {};
	}
	
	(function () {
	    function testCodeMinification() { }
	    if (testCodeMinification.name !== "testCodeMinification" &&
	        ("production") !== "production") {
	        console.warn("[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
	    }
	})();
	// This line should come after all the imports as well, for the same reason
	// as noted above. I will file a bug with rollupjs - @rossipedia
	// Devtools support
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    // See: https://github.com/andykog/mobx-devtools/
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
	        spy: spy,
	        extras: {
	            getDebugName: getDebugName
	        }
	    });
	}
	// TODO: remove in some future build
	if (false) {
	    var warnedAboutDefaultExport_1 = false;
	    Object.defineProperty(module.exports, "default", {
	        enumerable: false,
	        get: function () {
	            if (!warnedAboutDefaultExport_1) {
	                warnedAboutDefaultExport_1 = true;
	                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
	            }
	            return undefined;
	        }
	    });
	    [
	        "extras",
	        "Atom",
	        "BaseAtom",
	        "asFlat",
	        "asMap",
	        "asReference",
	        "asStructure",
	        "autorunAsync",
	        "createTranformer",
	        "expr",
	        "isModifierDescriptor",
	        "isStrictModeEnabled",
	        "map",
	        "useStrict",
	        "whyRun"
	    ].forEach(function (prop) {
	        Object.defineProperty(module.exports, prop, {
	            enumerable: false,
	            get: function () {
	                fail$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
	            },
	            set: function () { }
	        });
	    });
	}
	
	exports.Reaction = Reaction;
	exports.untracked = untracked;
	exports.createAtom = createAtom;
	exports.spy = spy;
	exports.comparer = comparer;
	exports.isObservableObject = isObservableObject;
	exports.isBoxedObservable = isObservableValue;
	exports.isObservableArray = isObservableArray;
	exports.ObservableMap = ObservableMap;
	exports.isObservableMap = isObservableMap;
	exports.transaction = transaction;
	exports.observable = observable;
	exports.computed = computed;
	exports.isObservable = isObservable;
	exports.isObservableProp = isObservableProp;
	exports.isComputed = isComputed;
	exports.isComputedProp = isComputedProp;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.observe = observe;
	exports.intercept = intercept;
	exports.autorun = autorun;
	exports.reaction = reaction;
	exports.when = when;
	exports.action = action;
	exports.isAction = isAction;
	exports.runInAction = runInAction;
	exports.keys = keys;
	exports.values = values;
	exports.set = set;
	exports.remove = remove;
	exports.has = has$1;
	exports.get = get;
	exports.decorate = decorate;
	exports.configure = configure;
	exports.onBecomeObserved = onBecomeObserved;
	exports.onBecomeUnobserved = onBecomeUnobserved;
	exports.flow = flow;
	exports.toJS = toJS;
	exports.trace = trace;
	exports.getDependencyTree = getDependencyTree;
	exports.getObserverTree = getObserverTree;
	exports._resetGlobalState = resetGlobalState;
	exports._getGlobalState = getGlobalState;
	exports.getDebugName = getDebugName;
	exports.getAtom = getAtom;
	exports._getAdministration = getAdministration;
	exports._allowStateChanges = allowStateChanges;
	exports.isArrayLike = isArrayLike;
	exports._isComputingDerivation = isComputingDerivation;
	exports.onReactionError = onReactionError;
	exports._interceptReads = interceptReads;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), (function() { return this; }())))

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(61)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(104);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(62);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(106);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(61);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(103);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(105);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(104);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(62);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(106);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(61);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(103);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(105);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(104);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(62);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(106);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(343);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(61);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(103);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(105);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(340);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(341);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(342);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(346);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(146);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(62);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(345);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(146);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(11)))

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(107);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*! NoSleep.js v0.7.0 - git.io/vfn01 - Rich Tibbett - MIT license */
	(function webpackUniversalModuleDefinition(root, factory) {
	    if (true) module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["NoSleep"] = factory();else root["NoSleep"] = factory();
	})(undefined, function () {
	    return (/******/function (modules) {
	            /******/ // The module cache
	            /******/var installedModules = {};
	            /******/
	            /******/ // The require function
	            /******/function __webpack_require__(moduleId) {
	                /******/
	                /******/ // Check if module is in cache
	                /******/if (installedModules[moduleId]) {
	                    /******/return installedModules[moduleId].exports;
	                    /******/
	                }
	                /******/ // Create a new module (and put it into the cache)
	                /******/var module = installedModules[moduleId] = {
	                    /******/i: moduleId,
	                    /******/l: false,
	                    /******/exports: {}
	                    /******/
	                };
	                /******/
	                /******/ // Execute the module function
	                /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	                /******/
	                /******/ // Flag the module as loaded
	                /******/module.l = true;
	                /******/
	                /******/ // Return the exports of the module
	                /******/return module.exports;
	                /******/
	            }
	            /******/
	            /******/
	            /******/ // expose the modules object (__webpack_modules__)
	            /******/__webpack_require__.m = modules;
	            /******/
	            /******/ // expose the module cache
	            /******/__webpack_require__.c = installedModules;
	            /******/
	            /******/ // define getter function for harmony exports
	            /******/__webpack_require__.d = function (exports, name, getter) {
	                /******/if (!__webpack_require__.o(exports, name)) {
	                    /******/Object.defineProperty(exports, name, {
	                        /******/configurable: false,
	                        /******/enumerable: true,
	                        /******/get: getter
	                        /******/
	                    });
	                    /******/
	                }
	                /******/
	            };
	            /******/
	            /******/ // getDefaultExport function for compatibility with non-harmony modules
	            /******/__webpack_require__.n = function (module) {
	                /******/var getter = module && module.__esModule ?
	                /******/function getDefault() {
	                    return module['default'];
	                } :
	                /******/function getModuleExports() {
	                    return module;
	                };
	                /******/__webpack_require__.d(getter, 'a', getter);
	                /******/return getter;
	                /******/
	            };
	            /******/
	            /******/ // Object.prototype.hasOwnProperty.call
	            /******/__webpack_require__.o = function (object, property) {
	                return Object.prototype.hasOwnProperty.call(object, property);
	            };
	            /******/
	            /******/ // __webpack_public_path__
	            /******/__webpack_require__.p = "";
	            /******/
	            /******/ // Load entry module and return exports
	            /******/return __webpack_require__(__webpack_require__.s = 0);
	            /******/
	        }([
	        /* 0 */
	        /***/function (module, exports, __webpack_require__) {
	            "use strict";
	
	            var _createClass = function () {
	                function defineProperties(target, props) {
	                    for (var i = 0; i < props.length; i++) {
	                        var descriptor = props[i];
	                        descriptor.enumerable = descriptor.enumerable || false;
	                        descriptor.configurable = true;
	                        if ("value" in descriptor) descriptor.writable = true;
	                        Object.defineProperty(target, descriptor.key, descriptor);
	                    }
	                }return function (Constructor, protoProps, staticProps) {
	                    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	                };
	            }();
	            function _classCallCheck(instance, Constructor) {
	                if (!(instance instanceof Constructor)) {
	                    throw new TypeError("Cannot call a class as a function");
	                }
	            }
	            var mediaFile = __webpack_require__(1);
	            // Detect iOS browsers < version 10
	            var oldIOS = typeof navigator !== 'undefined' && parseFloat(('' + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) < 10 && !window.MSStream;
	            var NoSleep = function () {
	                function NoSleep() {
	                    _classCallCheck(this, NoSleep);
	                    if (oldIOS) {
	                        this.noSleepTimer = null;
	                    } else {
	                        // Set up no sleep video element
	                        this.noSleepVideo = document.createElement('video');
	                        this.noSleepVideo.setAttribute('playsinline', '');
	                        this.noSleepVideo.setAttribute('src', mediaFile);
	                        this.noSleepVideo.addEventListener('timeupdate', function (e) {
	                            if (this.noSleepVideo.currentTime > 0.5) {
	                                this.noSleepVideo.currentTime = Math.random();
	                            }
	                        }.bind(this));
	                    }
	                }
	                _createClass(NoSleep, [{
	                    key: 'enable',
	                    value: function enable() {
	                        if (oldIOS) {
	                            this.disable();
	                            this.noSleepTimer = window.setInterval(function () {
	                                window.location.href = '/';
	                                window.setTimeout(window.stop, 0);
	                            }, 15000);
	                        } else {
	                            this.noSleepVideo.play();
	                        }
	                    }
	                }, {
	                    key: 'disable',
	                    value: function disable() {
	                        if (oldIOS) {
	                            if (this.noSleepTimer) {
	                                window.clearInterval(this.noSleepTimer);
	                                this.noSleepTimer = null;
	                            }
	                        } else {
	                            this.noSleepVideo.pause();
	                        }
	                    }
	                }]);
	                return NoSleep;
	            }();
	            ;
	            module.exports = NoSleep;
	            /***/
	        },
	        /* 1 */
	        /***/function (module, exports, __webpack_require__) {
	            "use strict";
	
	            module.exports = 'data:video/mp4;base64,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';
	            /***/
	        }]
	        /******/
	        )
	    );
	});

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var Timer = function () {
	    function Timer(duration, playCallback, pauseCallback, endCallback) {
	        _classCallCheck(this, Timer);
	
	        this.isPlaying = false;
	        this.currentDuration = duration;
	        this.totalDuration = duration;
	        this.playCallback = playCallback;
	        this.pauseCallback = pauseCallback;
	        this.endCallback = endCallback;
	    }
	
	    Timer.prototype.play = function play() {
	        if (this.isPlaying) {
	            return;
	        }
	        // Mark original starting time
	        this.startTime = new Date().getTime();
	        this.isPlaying = true;
	        this.timeoutId = window.setTimeout(this.end.bind(this), this.currentDuration);
	        if (this.playCallback) {
	            this.playCallback();
	        }
	    };
	
	    Timer.prototype.pause = function pause() {
	        if (!this.isPlaying) {
	            return;
	        }
	        var elapsedTime = new Date().getTime() - this.startTime;
	        delete this.startTime;
	        window.clearTimeout(this.timeoutId);
	        delete this.timeoutId;
	        this.currentDuration -= elapsedTime;
	        this.isPlaying = false;
	        if (this.pauseCallback) {
	            this.pauseCallback();
	        }
	    };
	
	    Timer.prototype.stop = function stop() {
	        window.clearTimeout(this.timeoutId);
	        delete this.timeoutId;
	    };
	
	    Timer.prototype.end = function end() {
	        window.clearTimeout(this.timeoutId);
	        delete this.timeoutId;
	        if (this.endCallback) {
	            this.endCallback();
	        }
	    };
	
	    Timer.prototype.getPercentageComplete = function getPercentageComplete() {
	        var elapsedTime = new Date().getTime() - this.startTime;
	        var percentage = (this.totalDuration - (this.currentDuration - elapsedTime)) / this.totalDuration;
	        return Number(percentage.toPrecision(2));
	    };
	
	    return Timer;
	}();
	
	exports.default = Timer;

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var player_1 = __webpack_require__(17);
	__webpack_require__(322);
	var CardProgress_1 = __webpack_require__(160);
	var Icon_1 = __webpack_require__(23);
	var keyword = '___';
	var markSmalls = function markSmalls(text) {
	    var parts = text.split(new RegExp("(" + keyword + ")", 'gi'));
	    var output = [];
	    for (var i = 0; i < parts.length; i++) {
	        if (parts[i].toLowerCase() === keyword.toLowerCase()) {
	            // output.push(<small key={i}>{parts[i + 1]}</small>)
	            i += 2;
	        } else {
	            output.push(parts[i]);
	        }
	    }
	    return output;
	};
	var Card = function (_React$Component) {
	    _inherits(Card, _React$Component);
	
	    function Card() {
	        _classCallCheck(this, Card);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.handlePausePlayClick = function () {
	            var store = _this.injected.store;
	
	            store.player.setPlayerState(store.player.state === player_1.PlayerState.playing ? player_1.PlayerState.paused : player_1.PlayerState.playing);
	        };
	        return _this;
	    }
	
	    Card.prototype.render = function render() {
	        var interpolatedStyles = this.props.interpolatedStyles;
	
	        return React.createElement("div", { className: 'card', style: {
	                opacity: interpolatedStyles.opacity,
	                transform: "translate3d(" + interpolatedStyles.translateX + "px, " + interpolatedStyles.translateY + "px, 0) rotate(" + interpolatedStyles.rotation + "deg)"
	            } }, this.renderCardContent());
	    };
	
	    Card.prototype.renderCardContent = function renderCardContent() {
	        var store = this.injected.store;
	        var _props = this.props,
	            visibleIndex = _props.visibleIndex,
	            card = _props.card,
	            images = _props.images;
	
	        var content = null;
	        if (card.source) {
	            content = React.createElement("blockquote", { className: "card__quote" }, React.createElement("p", null, " \u201C", card.title, "\u201D"), React.createElement("cite", null, "\u2014 ", card.source));
	        } else if (card.image) {
	            var imageURL = images.get(card.image);
	            content = React.createElement(React.Fragment, null, React.createElement("img", { className: "card__image", src: imageURL }), React.createElement("h1", { className: "card__title small_title card__title--center" }, markSmalls(card.title)));
	        } else {
	            content = React.createElement("h1", { className: "card__title small_title" }, markSmalls(card.title));
	        }
	        return React.createElement(React.Fragment, null, content, React.createElement("div", { className: "card__partners" + (" card__partners--" + card.partner) }, React.createElement("div", { className: "card__partner card__partner--one", style: {
	                backgroundColor: store.player.playerOneColor
	            } }, React.createElement("div", { className: "card__partner__avatar" }), React.createElement("span", { className: "card__partner__number" }, "1")), React.createElement("div", { className: "card__partner card__partner--two", style: {
	                backgroundColor: store.player.playerTwoColor
	            } }, React.createElement("div", { className: "card__partner__avatar" }), React.createElement("span", { className: "card__partner__number" }, "2"))), React.createElement("div", { className: "card__bottom" }, React.createElement(CardProgress_1.default, { shouldUpdate: visibleIndex === 0 }), React.createElement("button", { onClick: this.handlePausePlayClick, className: 'card__pauseplay' + ' ' + ("card__pauseplay--" + (store.player.state === player_1.PlayerState.playing ? 'playing' : 'paused')) }, store.player.state === player_1.PlayerState.playing ? React.createElement(Icon_1.default, { className: "card__pauseplay__icon", name: Icon_1.IconName.pause }) : React.createElement(Icon_1.default, { className: "card__pauseplay__icon", name: Icon_1.IconName.play }))));
	    };
	
	    _createClass(Card, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return Card;
	}(React.Component);
	Card = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], Card);
	exports.default = Card;

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var CircularProgressBar_1 = __webpack_require__(111);
	var CardProgress = function (_React$Component) {
	    _inherits(CardProgress, _React$Component);
	
	    function CardProgress() {
	        _classCallCheck(this, CardProgress);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    CardProgress.prototype.render = function render() {
	        var store = this.injected.store;
	        var shouldUpdate = this.props.shouldUpdate;
	
	        return React.createElement("div", { className: 'card__progress card__progress--visible' }, React.createElement(CircularProgressBar_1.default, { fillColor: '#000', percentage: shouldUpdate ? store.player.progressPercentage * 100 : 0, diameter: 60, strokeWidth: 7 }));
	    };
	
	    _createClass(CardProgress, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return CardProgress;
	}(React.Component);
	CardProgress = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], CardProgress);
	exports.default = CardProgress;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var react_motion_1 = __webpack_require__(344);
	var ReactTooltip = __webpack_require__(35);
	var constants_1 = __webpack_require__(36);
	var Card_1 = __webpack_require__(159);
	var Icon_1 = __webpack_require__(23);
	var SecondaryButton_1 = __webpack_require__(45);
	var CardStack = function (_React$Component) {
	    _inherits(CardStack, _React$Component);
	
	    function CardStack() {
	        _classCallCheck(this, CardStack);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.state = {
	            dragStartTime: 0,
	            pos: { x: 0, y: 0 },
	            startPos: { x: 0, y: 0 },
	            vel: { x: 0, y: 0 }
	        };
	        _this.getDefaultStyles = function () {
	            var store = _this.injected.store;
	
	            var visibleCards = store.visibleCards;
	            return visibleCards.map(function (visibleCard, i) {
	                return {
	                    data: {
	                        card: visibleCard
	                    },
	                    key: 'card-' + visibleCard.title,
	                    style: {
	                        opacity: 0,
	                        rotation: Math.floor((Math.random() - 0.5) * constants_1.CARD_ROTATION_AMOUNT),
	                        translateX: Math.floor((Math.random() - 0.5) * constants_1.CARD_MOVEMENT_DISTANCE),
	                        translateY: Math.floor((Math.random() - 0.5) * constants_1.CARD_MOVEMENT_DISTANCE)
	                    }
	                };
	            });
	        };
	        _this.getStyles = function () {
	            var store = _this.injected.store;
	            var _this$state = _this.state,
	                dragStartTime = _this$state.dragStartTime,
	                pos = _this$state.pos,
	                startPos = _this$state.startPos;
	
	            var visibleCards = store.visibleCards;
	            return visibleCards.map(function (visibleCard, i) {
	                var x = 0;
	                var y = 0;
	                var distanceRotation = 0;
	                var o = 1;
	                if (dragStartTime !== 0) {
	                    var delta = {
	                        x: pos.x - startPos.x,
	                        y: pos.y - startPos.y
	                    };
	                    x = delta.x;
	                    y = delta.y;
	                    var sign = Math.sign(delta.x);
	                    var distance = Math.sqrt(delta.x * delta.x + delta.y * delta.y);
	                    distanceRotation = sign * distance / 100 * 5;
	                    o = 1 - distance / 100;
	                }
	                var opacity = i === 0 ? o : Number(Math.max(0, 1 - i * 0.4).toPrecision(2));
	                var rotation = i === 0 ? distanceRotation : _this.getPseudoRandomRotation(visibleCard.title);
	                var translateX = i === 0 ? x : 0;
	                var translateY = i === 0 ? y : 0;
	                var preset = dragStartTime ? react_motion_1.presets.stiff : react_motion_1.presets.gentle;
	                return {
	                    data: {
	                        card: visibleCard
	                    },
	                    key: 'card-' + visibleCard.title,
	                    style: {
	                        opacity: react_motion_1.spring(opacity, preset),
	                        rotation: react_motion_1.spring(rotation, preset),
	                        translateX: react_motion_1.spring(translateX, preset),
	                        translateY: react_motion_1.spring(translateY, preset)
	                    }
	                };
	            });
	        };
	        _this.willEnterHandler = function (styledCard) {
	            return {
	                opacity: 0,
	                rotation: Math.floor((Math.random() - 0.5) * constants_1.CARD_ROTATION_AMOUNT),
	                translateX: Math.floor((Math.random() - 0.5) * constants_1.CARD_MOVEMENT_DISTANCE),
	                translateY: Math.floor((Math.random() - 0.5) * constants_1.CARD_MOVEMENT_DISTANCE)
	            };
	        };
	        _this.willLeaveHandler = function (styledCard) {
	            return {
	                opacity: react_motion_1.spring(0, react_motion_1.presets.stiff),
	                rotation: react_motion_1.spring(10, react_motion_1.presets.gentle),
	                translateX: react_motion_1.spring(0, react_motion_1.presets.gentle),
	                translateY: react_motion_1.spring(10, react_motion_1.presets.gentle)
	            };
	        };
	        _this.handleMouseDown = function (e) {
	            var targetClasses = e.target.classList;
	            if (!targetClasses.contains('card__toucharea')) {
	                return;
	            }
	            e.preventDefault();
	            _this.setState({
	                dragStartTime: new Date().getTime(),
	                pos: {
	                    x: e.clientX,
	                    y: e.clientY
	                },
	                startPos: {
	                    x: e.clientX,
	                    y: e.clientY
	                }
	            });
	        };
	        _this.handleTouchStart = function (e) {
	            var targetClasses = e.target.classList;
	            if (!targetClasses.contains('card__toucharea')) {
	                return;
	            }
	            e.preventDefault();
	            var touch = e.targetTouches[0];
	            _this.setState({
	                dragStartTime: new Date().getTime(),
	                pos: {
	                    x: touch.clientX,
	                    y: touch.clientY
	                },
	                startPos: {
	                    x: touch.clientX,
	                    y: touch.clientY
	                }
	            });
	        };
	        _this.handleTouchMove = function (e) {
	            if (!_this.state.dragStartTime) {
	                return;
	            }
	            e.preventDefault();
	            var touch = e.targetTouches[0];
	            _this.setState({
	                pos: {
	                    x: touch.clientX,
	                    y: touch.clientY
	                }
	            });
	        };
	        _this.handleMouseMove = function (e) {
	            if (!_this.state.dragStartTime) {
	                return;
	            }
	            e.preventDefault();
	            _this.setState({
	                pos: {
	                    x: e.clientX,
	                    y: e.clientY
	                }
	            });
	        };
	        _this.handleTouchEnd = function (e) {
	            if (!_this.state.dragStartTime) {
	                return;
	            }
	            e.preventDefault();
	            _this.endPanHandler();
	        };
	        _this.handleMouseUp = function (e) {
	            if (!_this.state.dragStartTime) {
	                return;
	            }
	            e.preventDefault();
	            _this.endPanHandler();
	        };
	        _this.endPanHandler = function () {
	            var _this$state2 = _this.state,
	                dragStartTime = _this$state2.dragStartTime,
	                pos = _this$state2.pos,
	                startPos = _this$state2.startPos;
	            var store = _this.injected.store;
	
	            var delta = {
	                x: pos.x - startPos.x,
	                y: pos.y - startPos.y
	            };
	            var endTime = new Date().getTime();
	            var vel = {
	                x: Math.abs(delta.x) / (endTime - dragStartTime),
	                y: Math.abs(delta.y) / (endTime - dragStartTime)
	            };
	            var magnitude = Math.sqrt(vel.x * vel.x + vel.y * vel.y);
	            if (magnitude > 0.1) {
	                store.completeEvent();
	            }
	            _this.setState({
	                dragStartTime: 0,
	                pos: { x: 0, y: 0 },
	                startPos: { x: 0, y: 0 }
	            }, function () {
	                if (_this) {
	                    _this.forceUpdate();
	                }
	            });
	        };
	        _this.handlePrevClick = function () {
	            var store = _this.injected.store;
	
	            store.undoCompleteEvent();
	        };
	        _this.handleNextClick = function () {
	            var store = _this.injected.store;
	
	            store.completeEvent();
	        };
	        _this.handleEndClick = function () {
	            var store = _this.injected.store;
	
	            store.player.reset();
	        };
	        return _this;
	    }
	
	    CardStack.prototype.componentDidMount = function componentDidMount() {
	        window.addEventListener('touchmove', this.handleTouchMove, {
	            passive: false
	        });
	        window.addEventListener('touchend', this.handleTouchEnd);
	        window.addEventListener('mousemove', this.handleMouseMove, {
	            passive: false
	        });
	        window.addEventListener('mouseup', this.handleMouseUp);
	    };
	
	    CardStack.prototype.componentWillUnmount = function componentWillUnmount() {
	        window.removeEventListener('touchmove', this.handleTouchMove);
	        window.removeEventListener('touchend', this.handleTouchEnd);
	        window.removeEventListener('mousemove', this.handleMouseMove);
	        window.removeEventListener('mouseup', this.handleMouseUp);
	    };
	
	    CardStack.prototype.render = function render() {
	        var _this2 = this;
	
	        var store = this.injected.store;
	        var images = this.props.images;
	
	        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	        return React.createElement(React.Fragment, null, React.createElement(react_motion_1.TransitionMotion, { defaultStyles: this.getDefaultStyles(), willEnter: this.willEnterHandler, styles: this.getStyles(), willLeave: this.willLeaveHandler }, function (styles) {
	            return React.createElement("div", { className: "cardstack" }, styles.map(function (style, i) {
	                return React.createElement("div", { key: style.key, className: "card__wrapper", style: {
	                        zIndex: 999 - i
	                    } }, React.createElement(Card_1.default, { visibleIndex: i, card: style.data.card, interpolatedStyles: style.style, images: images }), React.createElement("div", { className: "card__toucharea", onMouseDown: _this2.handleMouseDown, onTouchStart: _this2.handleTouchStart }));
	            }));
	        }), React.createElement("div", { className: "cardstack__controls" }, React.createElement(ReactTooltip, { className: "cardstack__tooltip", place: "bottom", "aria-haspopup": "true", disable: isMobile }), React.createElement(SecondaryButton_1.default, { className: "bottomlink", iconName: Icon_1.IconName.prev, callback: this.handlePrevClick }), React.createElement(SecondaryButton_1.default, { className: "bottomlink", iconName: Icon_1.IconName.x, text: "End", callback: this.handleEndClick }), React.createElement(SecondaryButton_1.default, { className: "bottomlink", iconName: Icon_1.IconName.skip, callback: this.handleNextClick })));
	    };
	
	    CardStack.prototype.getStringHash = function getStringHash(input) {
	        var hash = 0;
	        var chr = void 0;
	        if (input.length === 0) {
	            return hash;
	        }
	        for (var i = 0; i < input.length; i++) {
	            chr = input.charCodeAt(i);
	            // tslint:disable-next-line:no-bitwise
	            hash = (hash << 5) - hash + chr;
	            // tslint:disable-next-line:no-bitwise
	            hash |= 0; // Convert to 32bit integer
	        }
	        return hash;
	    };
	
	    CardStack.prototype.getPseudoRandomRotation = function getPseudoRandomRotation(input) {
	        var hash = this.getStringHash(input);
	        var x = Math.sin(hash) * 10000;
	        var random = x - Math.floor(x);
	        var randomRotation = Math.floor((random - 0.5) * constants_1.CARD_ROTATION_AMOUNT);
	        return randomRotation;
	    };
	
	    _createClass(CardStack, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return CardStack;
	}(React.Component);
	CardStack = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], CardStack);
	exports.default = CardStack;

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	__webpack_require__(323);
	var constants_1 = __webpack_require__(36);
	
	var CircularProgressBar = function (_React$PureComponent) {
	    _inherits(CircularProgressBar, _React$PureComponent);
	
	    function CircularProgressBar() {
	        _classCallCheck(this, CircularProgressBar);
	
	        return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	    }
	
	    CircularProgressBar.prototype._getPathRadius = function _getPathRadius() {
	        return this.props.diameter / 2 - this.props.strokeWidth / 2;
	    };
	
	    CircularProgressBar.prototype._getPathDescription = function _getPathDescription() {
	        var radius = this._getPathRadius();
	        var rotation = 0;
	        return "\n      M " + this.props.diameter / 2 + ", " + this.props.diameter / 2 + "\n      m 0,-" + radius + "\n      a " + radius + ", " + radius + " " + rotation + " 1 1 0, " + 2 * radius + "\n      a " + radius + ", " + radius + " " + rotation + " 1 1 0, -" + 2 * radius + "\n    ";
	    };
	
	    CircularProgressBar.prototype._getPathStyles = function _getPathStyles() {
	        var diameter = Math.PI * 2 * this._getPathRadius();
	        var truncatedPercentage = Math.min(Math.max(this.props.percentage, constants_1.MIN_PERCENTAGE), constants_1.MAX_PERCENTAGE);
	        var dashOffset = (100 - truncatedPercentage) / 100 * diameter;
	        return {
	            strokeDasharray: diameter + "px " + diameter + "px",
	            strokeDashoffset: dashOffset + "px"
	        };
	    };
	
	    CircularProgressBar.prototype.render = function render() {
	        var strokeWidth = this.props.strokeWidth;
	
	        var pathDescription = this._getPathDescription();
	        return React.createElement("svg", { className: "cpb", viewBox: "0 0 " + this.props.diameter + " " + this.props.diameter, style: {
	                width: this.props.diameter + "px"
	            } }, React.createElement("path", { className: "cpb__trail", d: pathDescription, strokeWidth: strokeWidth, fillOpacity: 0, style: {
	                stroke: this.props.bgColor
	            } }), React.createElement("path", { className: "cpb__path", d: pathDescription, strokeWidth: strokeWidth, fillOpacity: 0, style: _extends({
	                stroke: this.props.fillColor
	            }, this._getPathStyles()) }));
	    };
	
	    return CircularProgressBar;
	}(React.PureComponent);
	
	CircularProgressBar.props = {
	    fillColor: '#000',
	    bgColor: '#F6F5F3',
	    diameter: 100,
	    percentage: 0,
	    strokeWidth: 14
	};
	exports.default = CircularProgressBar;

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var idx_1 = __webpack_require__(308);
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var player_1 = __webpack_require__(17);
	var CardStack_1 = __webpack_require__(161);
	var CircularProgressBar_1 = __webpack_require__(111);
	var Header_1 = __webpack_require__(14);
	var Icon_1 = __webpack_require__(23);
	var MailingListModal_1 = __webpack_require__(15);
	var ModuleIntro_1 = __webpack_require__(163);
	var Player_1 = __webpack_require__(164);
	var PrimaryButton_1 = __webpack_require__(16);
	__webpack_require__(325);
	var SecondaryButton_1 = __webpack_require__(45);
	var Module = function (_React$Component) {
	    _inherits(Module, _React$Component);
	
	    function Module() {
	        _classCallCheck(this, Module);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.images = new Map();
	        _this.handleEndClick = function () {
	            var store = _this.injected.store;
	
	            store.player.reset();
	            store.player.setPlayerState(player_1.PlayerState.inactive);
	        };
	        _this.handleReplayClick = function () {
	            var store = _this.injected.store;
	
	            store.player.reset();
	            store.player.setPlayerState(player_1.PlayerState.inactive);
	        };
	        return _this;
	    }
	
	    Module.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        var data = this.props.data;
	        var store = this.injected.store;
	        // Store all images (.svg)
	
	        data.allFile.edges.map(function (edge) {
	            var publicURL = idx_1.default(edge, function (_) {
	                return _.node.publicURL;
	            });
	            if (!publicURL) {
	                return;
	            }
	            var ext = publicURL.substr(publicURL.lastIndexOf('.') + 1);
	            if (ext === 'svg') {
	                _this2.images.set(edge.node.name, edge.node.publicURL);
	            }
	        });
	        var script = data.allScriptsYaml.edges[0].node;
	        if (!script) {
	            console.error('Unable to find script for module');
	        }
	        store.loadModule(script);
	        store.player.loadRandomPlayerColors();
	    };
	
	    Module.prototype.componentWillUnmount = function componentWillUnmount() {
	        var store = this.injected.store;
	        // Clear all module data
	
	        store.resetModule();
	    };
	
	    Module.prototype.render = function render() {
	        var store = this.injected.store;
	        var data = this.props.data;
	
	        return React.createElement("div", { className: "module" }, React.createElement("div", { className: "page__backdrop__gradient" }), store.player.state === player_1.PlayerState.inactive ? this.renderIntro() : null, store.player.state === player_1.PlayerState.loading ? this.renderPlayerLoading() : null, store.player.state !== player_1.PlayerState.inactive && store.player.state !== player_1.PlayerState.completed ? React.createElement(Player_1.default, { data: data }) : null, store.player.state === player_1.PlayerState.loaded || store.player.state === player_1.PlayerState.playing || store.player.state === player_1.PlayerState.paused || store.player.state === player_1.PlayerState.ended ? this.renderPlaying() : null, store.player.state === player_1.PlayerState.completed ? this.renderCompleted() : null);
	    };
	
	    Module.prototype.renderIntro = function renderIntro() {
	        var data = this.props.data;
	
	        return React.createElement("div", { className: "page" }, React.createElement(Header_1.default, { bwlogo: true }), React.createElement(ModuleIntro_1.default, { script: data.allScriptsYaml.edges[0].node }));
	    };
	
	    Module.prototype.renderPlayerLoading = function renderPlayerLoading() {
	        var store = this.injected.store;
	        var data = this.props.data;
	
	        return React.createElement("div", { className: "loadingscreen" }, React.createElement(CircularProgressBar_1.default, { fillColor: '#000', bgColor: 'rgba(0, 0, 0, 0.05)', percentage: store.player.progressPercentage, diameter: 40, strokeWidth: 4 }), React.createElement("h3", null, "Loading audio"), React.createElement(SecondaryButton_1.default, { className: "bottomlink", iconName: Icon_1.IconName.x, text: "Cancel", callback: this.handleEndClick }));
	    };
	
	    Module.prototype.renderPlaying = function renderPlaying() {
	        var store = this.injected.store;
	
	        return React.createElement("div", { className: "playingscreen" }, React.createElement(CardStack_1.default, { images: this.images }));
	    };
	
	    Module.prototype.renderCompleted = function renderCompleted() {
	        var store = this.injected.store;
	
	        return React.createElement("div", { className: "page" }, React.createElement(Header_1.default, { bwlogo: true }), React.createElement("div", { className: "endedscreen" }, React.createElement("div", { className: "module__icon--" + (store.script.data && store.script.data.shortname) + " playing__icon" }), React.createElement("div", { className: "endedscreen__top" }, React.createElement("h1", { className: "small_title" }, "We hope you had a great conversation."), React.createElement("p", { className: "normal_paragraph" }, "Thank you for trying ", React.createElement("em", null, "Supportive"), "."), React.createElement(PrimaryButton_1.default, { className: "endlink", text: "Return Home", to: "/" })), React.createElement(SecondaryButton_1.default, { className: "endedreplay", iconName: Icon_1.IconName.replay, text: "Restart", callback: this.handleReplayClick })), React.createElement(MailingListModal_1.default, { type: "white" }));
	    };
	
	    _createClass(Module, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return Module;
	}(React.Component);
	Module = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], Module);
	exports.default = Module;

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var ReactTooltip = __webpack_require__(35);
	var MailingListModal_1 = __webpack_require__(15);
	var Icon_1 = __webpack_require__(23);
	__webpack_require__(326);
	var PrimaryButton_1 = __webpack_require__(16);
	var player_1 = __webpack_require__(17);
	var keyword = '---';
	var markHighlights = function markHighlights(text) {
	    var parts = text.split(new RegExp("(" + keyword + ")", 'gi'));
	    var output = [];
	    for (var i = 0; i < parts.length; i++) {
	        if (parts[i].toLowerCase() === keyword.toLowerCase()) {
	            output.push(React.createElement("mark", { key: i }, parts[i + 1]));
	            i += 2;
	        } else {
	            output.push(parts[i]);
	        }
	    }
	    return output;
	};
	var ModuleIntro = function (_React$Component) {
	    _inherits(ModuleIntro, _React$Component);
	
	    function ModuleIntro() {
	        _classCallCheck(this, ModuleIntro);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.startHandler = function () {
	            var store = _this.injected.store;
	
	            store.player.setPlayerState(player_1.PlayerState.loading);
	            window.scrollTo(0, 0);
	        };
	        return _this;
	    }
	
	    ModuleIntro.prototype.render = function render() {
	        var script = this.props.script;
	        var store = this.injected.store;
	
	        var data = store.script.data;
	        return React.createElement("div", { className: "intro" }, React.createElement(ReactTooltip, { className: "tooltip", place: "bottom", "aria-haspopup": "true" }), React.createElement("header", { className: "intro__header" }, React.createElement("div", { className: "module__icon--" + script.shortname + " intro__icon" }), React.createElement("h1", { className: "small_title intro__title" }, script.details.title), React.createElement("p", { className: "normal_paragraph" }, script.details.textIntro), React.createElement("p", { className: "normal_paragraph" }, markHighlights(script.details.textSell))), React.createElement("section", { className: "intro__actions" }, React.createElement(PrimaryButton_1.default, { text: script.details.textStart, callback: this.startHandler }), React.createElement("ul", { className: "intro__info" }, React.createElement("li", null, React.createElement("img", { src: __webpack_require__(376), alt: "" }), React.createElement("span", null, data && data.totalLength, " minutes")), React.createElement("li", null, React.createElement("img", { src: __webpack_require__(365), alt: "" }), React.createElement("span", null, data && data.cardCount, " cards")), React.createElement("li", null, React.createElement("img", { src: __webpack_require__(374), alt: "" }), React.createElement("span", null, "2 people"))), React.createElement("div", { className: "intro__preview__indicator" }, "Preview", React.createElement(Icon_1.default, { className: "intro__preview__indicator__chevron", name: Icon_1.IconName.downChevron }))), React.createElement("section", { className: "intro__preview" }, React.createElement("ul", { className: "intro__preview__list" }, script.sequence.map(function (sequenceItem, i) {
	            if (sequenceItem.partner) {
	                return null;
	            }
	            var text = React.createElement(React.Fragment, null, sequenceItem.icon);
	            switch (sequenceItem.icon) {
	                case 'intro':
	                    text = React.createElement(React.Fragment, null, "Intro");
	                    break;
	                case 'meditation':
	                    text = React.createElement(React.Fragment, null, "Meditation");
	                    break;
	                case 'quote':
	                    text = React.createElement("span", { className: "intro__preview__item__quote" }, "\u201C", sequenceItem.title, "\u201D", ' ', React.createElement("cite", null, "\u2014 ", sequenceItem.source));
	                    break;
	                case 'silence':
	                    text = React.createElement(React.Fragment, null, "About silences");
	                    break;
	                case 'setup':
	                    text = React.createElement(React.Fragment, null, "Setup");
	                    break;
	                case 'question':
	                    text = React.createElement("span", null, sequenceItem.title);
	                    break;
	                case 'ending':
	                    text = React.createElement(React.Fragment, null, "Ending");
	                    break;
	                case 'mailinglist':
	                    text = React.createElement(React.Fragment, null, "One last thing...");
	                    break;
	            }
	            return React.createElement("li", { key: i, className: "intro__preview__item intro__preview__item--" + sequenceItem.icon }, text);
	        }))), React.createElement("section", { className: "module__mailinglist" }, React.createElement(MailingListModal_1.default, null)));
	    };
	
	    _createClass(ModuleIntro, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return ModuleIntro;
	}(React.Component);
	ModuleIntro = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], ModuleIntro);
	exports.default = ModuleIntro;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var howler_1 = __webpack_require__(307);
	var mobx_1 = __webpack_require__(10);
	var mobx_react_1 = __webpack_require__(7);
	var React = __webpack_require__(1);
	var ga_1 = __webpack_require__(46);
	var player_1 = __webpack_require__(17);
	var script_1 = __webpack_require__(47);
	var Timer_1 = __webpack_require__(158);
	// tslint:disable-next-line:no-var-requires
	var NoSleep = __webpack_require__(157);
	var Player = function (_React$Component) {
	    _inherits(Player, _React$Component);
	
	    function Player() {
	        _classCallCheck(this, Player);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.nosleep = new NoSleep();
	        _this.timerOnEndHandler = function () {
	            var store = _this.injected.store;
	
	            store.completeEvent();
	        };
	        _this.updateProgressPercentage = function () {
	            var store = _this.injected.store;
	
	            store.player.updateProgressPercentage(_this.timer.getPercentageComplete());
	        };
	        _this.clearAllPlayData = function () {
	            // Destroy all state (don't expect to retrieve it)
	            if (_this.timer) {
	                _this.timer.stop();
	                delete _this.timer;
	            }
	            if (_this.curHowl) {
	                _this.curHowl.stop();
	                delete _this.curHowl;
	            }
	            if (_this.progressInterval) {
	                window.clearInterval(_this.progressInterval);
	                delete _this.progressInterval;
	            }
	        };
	        _this.playerStateChangeHandler = function (newState) {
	            if (!_this.timer) {
	                return;
	            }
	            var store = _this.injected.store;
	
	            if (newState === player_1.PlayerState.inactive) {
	                if (_this.curHowl) {
	                    _this.curHowl.stop();
	                    delete _this.curHowl;
	                }
	                if (_this.timer) {
	                    _this.timer.stop();
	                    delete _this.timer;
	                }
	                // End interval to update timer
	                window.clearInterval(_this.progressInterval);
	                delete _this.progressInterval;
	            }
	            // -------------------------------------------------------------------------
	            // PlayerState.Ended
	            // -------------------------------------------------------------------------
	            if (newState === player_1.PlayerState.ended) {
	                _this.clearAllPlayData();
	                if (store.visibleCards.length) {
	                    _this.playCard();
	                }
	                return;
	            }
	            // -------------------------------------------------------------------------
	            // PlayerState.playing
	            // -------------------------------------------------------------------------
	            if (newState === player_1.PlayerState.playing) {
	                if (_this.timer && !_this.timer.isPlaying) {
	                    _this.timer.play();
	                }
	                if (_this.curHowl && !_this.curHowl.playing()) {
	                    _this.curHowl.play();
	                }
	                // Start interval to update timer
	                window.clearInterval(_this.progressInterval);
	                _this.updateProgressPercentage();
	                _this.progressInterval = window.setInterval(_this.updateProgressPercentage, 1000);
	                try {
	                    if (window && window.drift && typeof window.drift !== 'undefined') {
	                        window.drift.api.widget.hide();
	                        return;
	                    }
	                } catch (e) {
	                    console.error(e);
	                }
	                return;
	            }
	            // -------------------------------------------------------------------------
	            // PlayerState.paused
	            // -------------------------------------------------------------------------
	            if (newState === player_1.PlayerState.paused) {
	                if (_this.timer && _this.timer.isPlaying) {
	                    _this.timer.pause();
	                }
	                // Pause playback if it exists
	                if (_this.curHowl && _this.curHowl.playing()) {
	                    _this.curHowl.pause();
	                }
	                // End interval to update timer
	                window.clearInterval(_this.progressInterval);
	                delete _this.progressInterval;
	                return;
	            }
	            // -------------------------------------------------------------------------
	            // PlayerState.completed
	            // -------------------------------------------------------------------------
	            if (newState === player_1.PlayerState.completed) {
	                try {
	                    if (window && window.drift && typeof window.drift !== 'undefined') {
	                        window.drift.api.widget.show();
	                        return;
	                    }
	                } catch (e) {
	                    console.error(e);
	                }
	            }
	        };
	        return _this;
	    }
	
	    Player.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        var store = this.injected.store;
	        // Add a reaction to observe changes to player state
	
	        this.disposer = mobx_1.reaction(function () {
	            return _this2.injected.store.player.state;
	        }, this.playerStateChangeHandler);
	        this.loadPlayer();
	        if (this.nosleep) {
	            this.nosleep.enable();
	        }
	        // Log start
	        if (store.script.data) {
	            ga_1.GASendEvent('module', 'started', store.script.data.shortname);
	        }
	    };
	
	    Player.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.clearAllPlayData();
	        if (this.nosleep) {
	            this.nosleep.disable();
	        }
	        try {
	            if (window && window.drift && typeof window.drift !== 'undefined') {
	                window.drift.api.widget.show();
	                return;
	            }
	        } catch (e) {
	            //
	        }
	    };
	
	    Player.prototype.render = function render() {
	        return React.createElement("div", { className: "player" });
	    };
	
	    Player.prototype.loadPlayer = function loadPlayer() {
	        var store = this.injected.store;
	        // Ensure our script is loaded
	
	        if (store.script.state === script_1.ScriptState.loading || !store.script) {
	            store.throwTopLevelError("Player tried to load, but the script for this module hasn't loaded (" + store.script.state + ").");
	            return;
	        }
	        this.loadAudioFiles();
	    };
	
	    Player.prototype.loadAudioFiles = function loadAudioFiles() {
	        var _this3 = this;
	
	        var data = this.props.data;
	        var store = this.injected.store;
	        // Reset howls
	
	        this.howls = new Map();
	        this.allFiles = data.allFile.edges.map(function (edge) {
	            return edge.node;
	        });
	        var scriptData = store.script.data;
	        if (!scriptData) {
	            store.throwTopLevelError("Player tried to load audio, but script data is null.");
	            return;
	        }
	        // Load all required howls
	        scriptData.sequence.map(function (sequenceItem) {
	            var audioEvents = sequenceItem.events.filter(function (event) {
	                return event.type === 'audio';
	            });
	            audioEvents.map(function (event) {
	                _this3.loadWrappedHowl(event.fileName);
	            });
	        });
	    };
	
	    Player.prototype.loadWrappedHowl = function loadWrappedHowl(fileName) {
	        var store = this.injected.store;
	        // Avoid duplicates of audio files
	
	        if (this.howls.get(fileName)) {
	            return;
	        }
	        // Find all files with our given audio filename
	        var audioFiles = this.allFiles.filter(function (file) {
	            return file.name === fileName;
	        });
	        var mp3FileURL = '';
	        var webmFileURL = '';
	        audioFiles.map(function (file) {
	            var ext = file.publicURL.substr(file.publicURL.lastIndexOf('.') + 1);
	            if (ext === 'mp3') {
	                mp3FileURL = file.publicURL;
	            } else if (ext === 'webm') {
	                webmFileURL = file.publicURL;
	            }
	        });
	        // Ensure our audio files exist
	        if (!mp3FileURL || !webmFileURL) {
	            store.throwTopLevelError("Player tried to load audio, but failed to find correct audio files. Expected mp3: " + mp3FileURL + "; webm: " + webmFileURL);
	            return;
	        }
	        var wrappedHowl = {
	            howl: new howler_1.Howl({
	                html5: true,
	                onload: this.onHowlLoaded.bind(this, fileName),
	                src: [webmFileURL, mp3FileURL]
	            }),
	            loaded: false
	        };
	        this.howls.set(fileName, wrappedHowl);
	    };
	
	    Player.prototype.onHowlLoaded = function onHowlLoaded(fileName) {
	        var _this4 = this;
	
	        var store = this.injected.store;
	
	        var howl = this.howls.get(fileName);
	        if (!howl) {
	            store.throwTopLevelError("Player failed to find \"" + fileName + "\" in howl map: " + this.howls, function () {
	                return new Promise(function (resolve, reject) {
	                    _this4.loadAudioFiles(); // Try to reload the audio
	                    resolve();
	                });
	            });
	            return;
	        }
	        // Mark howl as loaded
	        howl.loaded = true;
	        // Check # of loaded cards
	        var unloadedCount = 0;
	        this.howls.forEach(function (wrappedHowl) {
	            if (!wrappedHowl.loaded) {
	                unloadedCount++;
	            }
	        });
	        var percentageLoaded = Math.round((this.howls.size - unloadedCount) / this.howls.size * 100);
	        store.player.updateProgressPercentage(percentageLoaded);
	        if (!unloadedCount) {
	            this.onAllHowlsLoaded();
	            return;
	        }
	    };
	
	    Player.prototype.onAllHowlsLoaded = function onAllHowlsLoaded() {
	        var store = this.injected.store;
	
	        if (store.player.state === player_1.PlayerState.loading) {
	            store.player.updateProgressPercentage(0);
	            store.player.setPlayerState(player_1.PlayerState.loaded);
	            this.playCard();
	        }
	    };
	
	    Player.prototype.playCard = function playCard() {
	        var store = this.injected.store;
	
	        if (!store.activeCard || !store.activeEvent) {
	            store.throwTopLevelError("Called playCard(), but store.activeCard or store.activeEvent is null");
	            return;
	        }
	        this.playEvent(store.activeEvent);
	    };
	
	    Player.prototype.playEvent = function playEvent(event) {
	        var store = this.injected.store;
	        // Force stop any existing howl
	
	        if (this.curHowl) {
	            this.curHowl.stop();
	            delete this.curHowl;
	        }
	        var wrappedHowl = this.howls.get(event.fileName);
	        if (!wrappedHowl) {
	            store.throwTopLevelError("Attempted to play event \"" + event + "\", but could not get wrappedHowl from howls.");
	            return;
	        }
	        this.curHowl = wrappedHowl.howl;
	        this.addHowlEventListeners(this.curHowl);
	        var extraTime = event.extraTime;
	        var duration = (this.curHowl.duration() + extraTime) * 1000; // s -> ms
	        this.timer = new Timer_1.default(duration, undefined, undefined, this.timerOnEndHandler);
	        // store.player.setPlayerState(PlayerState.playing);
	        this.curHowl.play();
	    };
	
	    Player.prototype.addHowlEventListeners = function addHowlEventListeners(howl) {
	        howl.on('play', this.howlOnPlayHandler.bind(this, howl));
	        howl.on('end', this.howlOnEndHandler.bind(this, howl));
	    };
	
	    Player.prototype.howlOnPlayHandler = function howlOnPlayHandler(howl) {
	        var store = this.injected.store;
	        // Special case for initial play: timer starts when the player starts
	        // to avoid lag
	
	        if (this.timer && !this.timer.isPlaying) {
	            this.timer.play();
	            store.player.setPlayerState(player_1.PlayerState.playing);
	        }
	    };
	
	    Player.prototype.howlOnEndHandler = function howlOnEndHandler(howl) {
	        delete this.curHowl;
	    };
	
	    _createClass(Player, [{
	        key: "injected",
	        get: function get() {
	            return this.props;
	        }
	    }]);
	
	    return Player;
	}(React.Component);
	Player = __decorate([mobx_react_1.inject('store'), mobx_react_1.observer], Player);
	exports.default = Player;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.COLORS = ['#F44336', '#E91E63', '#673AB7', '#2196F3', '#8BC34A', '#FFC107', '#FF9800', '#FF5722'];
	exports.CARD_MOVEMENT_DISTANCE = 200;
	exports.CARD_ROTATION_AMOUNT = 15;
	// export const SCRIPT_PATH = 'script.json';
	// Percentage Circle
	exports.MIN_PERCENTAGE = 0;
	exports.MAX_PERCENTAGE = 100;
	// Mailchimp
	exports.mailchimpURL = 'https://wearesupportive.us18.list-manage.com/subscribe/post?u=40067302b02edea4063b16716&amp;id=7e19c9a7b6';

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4wODE2IDMuNTMzOTFDMTAuMDgxNiA1LjIwOTk4IDguODgzNTQgNi42MTk1NSA3LjI4OTczIDYuOTc5MDhDMTAuNTEyNCA3LjM2NzY0IDEzIDEwLjA3NDEgMTMgMTMuMzM0OUMxMyAxMy43MDM2IDEyLjY5NTYgMTQgMTIuMzI1OCAxNEgwLjY3NDIzMUMwLjI3NjEyMyAxNCAwIDEzLjY5NDUgMCAxMy4zMzQ5QzAgMTAuMDc1IDIuNDY5NzkgNy4zNjgxOCA1LjY5MDk1IDYuOTc5MThDNC4wOTcyNyA2LjYxOTk2IDIuODk4NCA1LjIxMDkgMi44OTg0IDMuNTMzOTFDMi44OTg0IDEuNTY2NTIgNC41MTU2NyAwIDYuNDkwMDYgMEM4LjQ2NDQ2IDAgMTAuMDgxNiAxLjU4NjI4IDEwLjA4MTYgMy41MzM5MVpNOC43MzM0MSAzLjUzMzkxQzguNzMzNDEgNC43NDQ3MiA3LjcyNjA2IDUuNzM3NTQgNi40OTAyIDUuNzM3NTRDNS4yNTM2NSA1LjczNzU0IDQuMjQ3MTMgNC43NDQgNC4yNDcxMyAzLjUzMzkxQzQuMjQ3MTMgMi4zMjMwOSA1LjI1NDQ4IDEuMzMwMjQgNi40OTAyIDEuMzMwMjRDNy43MjY3NSAxLjMzMDI0IDguNzMzNDEgMi4zMjMxMiA4LjczMzQxIDMuNTMzOTFaTTYuNDkwMDYgOC4yODExMkM5LjA5ODI2IDguMjgxMTIgMTEuMjc0IDEwLjIwNjggMTEuNjAxOSAxMi42ODk0SDEuMzc4MTNDMS43MDYgMTAuMjA3NyAzLjg4MjAxIDguMjgxMTIgNi40OTAwNiA4LjI4MTEyWiIgZmlsbD0iIzlFQTZBNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_state_tree_1 = __webpack_require__(21);
	var constants_1 = __webpack_require__(36);
	var PlayerState;
	(function (PlayerState) {
	    PlayerState["inactive"] = "inactive";
	    PlayerState["loading"] = "loading";
	    PlayerState["loaded"] = "loaded";
	    PlayerState["playing"] = "playing";
	    PlayerState["paused"] = "paused";
	    PlayerState["ended"] = "ended";
	    PlayerState["completed"] = "completed";
	})(PlayerState = exports.PlayerState || (exports.PlayerState = {}));
	exports.PlayerStore = mobx_state_tree_1.types.model('PlayerStore', {
	    cardIndex: 0,
	    eventIndex: 0,
	    playerOneColor: '#000',
	    playerTwoColor: '#000',
	    progressPercentage: 0,
	    state: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.enumeration('PlayerState', Object.keys(PlayerState)), PlayerState.inactive)
	}).actions(function (self) {
	    var actions = {
	        reset: function reset() {
	            self.state = PlayerState.inactive;
	            self.cardIndex = 0;
	            self.eventIndex = 0;
	            self.progressPercentage = 0;
	            self.playerOneColor = '#000';
	            self.playerTwoColor = '#000';
	        },
	        setPlayerState: function setPlayerState(newState) {
	            self.state = newState;
	        },
	        setCardIndex: function setCardIndex(index) {
	            self.cardIndex = index;
	        },
	        setEventIndex: function setEventIndex(index) {
	            self.eventIndex = index;
	        },
	        updateProgressPercentage: function updateProgressPercentage(percentage) {
	            percentage = Math.max(0, percentage);
	            percentage = Math.min(100, percentage);
	            self.progressPercentage = percentage;
	        },
	        loadRandomPlayerColors: function loadRandomPlayerColors() {
	            var color = constants_1.COLORS[Math.floor(Math.random() * constants_1.COLORS.length)];
	            var color2 = constants_1.COLORS[Math.floor(Math.random() * constants_1.COLORS.length)];
	            while (color2 === color) {
	                color2 = constants_1.COLORS[Math.floor(Math.random() * constants_1.COLORS.length)];
	            }
	            self.playerOneColor = color;
	            self.playerTwoColor = color2;
	        }
	    };
	    return actions;
	});

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_state_tree_1 = __webpack_require__(21);
	exports.SequenceEvent = mobx_state_tree_1.types.model('SequenceAudioEvent', {
	    extraTime: 0,
	    fileName: mobx_state_tree_1.types.string,
	    length: mobx_state_tree_1.types.number,
	    type: mobx_state_tree_1.types.literal('audio')
	});
	var SequenceIcon;
	(function (SequenceIcon) {
	    SequenceIcon["intro"] = "intro";
	    SequenceIcon["meditation"] = "meditation";
	    SequenceIcon["quote"] = "quote";
	    SequenceIcon["silence"] = "silence";
	    SequenceIcon["setup"] = "setup";
	    SequenceIcon["question"] = "question";
	    SequenceIcon["ending"] = "ending";
	    SequenceIcon["mailinglist"] = "mailinglist";
	    SequenceIcon["partner"] = "partner";
	})(SequenceIcon = exports.SequenceIcon || (exports.SequenceIcon = {}));
	exports.SequenceItem = mobx_state_tree_1.types.model('SequenceItem', {
	    events: mobx_state_tree_1.types.array(exports.SequenceEvent),
	    icon: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.enumeration('Icon', Object.keys(SequenceIcon))),
	    image: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
	    partner: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.union(mobx_state_tree_1.types.literal('one'), mobx_state_tree_1.types.literal('two'))),
	    source: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
	    title: mobx_state_tree_1.types.string
	}).views(function (self) {
	    return {
	        get totalLength() {
	            return self.events.reduce(function (sum, event) {
	                return sum + event.length;
	            }, 0);
	        }
	    };
	});
	exports.ModuleDetails = mobx_state_tree_1.types.model('ModuleDetails', {
	    textIntro: mobx_state_tree_1.types.string,
	    textSell: mobx_state_tree_1.types.string,
	    textStart: mobx_state_tree_1.types.string,
	    title: mobx_state_tree_1.types.string
	});
	exports.Script = mobx_state_tree_1.types.model('Module', {
	    details: exports.ModuleDetails,
	    sequence: mobx_state_tree_1.types.array(exports.SequenceItem),
	    shortname: mobx_state_tree_1.types.string
	}).views(function (self) {
	    return {
	        get totalLength() {
	            var total = self.sequence.reduce(function (sum, item) {
	                return sum + item.totalLength;
	            }, 0);
	            return Math.floor(total);
	        },
	        get cardCount() {
	            var filteredCards = self.sequence.filter(function (item) {
	                return !item.partner;
	            });
	            return filteredCards.length;
	        }
	    };
	});
	var ScriptState;
	(function (ScriptState) {
	    ScriptState["inactive"] = "inactive";
	    ScriptState["loading"] = "loading";
	    ScriptState["loaded"] = "loaded";
	    ScriptState["error"] = "error";
	})(ScriptState = exports.ScriptState || (exports.ScriptState = {}));
	exports.ScriptStore = mobx_state_tree_1.types.model('ScriptStore', {
	    data: mobx_state_tree_1.types.maybe(exports.Script),
	    state: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.enumeration('ScriptState', Object.keys(ScriptState)), ScriptState.inactive)
	}).actions(function (self) {
	    return {
	        reset: function reset() {
	            self.data = null;
	            self.state = ScriptState.inactive;
	        }
	    };
	});

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(22);
	var Module_1 = __webpack_require__(162);
	
	var Deeper = function (_React$PureComponent) {
	  _inherits(Deeper, _React$PureComponent);
	
	  function Deeper() {
	    _classCallCheck(this, Deeper);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Deeper.prototype.render = function render() {
	    var data = this.props.data;
	
	    return React.createElement("div", { className: "theme--green" }, React.createElement(react_helmet_1.default, { title: "Deeper Talk" }), React.createElement(Module_1.default, { data: data }));
	  };
	
	  return Deeper;
	}(React.PureComponent);
	
	exports.default = Deeper;
	exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-modules-deeper-tsx-af059f550b4a2c3470b8.js